var vf = { exports: {} }, Eu = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Td;
function hh() {
  if (Td) return Eu;
  Td = 1;
  var v = Symbol.for("react.transitional.element"), A = Symbol.for("react.fragment");
  function E(r, O, _) {
    var Y = null;
    if (_ !== void 0 && (Y = "" + _), O.key !== void 0 && (Y = "" + O.key), "key" in O) {
      _ = {};
      for (var N in O)
        N !== "key" && (_[N] = O[N]);
    } else _ = O;
    return O = _.ref, {
      $$typeof: v,
      type: r,
      key: Y,
      ref: O !== void 0 ? O : null,
      props: _
    };
  }
  return Eu.Fragment = A, Eu.jsx = E, Eu.jsxs = E, Eu;
}
var jd;
function yh() {
  return jd || (jd = 1, vf.exports = hh()), vf.exports;
}
var f = yh(), hf = { exports: {} }, L = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Od;
function gh() {
  if (Od) return L;
  Od = 1;
  var v = Symbol.for("react.transitional.element"), A = Symbol.for("react.portal"), E = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), _ = Symbol.for("react.consumer"), Y = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), M = Symbol.for("react.suspense"), S = Symbol.for("react.memo"), Z = Symbol.for("react.lazy"), U = Symbol.for("react.activity"), W = Symbol.iterator;
  function el(d) {
    return d === null || typeof d != "object" ? null : (d = W && d[W] || d["@@iterator"], typeof d == "function" ? d : null);
  }
  var Ol = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, bl = Object.assign, Sl = {};
  function pl(d, j, D) {
    this.props = d, this.context = j, this.refs = Sl, this.updater = D || Ol;
  }
  pl.prototype.isReactComponent = {}, pl.prototype.setState = function(d, j) {
    if (typeof d != "object" && typeof d != "function" && d != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, d, j, "setState");
  }, pl.prototype.forceUpdate = function(d) {
    this.updater.enqueueForceUpdate(this, d, "forceUpdate");
  };
  function vt() {
  }
  vt.prototype = pl.prototype;
  function El(d, j, D) {
    this.props = d, this.context = j, this.refs = Sl, this.updater = D || Ol;
  }
  var Gl = El.prototype = new vt();
  Gl.constructor = El, bl(Gl, pl.prototype), Gl.isPureReactComponent = !0;
  var Ml = Array.isArray;
  function Hl() {
  }
  var Q = { H: null, A: null, T: null, S: null }, yl = Object.prototype.hasOwnProperty;
  function ql(d, j, D) {
    var C = D.ref;
    return {
      $$typeof: v,
      type: d,
      key: j,
      ref: C !== void 0 ? C : null,
      props: D
    };
  }
  function Rt(d, j) {
    return ql(d.type, j, d.props);
  }
  function wl(d) {
    return typeof d == "object" && d !== null && d.$$typeof === v;
  }
  function _l(d) {
    var j = { "=": "=0", ":": "=2" };
    return "$" + d.replace(/[=:]/g, function(D) {
      return j[D];
    });
  }
  var Dt = /\/+/g;
  function $l(d, j) {
    return typeof d == "object" && d !== null && d.key != null ? _l("" + d.key) : j.toString(36);
  }
  function Tt(d) {
    switch (d.status) {
      case "fulfilled":
        return d.value;
      case "rejected":
        throw d.reason;
      default:
        switch (typeof d.status == "string" ? d.then(Hl, Hl) : (d.status = "pending", d.then(
          function(j) {
            d.status === "pending" && (d.status = "fulfilled", d.value = j);
          },
          function(j) {
            d.status === "pending" && (d.status = "rejected", d.reason = j);
          }
        )), d.status) {
          case "fulfilled":
            return d.value;
          case "rejected":
            throw d.reason;
        }
    }
    throw d;
  }
  function x(d, j, D, C, V) {
    var w = typeof d;
    (w === "undefined" || w === "boolean") && (d = null);
    var ul = !1;
    if (d === null) ul = !0;
    else
      switch (w) {
        case "bigint":
        case "string":
        case "number":
          ul = !0;
          break;
        case "object":
          switch (d.$$typeof) {
            case v:
            case A:
              ul = !0;
              break;
            case Z:
              return ul = d._init, x(
                ul(d._payload),
                j,
                D,
                C,
                V
              );
          }
      }
    if (ul)
      return V = V(d), ul = C === "" ? "." + $l(d, 0) : C, Ml(V) ? (D = "", ul != null && (D = ul.replace(Dt, "$&/") + "/"), x(V, j, D, "", function(Ra) {
        return Ra;
      })) : V != null && (wl(V) && (V = Rt(
        V,
        D + (V.key == null || d && d.key === V.key ? "" : ("" + V.key).replace(
          Dt,
          "$&/"
        ) + "/") + ul
      )), j.push(V)), 1;
    ul = 0;
    var kl = C === "" ? "." : C + ":";
    if (Ml(d))
      for (var Al = 0; Al < d.length; Al++)
        C = d[Al], w = kl + $l(C, Al), ul += x(
          C,
          j,
          D,
          w,
          V
        );
    else if (Al = el(d), typeof Al == "function")
      for (d = Al.call(d), Al = 0; !(C = d.next()).done; )
        C = C.value, w = kl + $l(C, Al++), ul += x(
          C,
          j,
          D,
          w,
          V
        );
    else if (w === "object") {
      if (typeof d.then == "function")
        return x(
          Tt(d),
          j,
          D,
          C,
          V
        );
      throw j = String(d), Error(
        "Objects are not valid as a React child (found: " + (j === "[object Object]" ? "object with keys {" + Object.keys(d).join(", ") + "}" : j) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return ul;
  }
  function R(d, j, D) {
    if (d == null) return d;
    var C = [], V = 0;
    return x(d, C, "", "", function(w) {
      return j.call(D, w, V++);
    }), C;
  }
  function X(d) {
    if (d._status === -1) {
      var j = d._result;
      j = j(), j.then(
        function(D) {
          (d._status === 0 || d._status === -1) && (d._status = 1, d._result = D);
        },
        function(D) {
          (d._status === 0 || d._status === -1) && (d._status = 2, d._result = D);
        }
      ), d._status === -1 && (d._status = 0, d._result = j);
    }
    if (d._status === 1) return d._result.default;
    throw d._result;
  }
  var cl = typeof reportError == "function" ? reportError : function(d) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var j = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof d == "object" && d !== null && typeof d.message == "string" ? String(d.message) : String(d),
        error: d
      });
      if (!window.dispatchEvent(j)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", d);
      return;
    }
    console.error(d);
  }, dl = {
    map: R,
    forEach: function(d, j, D) {
      R(
        d,
        function() {
          j.apply(this, arguments);
        },
        D
      );
    },
    count: function(d) {
      var j = 0;
      return R(d, function() {
        j++;
      }), j;
    },
    toArray: function(d) {
      return R(d, function(j) {
        return j;
      }) || [];
    },
    only: function(d) {
      if (!wl(d))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return d;
    }
  };
  return L.Activity = U, L.Children = dl, L.Component = pl, L.Fragment = E, L.Profiler = O, L.PureComponent = El, L.StrictMode = r, L.Suspense = M, L.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Q, L.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(d) {
      return Q.H.useMemoCache(d);
    }
  }, L.cache = function(d) {
    return function() {
      return d.apply(null, arguments);
    };
  }, L.cacheSignal = function() {
    return null;
  }, L.cloneElement = function(d, j, D) {
    if (d == null)
      throw Error(
        "The argument must be a React element, but you passed " + d + "."
      );
    var C = bl({}, d.props), V = d.key;
    if (j != null)
      for (w in j.key !== void 0 && (V = "" + j.key), j)
        !yl.call(j, w) || w === "key" || w === "__self" || w === "__source" || w === "ref" && j.ref === void 0 || (C[w] = j[w]);
    var w = arguments.length - 2;
    if (w === 1) C.children = D;
    else if (1 < w) {
      for (var ul = Array(w), kl = 0; kl < w; kl++)
        ul[kl] = arguments[kl + 2];
      C.children = ul;
    }
    return ql(d.type, V, C);
  }, L.createContext = function(d) {
    return d = {
      $$typeof: Y,
      _currentValue: d,
      _currentValue2: d,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, d.Provider = d, d.Consumer = {
      $$typeof: _,
      _context: d
    }, d;
  }, L.createElement = function(d, j, D) {
    var C, V = {}, w = null;
    if (j != null)
      for (C in j.key !== void 0 && (w = "" + j.key), j)
        yl.call(j, C) && C !== "key" && C !== "__self" && C !== "__source" && (V[C] = j[C]);
    var ul = arguments.length - 2;
    if (ul === 1) V.children = D;
    else if (1 < ul) {
      for (var kl = Array(ul), Al = 0; Al < ul; Al++)
        kl[Al] = arguments[Al + 2];
      V.children = kl;
    }
    if (d && d.defaultProps)
      for (C in ul = d.defaultProps, ul)
        V[C] === void 0 && (V[C] = ul[C]);
    return ql(d, w, V);
  }, L.createRef = function() {
    return { current: null };
  }, L.forwardRef = function(d) {
    return { $$typeof: N, render: d };
  }, L.isValidElement = wl, L.lazy = function(d) {
    return {
      $$typeof: Z,
      _payload: { _status: -1, _result: d },
      _init: X
    };
  }, L.memo = function(d, j) {
    return {
      $$typeof: S,
      type: d,
      compare: j === void 0 ? null : j
    };
  }, L.startTransition = function(d) {
    var j = Q.T, D = {};
    Q.T = D;
    try {
      var C = d(), V = Q.S;
      V !== null && V(D, C), typeof C == "object" && C !== null && typeof C.then == "function" && C.then(Hl, cl);
    } catch (w) {
      cl(w);
    } finally {
      j !== null && D.types !== null && (j.types = D.types), Q.T = j;
    }
  }, L.unstable_useCacheRefresh = function() {
    return Q.H.useCacheRefresh();
  }, L.use = function(d) {
    return Q.H.use(d);
  }, L.useActionState = function(d, j, D) {
    return Q.H.useActionState(d, j, D);
  }, L.useCallback = function(d, j) {
    return Q.H.useCallback(d, j);
  }, L.useContext = function(d) {
    return Q.H.useContext(d);
  }, L.useDebugValue = function() {
  }, L.useDeferredValue = function(d, j) {
    return Q.H.useDeferredValue(d, j);
  }, L.useEffect = function(d, j) {
    return Q.H.useEffect(d, j);
  }, L.useEffectEvent = function(d) {
    return Q.H.useEffectEvent(d);
  }, L.useId = function() {
    return Q.H.useId();
  }, L.useImperativeHandle = function(d, j, D) {
    return Q.H.useImperativeHandle(d, j, D);
  }, L.useInsertionEffect = function(d, j) {
    return Q.H.useInsertionEffect(d, j);
  }, L.useLayoutEffect = function(d, j) {
    return Q.H.useLayoutEffect(d, j);
  }, L.useMemo = function(d, j) {
    return Q.H.useMemo(d, j);
  }, L.useOptimistic = function(d, j) {
    return Q.H.useOptimistic(d, j);
  }, L.useReducer = function(d, j, D) {
    return Q.H.useReducer(d, j, D);
  }, L.useRef = function(d) {
    return Q.H.useRef(d);
  }, L.useState = function(d) {
    return Q.H.useState(d);
  }, L.useSyncExternalStore = function(d, j, D) {
    return Q.H.useSyncExternalStore(
      d,
      j,
      D
    );
  }, L.useTransition = function() {
    return Q.H.useTransition();
  }, L.version = "19.2.3", L;
}
var Md;
function xf() {
  return Md || (Md = 1, hf.exports = gh()), hf.exports;
}
var rl = xf(), yf = { exports: {} }, Au = {}, gf = { exports: {} }, pf = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _d;
function ph() {
  return _d || (_d = 1, (function(v) {
    function A(x, R) {
      var X = x.length;
      x.push(R);
      l: for (; 0 < X; ) {
        var cl = X - 1 >>> 1, dl = x[cl];
        if (0 < O(dl, R))
          x[cl] = R, x[X] = dl, X = cl;
        else break l;
      }
    }
    function E(x) {
      return x.length === 0 ? null : x[0];
    }
    function r(x) {
      if (x.length === 0) return null;
      var R = x[0], X = x.pop();
      if (X !== R) {
        x[0] = X;
        l: for (var cl = 0, dl = x.length, d = dl >>> 1; cl < d; ) {
          var j = 2 * (cl + 1) - 1, D = x[j], C = j + 1, V = x[C];
          if (0 > O(D, X))
            C < dl && 0 > O(V, D) ? (x[cl] = V, x[C] = X, cl = C) : (x[cl] = D, x[j] = X, cl = j);
          else if (C < dl && 0 > O(V, X))
            x[cl] = V, x[C] = X, cl = C;
          else break l;
        }
      }
      return R;
    }
    function O(x, R) {
      var X = x.sortIndex - R.sortIndex;
      return X !== 0 ? X : x.id - R.id;
    }
    if (v.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var _ = performance;
      v.unstable_now = function() {
        return _.now();
      };
    } else {
      var Y = Date, N = Y.now();
      v.unstable_now = function() {
        return Y.now() - N;
      };
    }
    var M = [], S = [], Z = 1, U = null, W = 3, el = !1, Ol = !1, bl = !1, Sl = !1, pl = typeof setTimeout == "function" ? setTimeout : null, vt = typeof clearTimeout == "function" ? clearTimeout : null, El = typeof setImmediate < "u" ? setImmediate : null;
    function Gl(x) {
      for (var R = E(S); R !== null; ) {
        if (R.callback === null) r(S);
        else if (R.startTime <= x)
          r(S), R.sortIndex = R.expirationTime, A(M, R);
        else break;
        R = E(S);
      }
    }
    function Ml(x) {
      if (bl = !1, Gl(x), !Ol)
        if (E(M) !== null)
          Ol = !0, Hl || (Hl = !0, _l());
        else {
          var R = E(S);
          R !== null && Tt(Ml, R.startTime - x);
        }
    }
    var Hl = !1, Q = -1, yl = 5, ql = -1;
    function Rt() {
      return Sl ? !0 : !(v.unstable_now() - ql < yl);
    }
    function wl() {
      if (Sl = !1, Hl) {
        var x = v.unstable_now();
        ql = x;
        var R = !0;
        try {
          l: {
            Ol = !1, bl && (bl = !1, vt(Q), Q = -1), el = !0;
            var X = W;
            try {
              t: {
                for (Gl(x), U = E(M); U !== null && !(U.expirationTime > x && Rt()); ) {
                  var cl = U.callback;
                  if (typeof cl == "function") {
                    U.callback = null, W = U.priorityLevel;
                    var dl = cl(
                      U.expirationTime <= x
                    );
                    if (x = v.unstable_now(), typeof dl == "function") {
                      U.callback = dl, Gl(x), R = !0;
                      break t;
                    }
                    U === E(M) && r(M), Gl(x);
                  } else r(M);
                  U = E(M);
                }
                if (U !== null) R = !0;
                else {
                  var d = E(S);
                  d !== null && Tt(
                    Ml,
                    d.startTime - x
                  ), R = !1;
                }
              }
              break l;
            } finally {
              U = null, W = X, el = !1;
            }
            R = void 0;
          }
        } finally {
          R ? _l() : Hl = !1;
        }
      }
    }
    var _l;
    if (typeof El == "function")
      _l = function() {
        El(wl);
      };
    else if (typeof MessageChannel < "u") {
      var Dt = new MessageChannel(), $l = Dt.port2;
      Dt.port1.onmessage = wl, _l = function() {
        $l.postMessage(null);
      };
    } else
      _l = function() {
        pl(wl, 0);
      };
    function Tt(x, R) {
      Q = pl(function() {
        x(v.unstable_now());
      }, R);
    }
    v.unstable_IdlePriority = 5, v.unstable_ImmediatePriority = 1, v.unstable_LowPriority = 4, v.unstable_NormalPriority = 3, v.unstable_Profiling = null, v.unstable_UserBlockingPriority = 2, v.unstable_cancelCallback = function(x) {
      x.callback = null;
    }, v.unstable_forceFrameRate = function(x) {
      0 > x || 125 < x ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : yl = 0 < x ? Math.floor(1e3 / x) : 5;
    }, v.unstable_getCurrentPriorityLevel = function() {
      return W;
    }, v.unstable_next = function(x) {
      switch (W) {
        case 1:
        case 2:
        case 3:
          var R = 3;
          break;
        default:
          R = W;
      }
      var X = W;
      W = R;
      try {
        return x();
      } finally {
        W = X;
      }
    }, v.unstable_requestPaint = function() {
      Sl = !0;
    }, v.unstable_runWithPriority = function(x, R) {
      switch (x) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          x = 3;
      }
      var X = W;
      W = x;
      try {
        return R();
      } finally {
        W = X;
      }
    }, v.unstable_scheduleCallback = function(x, R, X) {
      var cl = v.unstable_now();
      switch (typeof X == "object" && X !== null ? (X = X.delay, X = typeof X == "number" && 0 < X ? cl + X : cl) : X = cl, x) {
        case 1:
          var dl = -1;
          break;
        case 2:
          dl = 250;
          break;
        case 5:
          dl = 1073741823;
          break;
        case 4:
          dl = 1e4;
          break;
        default:
          dl = 5e3;
      }
      return dl = X + dl, x = {
        id: Z++,
        callback: R,
        priorityLevel: x,
        startTime: X,
        expirationTime: dl,
        sortIndex: -1
      }, X > cl ? (x.sortIndex = X, A(S, x), E(M) === null && x === E(S) && (bl ? (vt(Q), Q = -1) : bl = !0, Tt(Ml, X - cl))) : (x.sortIndex = dl, A(M, x), Ol || el || (Ol = !0, Hl || (Hl = !0, _l()))), x;
    }, v.unstable_shouldYield = Rt, v.unstable_wrapCallback = function(x) {
      var R = W;
      return function() {
        var X = W;
        W = R;
        try {
          return x.apply(this, arguments);
        } finally {
          W = X;
        }
      };
    };
  })(pf)), pf;
}
var Rd;
function bh() {
  return Rd || (Rd = 1, gf.exports = ph()), gf.exports;
}
var bf = { exports: {} }, Jl = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dd;
function Sh() {
  if (Dd) return Jl;
  Dd = 1;
  var v = xf();
  function A(M) {
    var S = "https://react.dev/errors/" + M;
    if (1 < arguments.length) {
      S += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var Z = 2; Z < arguments.length; Z++)
        S += "&args[]=" + encodeURIComponent(arguments[Z]);
    }
    return "Minified React error #" + M + "; visit " + S + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function E() {
  }
  var r = {
    d: {
      f: E,
      r: function() {
        throw Error(A(522));
      },
      D: E,
      C: E,
      L: E,
      m: E,
      X: E,
      S: E,
      M: E
    },
    p: 0,
    findDOMNode: null
  }, O = Symbol.for("react.portal");
  function _(M, S, Z) {
    var U = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: O,
      key: U == null ? null : "" + U,
      children: M,
      containerInfo: S,
      implementation: Z
    };
  }
  var Y = v.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function N(M, S) {
    if (M === "font") return "";
    if (typeof S == "string")
      return S === "use-credentials" ? S : "";
  }
  return Jl.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r, Jl.createPortal = function(M, S) {
    var Z = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!S || S.nodeType !== 1 && S.nodeType !== 9 && S.nodeType !== 11)
      throw Error(A(299));
    return _(M, S, null, Z);
  }, Jl.flushSync = function(M) {
    var S = Y.T, Z = r.p;
    try {
      if (Y.T = null, r.p = 2, M) return M();
    } finally {
      Y.T = S, r.p = Z, r.d.f();
    }
  }, Jl.preconnect = function(M, S) {
    typeof M == "string" && (S ? (S = S.crossOrigin, S = typeof S == "string" ? S === "use-credentials" ? S : "" : void 0) : S = null, r.d.C(M, S));
  }, Jl.prefetchDNS = function(M) {
    typeof M == "string" && r.d.D(M);
  }, Jl.preinit = function(M, S) {
    if (typeof M == "string" && S && typeof S.as == "string") {
      var Z = S.as, U = N(Z, S.crossOrigin), W = typeof S.integrity == "string" ? S.integrity : void 0, el = typeof S.fetchPriority == "string" ? S.fetchPriority : void 0;
      Z === "style" ? r.d.S(
        M,
        typeof S.precedence == "string" ? S.precedence : void 0,
        {
          crossOrigin: U,
          integrity: W,
          fetchPriority: el
        }
      ) : Z === "script" && r.d.X(M, {
        crossOrigin: U,
        integrity: W,
        fetchPriority: el,
        nonce: typeof S.nonce == "string" ? S.nonce : void 0
      });
    }
  }, Jl.preinitModule = function(M, S) {
    if (typeof M == "string")
      if (typeof S == "object" && S !== null) {
        if (S.as == null || S.as === "script") {
          var Z = N(
            S.as,
            S.crossOrigin
          );
          r.d.M(M, {
            crossOrigin: Z,
            integrity: typeof S.integrity == "string" ? S.integrity : void 0,
            nonce: typeof S.nonce == "string" ? S.nonce : void 0
          });
        }
      } else S == null && r.d.M(M);
  }, Jl.preload = function(M, S) {
    if (typeof M == "string" && typeof S == "object" && S !== null && typeof S.as == "string") {
      var Z = S.as, U = N(Z, S.crossOrigin);
      r.d.L(M, Z, {
        crossOrigin: U,
        integrity: typeof S.integrity == "string" ? S.integrity : void 0,
        nonce: typeof S.nonce == "string" ? S.nonce : void 0,
        type: typeof S.type == "string" ? S.type : void 0,
        fetchPriority: typeof S.fetchPriority == "string" ? S.fetchPriority : void 0,
        referrerPolicy: typeof S.referrerPolicy == "string" ? S.referrerPolicy : void 0,
        imageSrcSet: typeof S.imageSrcSet == "string" ? S.imageSrcSet : void 0,
        imageSizes: typeof S.imageSizes == "string" ? S.imageSizes : void 0,
        media: typeof S.media == "string" ? S.media : void 0
      });
    }
  }, Jl.preloadModule = function(M, S) {
    if (typeof M == "string")
      if (S) {
        var Z = N(S.as, S.crossOrigin);
        r.d.m(M, {
          as: typeof S.as == "string" && S.as !== "script" ? S.as : void 0,
          crossOrigin: Z,
          integrity: typeof S.integrity == "string" ? S.integrity : void 0
        });
      } else r.d.m(M);
  }, Jl.requestFormReset = function(M) {
    r.d.r(M);
  }, Jl.unstable_batchedUpdates = function(M, S) {
    return M(S);
  }, Jl.useFormState = function(M, S, Z) {
    return Y.H.useFormState(M, S, Z);
  }, Jl.useFormStatus = function() {
    return Y.H.useHostTransitionStatus();
  }, Jl.version = "19.2.3", Jl;
}
var Nd;
function xh() {
  if (Nd) return bf.exports;
  Nd = 1;
  function v() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(v);
      } catch (A) {
        console.error(A);
      }
  }
  return v(), bf.exports = Sh(), bf.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ud;
function zh() {
  if (Ud) return Au;
  Ud = 1;
  var v = bh(), A = xf(), E = xh();
  function r(l) {
    var t = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var e = 2; e < arguments.length; e++)
        t += "&args[]=" + encodeURIComponent(arguments[e]);
    }
    return "Minified React error #" + l + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function O(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
  }
  function _(l) {
    var t = l, e = l;
    if (l.alternate) for (; t.return; ) t = t.return;
    else {
      l = t;
      do
        t = l, (t.flags & 4098) !== 0 && (e = t.return), l = t.return;
      while (l);
    }
    return t.tag === 3 ? e : null;
  }
  function Y(l) {
    if (l.tag === 13) {
      var t = l.memoizedState;
      if (t === null && (l = l.alternate, l !== null && (t = l.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function N(l) {
    if (l.tag === 31) {
      var t = l.memoizedState;
      if (t === null && (l = l.alternate, l !== null && (t = l.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function M(l) {
    if (_(l) !== l)
      throw Error(r(188));
  }
  function S(l) {
    var t = l.alternate;
    if (!t) {
      if (t = _(l), t === null) throw Error(r(188));
      return t !== l ? null : l;
    }
    for (var e = l, a = t; ; ) {
      var u = e.return;
      if (u === null) break;
      var n = u.alternate;
      if (n === null) {
        if (a = u.return, a !== null) {
          e = a;
          continue;
        }
        break;
      }
      if (u.child === n.child) {
        for (n = u.child; n; ) {
          if (n === e) return M(u), l;
          if (n === a) return M(u), t;
          n = n.sibling;
        }
        throw Error(r(188));
      }
      if (e.return !== a.return) e = u, a = n;
      else {
        for (var i = !1, c = u.child; c; ) {
          if (c === e) {
            i = !0, e = u, a = n;
            break;
          }
          if (c === a) {
            i = !0, a = u, e = n;
            break;
          }
          c = c.sibling;
        }
        if (!i) {
          for (c = n.child; c; ) {
            if (c === e) {
              i = !0, e = n, a = u;
              break;
            }
            if (c === a) {
              i = !0, a = n, e = u;
              break;
            }
            c = c.sibling;
          }
          if (!i) throw Error(r(189));
        }
      }
      if (e.alternate !== a) throw Error(r(190));
    }
    if (e.tag !== 3) throw Error(r(188));
    return e.stateNode.current === e ? l : t;
  }
  function Z(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l;
    for (l = l.child; l !== null; ) {
      if (t = Z(l), t !== null) return t;
      l = l.sibling;
    }
    return null;
  }
  var U = Object.assign, W = Symbol.for("react.element"), el = Symbol.for("react.transitional.element"), Ol = Symbol.for("react.portal"), bl = Symbol.for("react.fragment"), Sl = Symbol.for("react.strict_mode"), pl = Symbol.for("react.profiler"), vt = Symbol.for("react.consumer"), El = Symbol.for("react.context"), Gl = Symbol.for("react.forward_ref"), Ml = Symbol.for("react.suspense"), Hl = Symbol.for("react.suspense_list"), Q = Symbol.for("react.memo"), yl = Symbol.for("react.lazy"), ql = Symbol.for("react.activity"), Rt = Symbol.for("react.memo_cache_sentinel"), wl = Symbol.iterator;
  function _l(l) {
    return l === null || typeof l != "object" ? null : (l = wl && l[wl] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var Dt = Symbol.for("react.client.reference");
  function $l(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === Dt ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case bl:
        return "Fragment";
      case pl:
        return "Profiler";
      case Sl:
        return "StrictMode";
      case Ml:
        return "Suspense";
      case Hl:
        return "SuspenseList";
      case ql:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case Ol:
          return "Portal";
        case El:
          return l.displayName || "Context";
        case vt:
          return (l._context.displayName || "Context") + ".Consumer";
        case Gl:
          var t = l.render;
          return l = l.displayName, l || (l = t.displayName || t.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case Q:
          return t = l.displayName || null, t !== null ? t : $l(l.type) || "Memo";
        case yl:
          t = l._payload, l = l._init;
          try {
            return $l(l(t));
          } catch {
          }
      }
    return null;
  }
  var Tt = Array.isArray, x = A.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, R = E.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, X = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, cl = [], dl = -1;
  function d(l) {
    return { current: l };
  }
  function j(l) {
    0 > dl || (l.current = cl[dl], cl[dl] = null, dl--);
  }
  function D(l, t) {
    dl++, cl[dl] = l.current, l.current = t;
  }
  var C = d(null), V = d(null), w = d(null), ul = d(null);
  function kl(l, t) {
    switch (D(w, t), D(V, l), D(C, null), t.nodeType) {
      case 9:
      case 11:
        l = (l = t.documentElement) && (l = l.namespaceURI) ? $r(l) : 0;
        break;
      default:
        if (l = t.tagName, t = t.namespaceURI)
          t = $r(t), l = kr(t, l);
        else
          switch (l) {
            case "svg":
              l = 1;
              break;
            case "math":
              l = 2;
              break;
            default:
              l = 0;
          }
    }
    j(C), D(C, l);
  }
  function Al() {
    j(C), j(V), j(w);
  }
  function Ra(l) {
    l.memoizedState !== null && D(ul, l);
    var t = C.current, e = kr(t, l.type);
    t !== e && (D(V, l), D(C, e));
  }
  function Ou(l) {
    V.current === l && (j(C), j(V)), ul.current === l && (j(ul), bu._currentValue = X);
  }
  var kn, Ef;
  function je(l) {
    if (kn === void 0)
      try {
        throw Error();
      } catch (e) {
        var t = e.stack.trim().match(/\n( *(at )?)/);
        kn = t && t[1] || "", Ef = -1 < e.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + kn + l + Ef;
  }
  var Wn = !1;
  function Fn(l, t) {
    if (!l || Wn) return "";
    Wn = !0;
    var e = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var T = function() {
                throw Error();
              };
              if (Object.defineProperty(T.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(T, []);
                } catch (p) {
                  var g = p;
                }
                Reflect.construct(l, [], T);
              } else {
                try {
                  T.call();
                } catch (p) {
                  g = p;
                }
                l.call(T.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (p) {
                g = p;
              }
              (T = l()) && typeof T.catch == "function" && T.catch(function() {
              });
            }
          } catch (p) {
            if (p && g && typeof p.stack == "string")
              return [p.stack, g.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var u = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      u && u.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var n = a.DetermineComponentFrameRoot(), i = n[0], c = n[1];
      if (i && c) {
        var s = i.split(`
`), y = c.split(`
`);
        for (u = a = 0; a < s.length && !s[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; u < y.length && !y[u].includes(
          "DetermineComponentFrameRoot"
        ); )
          u++;
        if (a === s.length || u === y.length)
          for (a = s.length - 1, u = y.length - 1; 1 <= a && 0 <= u && s[a] !== y[u]; )
            u--;
        for (; 1 <= a && 0 <= u; a--, u--)
          if (s[a] !== y[u]) {
            if (a !== 1 || u !== 1)
              do
                if (a--, u--, 0 > u || s[a] !== y[u]) {
                  var b = `
` + s[a].replace(" at new ", " at ");
                  return l.displayName && b.includes("<anonymous>") && (b = b.replace("<anonymous>", l.displayName)), b;
                }
              while (1 <= a && 0 <= u);
            break;
          }
      }
    } finally {
      Wn = !1, Error.prepareStackTrace = e;
    }
    return (e = l ? l.displayName || l.name : "") ? je(e) : "";
  }
  function Jd(l, t) {
    switch (l.tag) {
      case 26:
      case 27:
      case 5:
        return je(l.type);
      case 16:
        return je("Lazy");
      case 13:
        return l.child !== t && t !== null ? je("Suspense Fallback") : je("Suspense");
      case 19:
        return je("SuspenseList");
      case 0:
      case 15:
        return Fn(l.type, !1);
      case 11:
        return Fn(l.type.render, !1);
      case 1:
        return Fn(l.type, !0);
      case 31:
        return je("Activity");
      default:
        return "";
    }
  }
  function Af(l) {
    try {
      var t = "", e = null;
      do
        t += Jd(l, e), e = l, l = l.return;
      while (l);
      return t;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var In = Object.prototype.hasOwnProperty, Pn = v.unstable_scheduleCallback, li = v.unstable_cancelCallback, wd = v.unstable_shouldYield, $d = v.unstable_requestPaint, ut = v.unstable_now, kd = v.unstable_getCurrentPriorityLevel, Tf = v.unstable_ImmediatePriority, jf = v.unstable_UserBlockingPriority, Mu = v.unstable_NormalPriority, Wd = v.unstable_LowPriority, Of = v.unstable_IdlePriority, Fd = v.log, Id = v.unstable_setDisableYieldValue, Da = null, nt = null;
  function le(l) {
    if (typeof Fd == "function" && Id(l), nt && typeof nt.setStrictMode == "function")
      try {
        nt.setStrictMode(Da, l);
      } catch {
      }
  }
  var it = Math.clz32 ? Math.clz32 : tm, Pd = Math.log, lm = Math.LN2;
  function tm(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (Pd(l) / lm | 0) | 0;
  }
  var _u = 256, Ru = 262144, Du = 4194304;
  function Oe(l) {
    var t = l & 42;
    if (t !== 0) return t;
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return l & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return l & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return l;
    }
  }
  function Nu(l, t, e) {
    var a = l.pendingLanes;
    if (a === 0) return 0;
    var u = 0, n = l.suspendedLanes, i = l.pingedLanes;
    l = l.warmLanes;
    var c = a & 134217727;
    return c !== 0 ? (a = c & ~n, a !== 0 ? u = Oe(a) : (i &= c, i !== 0 ? u = Oe(i) : e || (e = c & ~l, e !== 0 && (u = Oe(e))))) : (c = a & ~n, c !== 0 ? u = Oe(c) : i !== 0 ? u = Oe(i) : e || (e = a & ~l, e !== 0 && (u = Oe(e)))), u === 0 ? 0 : t !== 0 && t !== u && (t & n) === 0 && (n = u & -u, e = t & -t, n >= e || n === 32 && (e & 4194048) !== 0) ? t : u;
  }
  function Na(l, t) {
    return (l.pendingLanes & ~(l.suspendedLanes & ~l.pingedLanes) & t) === 0;
  }
  function em(l, t) {
    switch (l) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Mf() {
    var l = Du;
    return Du <<= 1, (Du & 62914560) === 0 && (Du = 4194304), l;
  }
  function ti(l) {
    for (var t = [], e = 0; 31 > e; e++) t.push(l);
    return t;
  }
  function Ua(l, t) {
    l.pendingLanes |= t, t !== 268435456 && (l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0);
  }
  function am(l, t, e, a, u, n) {
    var i = l.pendingLanes;
    l.pendingLanes = e, l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0, l.expiredLanes &= e, l.entangledLanes &= e, l.errorRecoveryDisabledLanes &= e, l.shellSuspendCounter = 0;
    var c = l.entanglements, s = l.expirationTimes, y = l.hiddenUpdates;
    for (e = i & ~e; 0 < e; ) {
      var b = 31 - it(e), T = 1 << b;
      c[b] = 0, s[b] = -1;
      var g = y[b];
      if (g !== null)
        for (y[b] = null, b = 0; b < g.length; b++) {
          var p = g[b];
          p !== null && (p.lane &= -536870913);
        }
      e &= ~T;
    }
    a !== 0 && _f(l, a, 0), n !== 0 && u === 0 && l.tag !== 0 && (l.suspendedLanes |= n & ~(i & ~t));
  }
  function _f(l, t, e) {
    l.pendingLanes |= t, l.suspendedLanes &= ~t;
    var a = 31 - it(t);
    l.entangledLanes |= t, l.entanglements[a] = l.entanglements[a] | 1073741824 | e & 261930;
  }
  function Rf(l, t) {
    var e = l.entangledLanes |= t;
    for (l = l.entanglements; e; ) {
      var a = 31 - it(e), u = 1 << a;
      u & t | l[a] & t && (l[a] |= t), e &= ~u;
    }
  }
  function Df(l, t) {
    var e = t & -t;
    return e = (e & 42) !== 0 ? 1 : ei(e), (e & (l.suspendedLanes | t)) !== 0 ? 0 : e;
  }
  function ei(l) {
    switch (l) {
      case 2:
        l = 1;
        break;
      case 8:
        l = 4;
        break;
      case 32:
        l = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        l = 128;
        break;
      case 268435456:
        l = 134217728;
        break;
      default:
        l = 0;
    }
    return l;
  }
  function ai(l) {
    return l &= -l, 2 < l ? 8 < l ? (l & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function Nf() {
    var l = R.p;
    return l !== 0 ? l : (l = window.event, l === void 0 ? 32 : pd(l.type));
  }
  function Uf(l, t) {
    var e = R.p;
    try {
      return R.p = l, t();
    } finally {
      R.p = e;
    }
  }
  var te = Math.random().toString(36).slice(2), Ql = "__reactFiber$" + te, Fl = "__reactProps$" + te, Je = "__reactContainer$" + te, ui = "__reactEvents$" + te, um = "__reactListeners$" + te, nm = "__reactHandles$" + te, Hf = "__reactResources$" + te, Ha = "__reactMarker$" + te;
  function ni(l) {
    delete l[Ql], delete l[Fl], delete l[ui], delete l[um], delete l[nm];
  }
  function we(l) {
    var t = l[Ql];
    if (t) return t;
    for (var e = l.parentNode; e; ) {
      if (t = e[Je] || e[Ql]) {
        if (e = t.alternate, t.child !== null || e !== null && e.child !== null)
          for (l = ed(l); l !== null; ) {
            if (e = l[Ql]) return e;
            l = ed(l);
          }
        return t;
      }
      l = e, e = l.parentNode;
    }
    return null;
  }
  function $e(l) {
    if (l = l[Ql] || l[Je]) {
      var t = l.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
        return l;
    }
    return null;
  }
  function Ca(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l.stateNode;
    throw Error(r(33));
  }
  function ke(l) {
    var t = l[Hf];
    return t || (t = l[Hf] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
  }
  function Bl(l) {
    l[Ha] = !0;
  }
  var Cf = /* @__PURE__ */ new Set(), qf = {};
  function Me(l, t) {
    We(l, t), We(l + "Capture", t);
  }
  function We(l, t) {
    for (qf[l] = t, l = 0; l < t.length; l++)
      Cf.add(t[l]);
  }
  var im = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Bf = {}, Yf = {};
  function cm(l) {
    return In.call(Yf, l) ? !0 : In.call(Bf, l) ? !1 : im.test(l) ? Yf[l] = !0 : (Bf[l] = !0, !1);
  }
  function Uu(l, t, e) {
    if (cm(t))
      if (e === null) l.removeAttribute(t);
      else {
        switch (typeof e) {
          case "undefined":
          case "function":
          case "symbol":
            l.removeAttribute(t);
            return;
          case "boolean":
            var a = t.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              l.removeAttribute(t);
              return;
            }
        }
        l.setAttribute(t, "" + e);
      }
  }
  function Hu(l, t, e) {
    if (e === null) l.removeAttribute(t);
    else {
      switch (typeof e) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(t);
          return;
      }
      l.setAttribute(t, "" + e);
    }
  }
  function qt(l, t, e, a) {
    if (a === null) l.removeAttribute(e);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(e);
          return;
      }
      l.setAttributeNS(t, e, "" + a);
    }
  }
  function ht(l) {
    switch (typeof l) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function Gf(l) {
    var t = l.type;
    return (l = l.nodeName) && l.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function fm(l, t, e) {
    var a = Object.getOwnPropertyDescriptor(
      l.constructor.prototype,
      t
    );
    if (!l.hasOwnProperty(t) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var u = a.get, n = a.set;
      return Object.defineProperty(l, t, {
        configurable: !0,
        get: function() {
          return u.call(this);
        },
        set: function(i) {
          e = "" + i, n.call(this, i);
        }
      }), Object.defineProperty(l, t, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return e;
        },
        setValue: function(i) {
          e = "" + i;
        },
        stopTracking: function() {
          l._valueTracker = null, delete l[t];
        }
      };
    }
  }
  function ii(l) {
    if (!l._valueTracker) {
      var t = Gf(l) ? "checked" : "value";
      l._valueTracker = fm(
        l,
        t,
        "" + l[t]
      );
    }
  }
  function Qf(l) {
    if (!l) return !1;
    var t = l._valueTracker;
    if (!t) return !0;
    var e = t.getValue(), a = "";
    return l && (a = Gf(l) ? l.checked ? "true" : "false" : l.value), l = a, l !== e ? (t.setValue(l), !0) : !1;
  }
  function Cu(l) {
    if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  var sm = /[\n"\\]/g;
  function yt(l) {
    return l.replace(
      sm,
      function(t) {
        return "\\" + t.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function ci(l, t, e, a, u, n, i, c) {
    l.name = "", i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" ? l.type = i : l.removeAttribute("type"), t != null ? i === "number" ? (t === 0 && l.value === "" || l.value != t) && (l.value = "" + ht(t)) : l.value !== "" + ht(t) && (l.value = "" + ht(t)) : i !== "submit" && i !== "reset" || l.removeAttribute("value"), t != null ? fi(l, i, ht(t)) : e != null ? fi(l, i, ht(e)) : a != null && l.removeAttribute("value"), u == null && n != null && (l.defaultChecked = !!n), u != null && (l.checked = u && typeof u != "function" && typeof u != "symbol"), c != null && typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" ? l.name = "" + ht(c) : l.removeAttribute("name");
  }
  function Xf(l, t, e, a, u, n, i, c) {
    if (n != null && typeof n != "function" && typeof n != "symbol" && typeof n != "boolean" && (l.type = n), t != null || e != null) {
      if (!(n !== "submit" && n !== "reset" || t != null)) {
        ii(l);
        return;
      }
      e = e != null ? "" + ht(e) : "", t = t != null ? "" + ht(t) : e, c || t === l.value || (l.value = t), l.defaultValue = t;
    }
    a = a ?? u, a = typeof a != "function" && typeof a != "symbol" && !!a, l.checked = c ? l.checked : !!a, l.defaultChecked = !!a, i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" && (l.name = i), ii(l);
  }
  function fi(l, t, e) {
    t === "number" && Cu(l.ownerDocument) === l || l.defaultValue === "" + e || (l.defaultValue = "" + e);
  }
  function Fe(l, t, e, a) {
    if (l = l.options, t) {
      t = {};
      for (var u = 0; u < e.length; u++)
        t["$" + e[u]] = !0;
      for (e = 0; e < l.length; e++)
        u = t.hasOwnProperty("$" + l[e].value), l[e].selected !== u && (l[e].selected = u), u && a && (l[e].defaultSelected = !0);
    } else {
      for (e = "" + ht(e), t = null, u = 0; u < l.length; u++) {
        if (l[u].value === e) {
          l[u].selected = !0, a && (l[u].defaultSelected = !0);
          return;
        }
        t !== null || l[u].disabled || (t = l[u]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function Lf(l, t, e) {
    if (t != null && (t = "" + ht(t), t !== l.value && (l.value = t), e == null)) {
      l.defaultValue !== t && (l.defaultValue = t);
      return;
    }
    l.defaultValue = e != null ? "" + ht(e) : "";
  }
  function Zf(l, t, e, a) {
    if (t == null) {
      if (a != null) {
        if (e != null) throw Error(r(92));
        if (Tt(a)) {
          if (1 < a.length) throw Error(r(93));
          a = a[0];
        }
        e = a;
      }
      e == null && (e = ""), t = e;
    }
    e = ht(t), l.defaultValue = e, a = l.textContent, a === e && a !== "" && a !== null && (l.value = a), ii(l);
  }
  function Ie(l, t) {
    if (t) {
      var e = l.firstChild;
      if (e && e === l.lastChild && e.nodeType === 3) {
        e.nodeValue = t;
        return;
      }
    }
    l.textContent = t;
  }
  var om = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Vf(l, t, e) {
    var a = t.indexOf("--") === 0;
    e == null || typeof e == "boolean" || e === "" ? a ? l.setProperty(t, "") : t === "float" ? l.cssFloat = "" : l[t] = "" : a ? l.setProperty(t, e) : typeof e != "number" || e === 0 || om.has(t) ? t === "float" ? l.cssFloat = e : l[t] = ("" + e).trim() : l[t] = e + "px";
  }
  function Kf(l, t, e) {
    if (t != null && typeof t != "object")
      throw Error(r(62));
    if (l = l.style, e != null) {
      for (var a in e)
        !e.hasOwnProperty(a) || t != null && t.hasOwnProperty(a) || (a.indexOf("--") === 0 ? l.setProperty(a, "") : a === "float" ? l.cssFloat = "" : l[a] = "");
      for (var u in t)
        a = t[u], t.hasOwnProperty(u) && e[u] !== a && Vf(l, u, a);
    } else
      for (var n in t)
        t.hasOwnProperty(n) && Vf(l, n, t[n]);
  }
  function si(l) {
    if (l.indexOf("-") === -1) return !1;
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var rm = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), dm = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function qu(l) {
    return dm.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  function Bt() {
  }
  var oi = null;
  function ri(l) {
    return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
  }
  var Pe = null, la = null;
  function Jf(l) {
    var t = $e(l);
    if (t && (l = t.stateNode)) {
      var e = l[Fl] || null;
      l: switch (l = t.stateNode, t.type) {
        case "input":
          if (ci(
            l,
            e.value,
            e.defaultValue,
            e.defaultValue,
            e.checked,
            e.defaultChecked,
            e.type,
            e.name
          ), t = e.name, e.type === "radio" && t != null) {
            for (e = l; e.parentNode; ) e = e.parentNode;
            for (e = e.querySelectorAll(
              'input[name="' + yt(
                "" + t
              ) + '"][type="radio"]'
            ), t = 0; t < e.length; t++) {
              var a = e[t];
              if (a !== l && a.form === l.form) {
                var u = a[Fl] || null;
                if (!u) throw Error(r(90));
                ci(
                  a,
                  u.value,
                  u.defaultValue,
                  u.defaultValue,
                  u.checked,
                  u.defaultChecked,
                  u.type,
                  u.name
                );
              }
            }
            for (t = 0; t < e.length; t++)
              a = e[t], a.form === l.form && Qf(a);
          }
          break l;
        case "textarea":
          Lf(l, e.value, e.defaultValue);
          break l;
        case "select":
          t = e.value, t != null && Fe(l, !!e.multiple, t, !1);
      }
    }
  }
  var di = !1;
  function wf(l, t, e) {
    if (di) return l(t, e);
    di = !0;
    try {
      var a = l(t);
      return a;
    } finally {
      if (di = !1, (Pe !== null || la !== null) && (An(), Pe && (t = Pe, l = la, la = Pe = null, Jf(t), l)))
        for (t = 0; t < l.length; t++) Jf(l[t]);
    }
  }
  function qa(l, t) {
    var e = l.stateNode;
    if (e === null) return null;
    var a = e[Fl] || null;
    if (a === null) return null;
    e = a[t];
    l: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (l = l.type, a = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !a;
        break l;
      default:
        l = !1;
    }
    if (l) return null;
    if (e && typeof e != "function")
      throw Error(
        r(231, t, typeof e)
      );
    return e;
  }
  var Yt = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), mi = !1;
  if (Yt)
    try {
      var Ba = {};
      Object.defineProperty(Ba, "passive", {
        get: function() {
          mi = !0;
        }
      }), window.addEventListener("test", Ba, Ba), window.removeEventListener("test", Ba, Ba);
    } catch {
      mi = !1;
    }
  var ee = null, vi = null, Bu = null;
  function $f() {
    if (Bu) return Bu;
    var l, t = vi, e = t.length, a, u = "value" in ee ? ee.value : ee.textContent, n = u.length;
    for (l = 0; l < e && t[l] === u[l]; l++) ;
    var i = e - l;
    for (a = 1; a <= i && t[e - a] === u[n - a]; a++) ;
    return Bu = u.slice(l, 1 < a ? 1 - a : void 0);
  }
  function Yu(l) {
    var t = l.keyCode;
    return "charCode" in l ? (l = l.charCode, l === 0 && t === 13 && (l = 13)) : l = t, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
  }
  function Gu() {
    return !0;
  }
  function kf() {
    return !1;
  }
  function Il(l) {
    function t(e, a, u, n, i) {
      this._reactName = e, this._targetInst = u, this.type = a, this.nativeEvent = n, this.target = i, this.currentTarget = null;
      for (var c in l)
        l.hasOwnProperty(c) && (e = l[c], this[c] = e ? e(n) : n[c]);
      return this.isDefaultPrevented = (n.defaultPrevented != null ? n.defaultPrevented : n.returnValue === !1) ? Gu : kf, this.isPropagationStopped = kf, this;
    }
    return U(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var e = this.nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = Gu);
      },
      stopPropagation: function() {
        var e = this.nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = Gu);
      },
      persist: function() {
      },
      isPersistent: Gu
    }), t;
  }
  var _e = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(l) {
      return l.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Qu = Il(_e), Ya = U({}, _e, { view: 0, detail: 0 }), mm = Il(Ya), hi, yi, Ga, Xu = U({}, Ya, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: pi,
    button: 0,
    buttons: 0,
    relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    },
    movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== Ga && (Ga && l.type === "mousemove" ? (hi = l.screenX - Ga.screenX, yi = l.screenY - Ga.screenY) : yi = hi = 0, Ga = l), hi);
    },
    movementY: function(l) {
      return "movementY" in l ? l.movementY : yi;
    }
  }), Wf = Il(Xu), vm = U({}, Xu, { dataTransfer: 0 }), hm = Il(vm), ym = U({}, Ya, { relatedTarget: 0 }), gi = Il(ym), gm = U({}, _e, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), pm = Il(gm), bm = U({}, _e, {
    clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    }
  }), Sm = Il(bm), xm = U({}, _e, { data: 0 }), Ff = Il(xm), zm = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Em = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Am = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Tm(l) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(l) : (l = Am[l]) ? !!t[l] : !1;
  }
  function pi() {
    return Tm;
  }
  var jm = U({}, Ya, {
    key: function(l) {
      if (l.key) {
        var t = zm[l.key] || l.key;
        if (t !== "Unidentified") return t;
      }
      return l.type === "keypress" ? (l = Yu(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? Em[l.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: pi,
    charCode: function(l) {
      return l.type === "keypress" ? Yu(l) : 0;
    },
    keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    },
    which: function(l) {
      return l.type === "keypress" ? Yu(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }
  }), Om = Il(jm), Mm = U({}, Xu, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), If = Il(Mm), _m = U({}, Ya, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: pi
  }), Rm = Il(_m), Dm = U({}, _e, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Nm = Il(Dm), Um = U({}, Xu, {
    deltaX: function(l) {
      return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
    },
    deltaY: function(l) {
      return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Hm = Il(Um), Cm = U({}, _e, {
    newState: 0,
    oldState: 0
  }), qm = Il(Cm), Bm = [9, 13, 27, 32], bi = Yt && "CompositionEvent" in window, Qa = null;
  Yt && "documentMode" in document && (Qa = document.documentMode);
  var Ym = Yt && "TextEvent" in window && !Qa, Pf = Yt && (!bi || Qa && 8 < Qa && 11 >= Qa), ls = " ", ts = !1;
  function es(l, t) {
    switch (l) {
      case "keyup":
        return Bm.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function as(l) {
    return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
  }
  var ta = !1;
  function Gm(l, t) {
    switch (l) {
      case "compositionend":
        return as(t);
      case "keypress":
        return t.which !== 32 ? null : (ts = !0, ls);
      case "textInput":
        return l = t.data, l === ls && ts ? null : l;
      default:
        return null;
    }
  }
  function Qm(l, t) {
    if (ta)
      return l === "compositionend" || !bi && es(l, t) ? (l = $f(), Bu = vi = ee = null, ta = !1, l) : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length)
            return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return Pf && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var Xm = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function us(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t === "input" ? !!Xm[l.type] : t === "textarea";
  }
  function ns(l, t, e, a) {
    Pe ? la ? la.push(a) : la = [a] : Pe = a, t = Dn(t, "onChange"), 0 < t.length && (e = new Qu(
      "onChange",
      "change",
      null,
      e,
      a
    ), l.push({ event: e, listeners: t }));
  }
  var Xa = null, La = null;
  function Lm(l) {
    Lr(l, 0);
  }
  function Lu(l) {
    var t = Ca(l);
    if (Qf(t)) return l;
  }
  function is(l, t) {
    if (l === "change") return t;
  }
  var cs = !1;
  if (Yt) {
    var Si;
    if (Yt) {
      var xi = "oninput" in document;
      if (!xi) {
        var fs = document.createElement("div");
        fs.setAttribute("oninput", "return;"), xi = typeof fs.oninput == "function";
      }
      Si = xi;
    } else Si = !1;
    cs = Si && (!document.documentMode || 9 < document.documentMode);
  }
  function ss() {
    Xa && (Xa.detachEvent("onpropertychange", os), La = Xa = null);
  }
  function os(l) {
    if (l.propertyName === "value" && Lu(La)) {
      var t = [];
      ns(
        t,
        La,
        l,
        ri(l)
      ), wf(Lm, t);
    }
  }
  function Zm(l, t, e) {
    l === "focusin" ? (ss(), Xa = t, La = e, Xa.attachEvent("onpropertychange", os)) : l === "focusout" && ss();
  }
  function Vm(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return Lu(La);
  }
  function Km(l, t) {
    if (l === "click") return Lu(t);
  }
  function Jm(l, t) {
    if (l === "input" || l === "change")
      return Lu(t);
  }
  function wm(l, t) {
    return l === t && (l !== 0 || 1 / l === 1 / t) || l !== l && t !== t;
  }
  var ct = typeof Object.is == "function" ? Object.is : wm;
  function Za(l, t) {
    if (ct(l, t)) return !0;
    if (typeof l != "object" || l === null || typeof t != "object" || t === null)
      return !1;
    var e = Object.keys(l), a = Object.keys(t);
    if (e.length !== a.length) return !1;
    for (a = 0; a < e.length; a++) {
      var u = e[a];
      if (!In.call(t, u) || !ct(l[u], t[u]))
        return !1;
    }
    return !0;
  }
  function rs(l) {
    for (; l && l.firstChild; ) l = l.firstChild;
    return l;
  }
  function ds(l, t) {
    var e = rs(l);
    l = 0;
    for (var a; e; ) {
      if (e.nodeType === 3) {
        if (a = l + e.textContent.length, l <= t && a >= t)
          return { node: e, offset: t - l };
        l = a;
      }
      l: {
        for (; e; ) {
          if (e.nextSibling) {
            e = e.nextSibling;
            break l;
          }
          e = e.parentNode;
        }
        e = void 0;
      }
      e = rs(e);
    }
  }
  function ms(l, t) {
    return l && t ? l === t ? !0 : l && l.nodeType === 3 ? !1 : t && t.nodeType === 3 ? ms(l, t.parentNode) : "contains" in l ? l.contains(t) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function vs(l) {
    l = l != null && l.ownerDocument != null && l.ownerDocument.defaultView != null ? l.ownerDocument.defaultView : window;
    for (var t = Cu(l.document); t instanceof l.HTMLIFrameElement; ) {
      try {
        var e = typeof t.contentWindow.location.href == "string";
      } catch {
        e = !1;
      }
      if (e) l = t.contentWindow;
      else break;
      t = Cu(l.document);
    }
    return t;
  }
  function zi(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t && (t === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || t === "textarea" || l.contentEditable === "true");
  }
  var $m = Yt && "documentMode" in document && 11 >= document.documentMode, ea = null, Ei = null, Va = null, Ai = !1;
  function hs(l, t, e) {
    var a = e.window === e ? e.document : e.nodeType === 9 ? e : e.ownerDocument;
    Ai || ea == null || ea !== Cu(a) || (a = ea, "selectionStart" in a && zi(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), Va && Za(Va, a) || (Va = a, a = Dn(Ei, "onSelect"), 0 < a.length && (t = new Qu(
      "onSelect",
      "select",
      null,
      t,
      e
    ), l.push({ event: t, listeners: a }), t.target = ea)));
  }
  function Re(l, t) {
    var e = {};
    return e[l.toLowerCase()] = t.toLowerCase(), e["Webkit" + l] = "webkit" + t, e["Moz" + l] = "moz" + t, e;
  }
  var aa = {
    animationend: Re("Animation", "AnimationEnd"),
    animationiteration: Re("Animation", "AnimationIteration"),
    animationstart: Re("Animation", "AnimationStart"),
    transitionrun: Re("Transition", "TransitionRun"),
    transitionstart: Re("Transition", "TransitionStart"),
    transitioncancel: Re("Transition", "TransitionCancel"),
    transitionend: Re("Transition", "TransitionEnd")
  }, Ti = {}, ys = {};
  Yt && (ys = document.createElement("div").style, "AnimationEvent" in window || (delete aa.animationend.animation, delete aa.animationiteration.animation, delete aa.animationstart.animation), "TransitionEvent" in window || delete aa.transitionend.transition);
  function De(l) {
    if (Ti[l]) return Ti[l];
    if (!aa[l]) return l;
    var t = aa[l], e;
    for (e in t)
      if (t.hasOwnProperty(e) && e in ys)
        return Ti[l] = t[e];
    return l;
  }
  var gs = De("animationend"), ps = De("animationiteration"), bs = De("animationstart"), km = De("transitionrun"), Wm = De("transitionstart"), Fm = De("transitioncancel"), Ss = De("transitionend"), xs = /* @__PURE__ */ new Map(), ji = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  ji.push("scrollEnd");
  function jt(l, t) {
    xs.set(l, t), Me(t, [l]);
  }
  var Zu = typeof reportError == "function" ? reportError : function(l) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof l == "object" && l !== null && typeof l.message == "string" ? String(l.message) : String(l),
        error: l
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", l);
      return;
    }
    console.error(l);
  }, gt = [], ua = 0, Oi = 0;
  function Vu() {
    for (var l = ua, t = Oi = ua = 0; t < l; ) {
      var e = gt[t];
      gt[t++] = null;
      var a = gt[t];
      gt[t++] = null;
      var u = gt[t];
      gt[t++] = null;
      var n = gt[t];
      if (gt[t++] = null, a !== null && u !== null) {
        var i = a.pending;
        i === null ? u.next = u : (u.next = i.next, i.next = u), a.pending = u;
      }
      n !== 0 && zs(e, u, n);
    }
  }
  function Ku(l, t, e, a) {
    gt[ua++] = l, gt[ua++] = t, gt[ua++] = e, gt[ua++] = a, Oi |= a, l.lanes |= a, l = l.alternate, l !== null && (l.lanes |= a);
  }
  function Mi(l, t, e, a) {
    return Ku(l, t, e, a), Ju(l);
  }
  function Ne(l, t) {
    return Ku(l, null, null, t), Ju(l);
  }
  function zs(l, t, e) {
    l.lanes |= e;
    var a = l.alternate;
    a !== null && (a.lanes |= e);
    for (var u = !1, n = l.return; n !== null; )
      n.childLanes |= e, a = n.alternate, a !== null && (a.childLanes |= e), n.tag === 22 && (l = n.stateNode, l === null || l._visibility & 1 || (u = !0)), l = n, n = n.return;
    return l.tag === 3 ? (n = l.stateNode, u && t !== null && (u = 31 - it(e), l = n.hiddenUpdates, a = l[u], a === null ? l[u] = [t] : a.push(t), t.lane = e | 536870912), n) : null;
  }
  function Ju(l) {
    if (50 < du)
      throw du = 0, Bc = null, Error(r(185));
    for (var t = l.return; t !== null; )
      l = t, t = l.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var na = {};
  function Im(l, t, e, a) {
    this.tag = l, this.key = e, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ft(l, t, e, a) {
    return new Im(l, t, e, a);
  }
  function _i(l) {
    return l = l.prototype, !(!l || !l.isReactComponent);
  }
  function Gt(l, t) {
    var e = l.alternate;
    return e === null ? (e = ft(
      l.tag,
      t,
      l.key,
      l.mode
    ), e.elementType = l.elementType, e.type = l.type, e.stateNode = l.stateNode, e.alternate = l, l.alternate = e) : (e.pendingProps = t, e.type = l.type, e.flags = 0, e.subtreeFlags = 0, e.deletions = null), e.flags = l.flags & 65011712, e.childLanes = l.childLanes, e.lanes = l.lanes, e.child = l.child, e.memoizedProps = l.memoizedProps, e.memoizedState = l.memoizedState, e.updateQueue = l.updateQueue, t = l.dependencies, e.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, e.sibling = l.sibling, e.index = l.index, e.ref = l.ref, e.refCleanup = l.refCleanup, e;
  }
  function Es(l, t) {
    l.flags &= 65011714;
    var e = l.alternate;
    return e === null ? (l.childLanes = 0, l.lanes = t, l.child = null, l.subtreeFlags = 0, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null) : (l.childLanes = e.childLanes, l.lanes = e.lanes, l.child = e.child, l.subtreeFlags = 0, l.deletions = null, l.memoizedProps = e.memoizedProps, l.memoizedState = e.memoizedState, l.updateQueue = e.updateQueue, l.type = e.type, t = e.dependencies, l.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), l;
  }
  function wu(l, t, e, a, u, n) {
    var i = 0;
    if (a = l, typeof l == "function") _i(l) && (i = 1);
    else if (typeof l == "string")
      i = ah(
        l,
        e,
        C.current
      ) ? 26 : l === "html" || l === "head" || l === "body" ? 27 : 5;
    else
      l: switch (l) {
        case ql:
          return l = ft(31, e, t, u), l.elementType = ql, l.lanes = n, l;
        case bl:
          return Ue(e.children, u, n, t);
        case Sl:
          i = 8, u |= 24;
          break;
        case pl:
          return l = ft(12, e, t, u | 2), l.elementType = pl, l.lanes = n, l;
        case Ml:
          return l = ft(13, e, t, u), l.elementType = Ml, l.lanes = n, l;
        case Hl:
          return l = ft(19, e, t, u), l.elementType = Hl, l.lanes = n, l;
        default:
          if (typeof l == "object" && l !== null)
            switch (l.$$typeof) {
              case El:
                i = 10;
                break l;
              case vt:
                i = 9;
                break l;
              case Gl:
                i = 11;
                break l;
              case Q:
                i = 14;
                break l;
              case yl:
                i = 16, a = null;
                break l;
            }
          i = 29, e = Error(
            r(130, l === null ? "null" : typeof l, "")
          ), a = null;
      }
    return t = ft(i, e, t, u), t.elementType = l, t.type = a, t.lanes = n, t;
  }
  function Ue(l, t, e, a) {
    return l = ft(7, l, a, t), l.lanes = e, l;
  }
  function Ri(l, t, e) {
    return l = ft(6, l, null, t), l.lanes = e, l;
  }
  function As(l) {
    var t = ft(18, null, null, 0);
    return t.stateNode = l, t;
  }
  function Di(l, t, e) {
    return t = ft(
      4,
      l.children !== null ? l.children : [],
      l.key,
      t
    ), t.lanes = e, t.stateNode = {
      containerInfo: l.containerInfo,
      pendingChildren: null,
      implementation: l.implementation
    }, t;
  }
  var Ts = /* @__PURE__ */ new WeakMap();
  function pt(l, t) {
    if (typeof l == "object" && l !== null) {
      var e = Ts.get(l);
      return e !== void 0 ? e : (t = {
        value: l,
        source: t,
        stack: Af(t)
      }, Ts.set(l, t), t);
    }
    return {
      value: l,
      source: t,
      stack: Af(t)
    };
  }
  var ia = [], ca = 0, $u = null, Ka = 0, bt = [], St = 0, ae = null, Nt = 1, Ut = "";
  function Qt(l, t) {
    ia[ca++] = Ka, ia[ca++] = $u, $u = l, Ka = t;
  }
  function js(l, t, e) {
    bt[St++] = Nt, bt[St++] = Ut, bt[St++] = ae, ae = l;
    var a = Nt;
    l = Ut;
    var u = 32 - it(a) - 1;
    a &= ~(1 << u), e += 1;
    var n = 32 - it(t) + u;
    if (30 < n) {
      var i = u - u % 5;
      n = (a & (1 << i) - 1).toString(32), a >>= i, u -= i, Nt = 1 << 32 - it(t) + u | e << u | a, Ut = n + l;
    } else
      Nt = 1 << n | e << u | a, Ut = l;
  }
  function Ni(l) {
    l.return !== null && (Qt(l, 1), js(l, 1, 0));
  }
  function Ui(l) {
    for (; l === $u; )
      $u = ia[--ca], ia[ca] = null, Ka = ia[--ca], ia[ca] = null;
    for (; l === ae; )
      ae = bt[--St], bt[St] = null, Ut = bt[--St], bt[St] = null, Nt = bt[--St], bt[St] = null;
  }
  function Os(l, t) {
    bt[St++] = Nt, bt[St++] = Ut, bt[St++] = ae, Nt = t.id, Ut = t.overflow, ae = l;
  }
  var Xl = null, vl = null, P = !1, ue = null, xt = !1, Hi = Error(r(519));
  function ne(l) {
    var t = Error(
      r(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw Ja(pt(t, l)), Hi;
  }
  function Ms(l) {
    var t = l.stateNode, e = l.type, a = l.memoizedProps;
    switch (t[Ql] = l, t[Fl] = a, e) {
      case "dialog":
        k("cancel", t), k("close", t);
        break;
      case "iframe":
      case "object":
      case "embed":
        k("load", t);
        break;
      case "video":
      case "audio":
        for (e = 0; e < vu.length; e++)
          k(vu[e], t);
        break;
      case "source":
        k("error", t);
        break;
      case "img":
      case "image":
      case "link":
        k("error", t), k("load", t);
        break;
      case "details":
        k("toggle", t);
        break;
      case "input":
        k("invalid", t), Xf(
          t,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        k("invalid", t);
        break;
      case "textarea":
        k("invalid", t), Zf(t, a.value, a.defaultValue, a.children);
    }
    e = a.children, typeof e != "string" && typeof e != "number" && typeof e != "bigint" || t.textContent === "" + e || a.suppressHydrationWarning === !0 || Jr(t.textContent, e) ? (a.popover != null && (k("beforetoggle", t), k("toggle", t)), a.onScroll != null && k("scroll", t), a.onScrollEnd != null && k("scrollend", t), a.onClick != null && (t.onclick = Bt), t = !0) : t = !1, t || ne(l, !0);
  }
  function _s(l) {
    for (Xl = l.return; Xl; )
      switch (Xl.tag) {
        case 5:
        case 31:
        case 13:
          xt = !1;
          return;
        case 27:
        case 3:
          xt = !0;
          return;
        default:
          Xl = Xl.return;
      }
  }
  function fa(l) {
    if (l !== Xl) return !1;
    if (!P) return _s(l), P = !0, !1;
    var t = l.tag, e;
    if ((e = t !== 3 && t !== 27) && ((e = t === 5) && (e = l.type, e = !(e !== "form" && e !== "button") || Ic(l.type, l.memoizedProps)), e = !e), e && vl && ne(l), _s(l), t === 13) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(r(317));
      vl = td(l);
    } else if (t === 31) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(r(317));
      vl = td(l);
    } else
      t === 27 ? (t = vl, be(l.type) ? (l = af, af = null, vl = l) : vl = t) : vl = Xl ? Et(l.stateNode.nextSibling) : null;
    return !0;
  }
  function He() {
    vl = Xl = null, P = !1;
  }
  function Ci() {
    var l = ue;
    return l !== null && (et === null ? et = l : et.push.apply(
      et,
      l
    ), ue = null), l;
  }
  function Ja(l) {
    ue === null ? ue = [l] : ue.push(l);
  }
  var qi = d(null), Ce = null, Xt = null;
  function ie(l, t, e) {
    D(qi, t._currentValue), t._currentValue = e;
  }
  function Lt(l) {
    l._currentValue = qi.current, j(qi);
  }
  function Bi(l, t, e) {
    for (; l !== null; ) {
      var a = l.alternate;
      if ((l.childLanes & t) !== t ? (l.childLanes |= t, a !== null && (a.childLanes |= t)) : a !== null && (a.childLanes & t) !== t && (a.childLanes |= t), l === e) break;
      l = l.return;
    }
  }
  function Yi(l, t, e, a) {
    var u = l.child;
    for (u !== null && (u.return = l); u !== null; ) {
      var n = u.dependencies;
      if (n !== null) {
        var i = u.child;
        n = n.firstContext;
        l: for (; n !== null; ) {
          var c = n;
          n = u;
          for (var s = 0; s < t.length; s++)
            if (c.context === t[s]) {
              n.lanes |= e, c = n.alternate, c !== null && (c.lanes |= e), Bi(
                n.return,
                e,
                l
              ), a || (i = null);
              break l;
            }
          n = c.next;
        }
      } else if (u.tag === 18) {
        if (i = u.return, i === null) throw Error(r(341));
        i.lanes |= e, n = i.alternate, n !== null && (n.lanes |= e), Bi(i, e, l), i = null;
      } else i = u.child;
      if (i !== null) i.return = u;
      else
        for (i = u; i !== null; ) {
          if (i === l) {
            i = null;
            break;
          }
          if (u = i.sibling, u !== null) {
            u.return = i.return, i = u;
            break;
          }
          i = i.return;
        }
      u = i;
    }
  }
  function sa(l, t, e, a) {
    l = null;
    for (var u = t, n = !1; u !== null; ) {
      if (!n) {
        if ((u.flags & 524288) !== 0) n = !0;
        else if ((u.flags & 262144) !== 0) break;
      }
      if (u.tag === 10) {
        var i = u.alternate;
        if (i === null) throw Error(r(387));
        if (i = i.memoizedProps, i !== null) {
          var c = u.type;
          ct(u.pendingProps.value, i.value) || (l !== null ? l.push(c) : l = [c]);
        }
      } else if (u === ul.current) {
        if (i = u.alternate, i === null) throw Error(r(387));
        i.memoizedState.memoizedState !== u.memoizedState.memoizedState && (l !== null ? l.push(bu) : l = [bu]);
      }
      u = u.return;
    }
    l !== null && Yi(
      t,
      l,
      e,
      a
    ), t.flags |= 262144;
  }
  function ku(l) {
    for (l = l.firstContext; l !== null; ) {
      if (!ct(
        l.context._currentValue,
        l.memoizedValue
      ))
        return !0;
      l = l.next;
    }
    return !1;
  }
  function qe(l) {
    Ce = l, Xt = null, l = l.dependencies, l !== null && (l.firstContext = null);
  }
  function Ll(l) {
    return Rs(Ce, l);
  }
  function Wu(l, t) {
    return Ce === null && qe(l), Rs(l, t);
  }
  function Rs(l, t) {
    var e = t._currentValue;
    if (t = { context: t, memoizedValue: e, next: null }, Xt === null) {
      if (l === null) throw Error(r(308));
      Xt = t, l.dependencies = { lanes: 0, firstContext: t }, l.flags |= 524288;
    } else Xt = Xt.next = t;
    return e;
  }
  var Pm = typeof AbortController < "u" ? AbortController : function() {
    var l = [], t = this.signal = {
      aborted: !1,
      addEventListener: function(e, a) {
        l.push(a);
      }
    };
    this.abort = function() {
      t.aborted = !0, l.forEach(function(e) {
        return e();
      });
    };
  }, lv = v.unstable_scheduleCallback, tv = v.unstable_NormalPriority, Rl = {
    $$typeof: El,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Gi() {
    return {
      controller: new Pm(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function wa(l) {
    l.refCount--, l.refCount === 0 && lv(tv, function() {
      l.controller.abort();
    });
  }
  var $a = null, Qi = 0, oa = 0, ra = null;
  function ev(l, t) {
    if ($a === null) {
      var e = $a = [];
      Qi = 0, oa = Zc(), ra = {
        status: "pending",
        value: void 0,
        then: function(a) {
          e.push(a);
        }
      };
    }
    return Qi++, t.then(Ds, Ds), t;
  }
  function Ds() {
    if (--Qi === 0 && $a !== null) {
      ra !== null && (ra.status = "fulfilled");
      var l = $a;
      $a = null, oa = 0, ra = null;
      for (var t = 0; t < l.length; t++) (0, l[t])();
    }
  }
  function av(l, t) {
    var e = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(u) {
        e.push(u);
      }
    };
    return l.then(
      function() {
        a.status = "fulfilled", a.value = t;
        for (var u = 0; u < e.length; u++) (0, e[u])(t);
      },
      function(u) {
        for (a.status = "rejected", a.reason = u, u = 0; u < e.length; u++)
          (0, e[u])(void 0);
      }
    ), a;
  }
  var Ns = x.S;
  x.S = function(l, t) {
    yr = ut(), typeof t == "object" && t !== null && typeof t.then == "function" && ev(l, t), Ns !== null && Ns(l, t);
  };
  var Be = d(null);
  function Xi() {
    var l = Be.current;
    return l !== null ? l : ml.pooledCache;
  }
  function Fu(l, t) {
    t === null ? D(Be, Be.current) : D(Be, t.pool);
  }
  function Us() {
    var l = Xi();
    return l === null ? null : { parent: Rl._currentValue, pool: l };
  }
  var da = Error(r(460)), Li = Error(r(474)), Iu = Error(r(542)), Pu = { then: function() {
  } };
  function Hs(l) {
    return l = l.status, l === "fulfilled" || l === "rejected";
  }
  function Cs(l, t, e) {
    switch (e = l[e], e === void 0 ? l.push(t) : e !== t && (t.then(Bt, Bt), t = e), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw l = t.reason, Bs(l), l;
      default:
        if (typeof t.status == "string") t.then(Bt, Bt);
        else {
          if (l = ml, l !== null && 100 < l.shellSuspendCounter)
            throw Error(r(482));
          l = t, l.status = "pending", l.then(
            function(a) {
              if (t.status === "pending") {
                var u = t;
                u.status = "fulfilled", u.value = a;
              }
            },
            function(a) {
              if (t.status === "pending") {
                var u = t;
                u.status = "rejected", u.reason = a;
              }
            }
          );
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw l = t.reason, Bs(l), l;
        }
        throw Ge = t, da;
    }
  }
  function Ye(l) {
    try {
      var t = l._init;
      return t(l._payload);
    } catch (e) {
      throw e !== null && typeof e == "object" && typeof e.then == "function" ? (Ge = e, da) : e;
    }
  }
  var Ge = null;
  function qs() {
    if (Ge === null) throw Error(r(459));
    var l = Ge;
    return Ge = null, l;
  }
  function Bs(l) {
    if (l === da || l === Iu)
      throw Error(r(483));
  }
  var ma = null, ka = 0;
  function ln(l) {
    var t = ka;
    return ka += 1, ma === null && (ma = []), Cs(ma, l, t);
  }
  function Wa(l, t) {
    t = t.props.ref, l.ref = t !== void 0 ? t : null;
  }
  function tn(l, t) {
    throw t.$$typeof === W ? Error(r(525)) : (l = Object.prototype.toString.call(t), Error(
      r(
        31,
        l === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : l
      )
    ));
  }
  function Ys(l) {
    function t(m, o) {
      if (l) {
        var h = m.deletions;
        h === null ? (m.deletions = [o], m.flags |= 16) : h.push(o);
      }
    }
    function e(m, o) {
      if (!l) return null;
      for (; o !== null; )
        t(m, o), o = o.sibling;
      return null;
    }
    function a(m) {
      for (var o = /* @__PURE__ */ new Map(); m !== null; )
        m.key !== null ? o.set(m.key, m) : o.set(m.index, m), m = m.sibling;
      return o;
    }
    function u(m, o) {
      return m = Gt(m, o), m.index = 0, m.sibling = null, m;
    }
    function n(m, o, h) {
      return m.index = h, l ? (h = m.alternate, h !== null ? (h = h.index, h < o ? (m.flags |= 67108866, o) : h) : (m.flags |= 67108866, o)) : (m.flags |= 1048576, o);
    }
    function i(m) {
      return l && m.alternate === null && (m.flags |= 67108866), m;
    }
    function c(m, o, h, z) {
      return o === null || o.tag !== 6 ? (o = Ri(h, m.mode, z), o.return = m, o) : (o = u(o, h), o.return = m, o);
    }
    function s(m, o, h, z) {
      var B = h.type;
      return B === bl ? b(
        m,
        o,
        h.props.children,
        z,
        h.key
      ) : o !== null && (o.elementType === B || typeof B == "object" && B !== null && B.$$typeof === yl && Ye(B) === o.type) ? (o = u(o, h.props), Wa(o, h), o.return = m, o) : (o = wu(
        h.type,
        h.key,
        h.props,
        null,
        m.mode,
        z
      ), Wa(o, h), o.return = m, o);
    }
    function y(m, o, h, z) {
      return o === null || o.tag !== 4 || o.stateNode.containerInfo !== h.containerInfo || o.stateNode.implementation !== h.implementation ? (o = Di(h, m.mode, z), o.return = m, o) : (o = u(o, h.children || []), o.return = m, o);
    }
    function b(m, o, h, z, B) {
      return o === null || o.tag !== 7 ? (o = Ue(
        h,
        m.mode,
        z,
        B
      ), o.return = m, o) : (o = u(o, h), o.return = m, o);
    }
    function T(m, o, h) {
      if (typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint")
        return o = Ri(
          "" + o,
          m.mode,
          h
        ), o.return = m, o;
      if (typeof o == "object" && o !== null) {
        switch (o.$$typeof) {
          case el:
            return h = wu(
              o.type,
              o.key,
              o.props,
              null,
              m.mode,
              h
            ), Wa(h, o), h.return = m, h;
          case Ol:
            return o = Di(
              o,
              m.mode,
              h
            ), o.return = m, o;
          case yl:
            return o = Ye(o), T(m, o, h);
        }
        if (Tt(o) || _l(o))
          return o = Ue(
            o,
            m.mode,
            h,
            null
          ), o.return = m, o;
        if (typeof o.then == "function")
          return T(m, ln(o), h);
        if (o.$$typeof === El)
          return T(
            m,
            Wu(m, o),
            h
          );
        tn(m, o);
      }
      return null;
    }
    function g(m, o, h, z) {
      var B = o !== null ? o.key : null;
      if (typeof h == "string" && h !== "" || typeof h == "number" || typeof h == "bigint")
        return B !== null ? null : c(m, o, "" + h, z);
      if (typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case el:
            return h.key === B ? s(m, o, h, z) : null;
          case Ol:
            return h.key === B ? y(m, o, h, z) : null;
          case yl:
            return h = Ye(h), g(m, o, h, z);
        }
        if (Tt(h) || _l(h))
          return B !== null ? null : b(m, o, h, z, null);
        if (typeof h.then == "function")
          return g(
            m,
            o,
            ln(h),
            z
          );
        if (h.$$typeof === El)
          return g(
            m,
            o,
            Wu(m, h),
            z
          );
        tn(m, h);
      }
      return null;
    }
    function p(m, o, h, z, B) {
      if (typeof z == "string" && z !== "" || typeof z == "number" || typeof z == "bigint")
        return m = m.get(h) || null, c(o, m, "" + z, B);
      if (typeof z == "object" && z !== null) {
        switch (z.$$typeof) {
          case el:
            return m = m.get(
              z.key === null ? h : z.key
            ) || null, s(o, m, z, B);
          case Ol:
            return m = m.get(
              z.key === null ? h : z.key
            ) || null, y(o, m, z, B);
          case yl:
            return z = Ye(z), p(
              m,
              o,
              h,
              z,
              B
            );
        }
        if (Tt(z) || _l(z))
          return m = m.get(h) || null, b(o, m, z, B, null);
        if (typeof z.then == "function")
          return p(
            m,
            o,
            h,
            ln(z),
            B
          );
        if (z.$$typeof === El)
          return p(
            m,
            o,
            h,
            Wu(o, z),
            B
          );
        tn(o, z);
      }
      return null;
    }
    function H(m, o, h, z) {
      for (var B = null, ll = null, q = o, J = o = 0, I = null; q !== null && J < h.length; J++) {
        q.index > J ? (I = q, q = null) : I = q.sibling;
        var tl = g(
          m,
          q,
          h[J],
          z
        );
        if (tl === null) {
          q === null && (q = I);
          break;
        }
        l && q && tl.alternate === null && t(m, q), o = n(tl, o, J), ll === null ? B = tl : ll.sibling = tl, ll = tl, q = I;
      }
      if (J === h.length)
        return e(m, q), P && Qt(m, J), B;
      if (q === null) {
        for (; J < h.length; J++)
          q = T(m, h[J], z), q !== null && (o = n(
            q,
            o,
            J
          ), ll === null ? B = q : ll.sibling = q, ll = q);
        return P && Qt(m, J), B;
      }
      for (q = a(q); J < h.length; J++)
        I = p(
          q,
          m,
          J,
          h[J],
          z
        ), I !== null && (l && I.alternate !== null && q.delete(
          I.key === null ? J : I.key
        ), o = n(
          I,
          o,
          J
        ), ll === null ? B = I : ll.sibling = I, ll = I);
      return l && q.forEach(function(Ae) {
        return t(m, Ae);
      }), P && Qt(m, J), B;
    }
    function G(m, o, h, z) {
      if (h == null) throw Error(r(151));
      for (var B = null, ll = null, q = o, J = o = 0, I = null, tl = h.next(); q !== null && !tl.done; J++, tl = h.next()) {
        q.index > J ? (I = q, q = null) : I = q.sibling;
        var Ae = g(m, q, tl.value, z);
        if (Ae === null) {
          q === null && (q = I);
          break;
        }
        l && q && Ae.alternate === null && t(m, q), o = n(Ae, o, J), ll === null ? B = Ae : ll.sibling = Ae, ll = Ae, q = I;
      }
      if (tl.done)
        return e(m, q), P && Qt(m, J), B;
      if (q === null) {
        for (; !tl.done; J++, tl = h.next())
          tl = T(m, tl.value, z), tl !== null && (o = n(tl, o, J), ll === null ? B = tl : ll.sibling = tl, ll = tl);
        return P && Qt(m, J), B;
      }
      for (q = a(q); !tl.done; J++, tl = h.next())
        tl = p(q, m, J, tl.value, z), tl !== null && (l && tl.alternate !== null && q.delete(tl.key === null ? J : tl.key), o = n(tl, o, J), ll === null ? B = tl : ll.sibling = tl, ll = tl);
      return l && q.forEach(function(vh) {
        return t(m, vh);
      }), P && Qt(m, J), B;
    }
    function ol(m, o, h, z) {
      if (typeof h == "object" && h !== null && h.type === bl && h.key === null && (h = h.props.children), typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case el:
            l: {
              for (var B = h.key; o !== null; ) {
                if (o.key === B) {
                  if (B = h.type, B === bl) {
                    if (o.tag === 7) {
                      e(
                        m,
                        o.sibling
                      ), z = u(
                        o,
                        h.props.children
                      ), z.return = m, m = z;
                      break l;
                    }
                  } else if (o.elementType === B || typeof B == "object" && B !== null && B.$$typeof === yl && Ye(B) === o.type) {
                    e(
                      m,
                      o.sibling
                    ), z = u(o, h.props), Wa(z, h), z.return = m, m = z;
                    break l;
                  }
                  e(m, o);
                  break;
                } else t(m, o);
                o = o.sibling;
              }
              h.type === bl ? (z = Ue(
                h.props.children,
                m.mode,
                z,
                h.key
              ), z.return = m, m = z) : (z = wu(
                h.type,
                h.key,
                h.props,
                null,
                m.mode,
                z
              ), Wa(z, h), z.return = m, m = z);
            }
            return i(m);
          case Ol:
            l: {
              for (B = h.key; o !== null; ) {
                if (o.key === B)
                  if (o.tag === 4 && o.stateNode.containerInfo === h.containerInfo && o.stateNode.implementation === h.implementation) {
                    e(
                      m,
                      o.sibling
                    ), z = u(o, h.children || []), z.return = m, m = z;
                    break l;
                  } else {
                    e(m, o);
                    break;
                  }
                else t(m, o);
                o = o.sibling;
              }
              z = Di(h, m.mode, z), z.return = m, m = z;
            }
            return i(m);
          case yl:
            return h = Ye(h), ol(
              m,
              o,
              h,
              z
            );
        }
        if (Tt(h))
          return H(
            m,
            o,
            h,
            z
          );
        if (_l(h)) {
          if (B = _l(h), typeof B != "function") throw Error(r(150));
          return h = B.call(h), G(
            m,
            o,
            h,
            z
          );
        }
        if (typeof h.then == "function")
          return ol(
            m,
            o,
            ln(h),
            z
          );
        if (h.$$typeof === El)
          return ol(
            m,
            o,
            Wu(m, h),
            z
          );
        tn(m, h);
      }
      return typeof h == "string" && h !== "" || typeof h == "number" || typeof h == "bigint" ? (h = "" + h, o !== null && o.tag === 6 ? (e(m, o.sibling), z = u(o, h), z.return = m, m = z) : (e(m, o), z = Ri(h, m.mode, z), z.return = m, m = z), i(m)) : e(m, o);
    }
    return function(m, o, h, z) {
      try {
        ka = 0;
        var B = ol(
          m,
          o,
          h,
          z
        );
        return ma = null, B;
      } catch (q) {
        if (q === da || q === Iu) throw q;
        var ll = ft(29, q, null, m.mode);
        return ll.lanes = z, ll.return = m, ll;
      } finally {
      }
    };
  }
  var Qe = Ys(!0), Gs = Ys(!1), ce = !1;
  function Zi(l) {
    l.updateQueue = {
      baseState: l.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Vi(l, t) {
    l = l.updateQueue, t.updateQueue === l && (t.updateQueue = {
      baseState: l.baseState,
      firstBaseUpdate: l.firstBaseUpdate,
      lastBaseUpdate: l.lastBaseUpdate,
      shared: l.shared,
      callbacks: null
    });
  }
  function fe(l) {
    return { lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function se(l, t, e) {
    var a = l.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (al & 2) !== 0) {
      var u = a.pending;
      return u === null ? t.next = t : (t.next = u.next, u.next = t), a.pending = t, t = Ju(l), zs(l, null, e), t;
    }
    return Ku(l, a, t, e), Ju(l);
  }
  function Fa(l, t, e) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (e & 4194048) !== 0)) {
      var a = t.lanes;
      a &= l.pendingLanes, e |= a, t.lanes = e, Rf(l, e);
    }
  }
  function Ki(l, t) {
    var e = l.updateQueue, a = l.alternate;
    if (a !== null && (a = a.updateQueue, e === a)) {
      var u = null, n = null;
      if (e = e.firstBaseUpdate, e !== null) {
        do {
          var i = {
            lane: e.lane,
            tag: e.tag,
            payload: e.payload,
            callback: null,
            next: null
          };
          n === null ? u = n = i : n = n.next = i, e = e.next;
        } while (e !== null);
        n === null ? u = n = t : n = n.next = t;
      } else u = n = t;
      e = {
        baseState: a.baseState,
        firstBaseUpdate: u,
        lastBaseUpdate: n,
        shared: a.shared,
        callbacks: a.callbacks
      }, l.updateQueue = e;
      return;
    }
    l = e.lastBaseUpdate, l === null ? e.firstBaseUpdate = t : l.next = t, e.lastBaseUpdate = t;
  }
  var Ji = !1;
  function Ia() {
    if (Ji) {
      var l = ra;
      if (l !== null) throw l;
    }
  }
  function Pa(l, t, e, a) {
    Ji = !1;
    var u = l.updateQueue;
    ce = !1;
    var n = u.firstBaseUpdate, i = u.lastBaseUpdate, c = u.shared.pending;
    if (c !== null) {
      u.shared.pending = null;
      var s = c, y = s.next;
      s.next = null, i === null ? n = y : i.next = y, i = s;
      var b = l.alternate;
      b !== null && (b = b.updateQueue, c = b.lastBaseUpdate, c !== i && (c === null ? b.firstBaseUpdate = y : c.next = y, b.lastBaseUpdate = s));
    }
    if (n !== null) {
      var T = u.baseState;
      i = 0, b = y = s = null, c = n;
      do {
        var g = c.lane & -536870913, p = g !== c.lane;
        if (p ? (F & g) === g : (a & g) === g) {
          g !== 0 && g === oa && (Ji = !0), b !== null && (b = b.next = {
            lane: 0,
            tag: c.tag,
            payload: c.payload,
            callback: null,
            next: null
          });
          l: {
            var H = l, G = c;
            g = t;
            var ol = e;
            switch (G.tag) {
              case 1:
                if (H = G.payload, typeof H == "function") {
                  T = H.call(ol, T, g);
                  break l;
                }
                T = H;
                break l;
              case 3:
                H.flags = H.flags & -65537 | 128;
              case 0:
                if (H = G.payload, g = typeof H == "function" ? H.call(ol, T, g) : H, g == null) break l;
                T = U({}, T, g);
                break l;
              case 2:
                ce = !0;
            }
          }
          g = c.callback, g !== null && (l.flags |= 64, p && (l.flags |= 8192), p = u.callbacks, p === null ? u.callbacks = [g] : p.push(g));
        } else
          p = {
            lane: g,
            tag: c.tag,
            payload: c.payload,
            callback: c.callback,
            next: null
          }, b === null ? (y = b = p, s = T) : b = b.next = p, i |= g;
        if (c = c.next, c === null) {
          if (c = u.shared.pending, c === null)
            break;
          p = c, c = p.next, p.next = null, u.lastBaseUpdate = p, u.shared.pending = null;
        }
      } while (!0);
      b === null && (s = T), u.baseState = s, u.firstBaseUpdate = y, u.lastBaseUpdate = b, n === null && (u.shared.lanes = 0), ve |= i, l.lanes = i, l.memoizedState = T;
    }
  }
  function Qs(l, t) {
    if (typeof l != "function")
      throw Error(r(191, l));
    l.call(t);
  }
  function Xs(l, t) {
    var e = l.callbacks;
    if (e !== null)
      for (l.callbacks = null, l = 0; l < e.length; l++)
        Qs(e[l], t);
  }
  var va = d(null), en = d(0);
  function Ls(l, t) {
    l = Ft, D(en, l), D(va, t), Ft = l | t.baseLanes;
  }
  function wi() {
    D(en, Ft), D(va, va.current);
  }
  function $i() {
    Ft = en.current, j(va), j(en);
  }
  var st = d(null), zt = null;
  function oe(l) {
    var t = l.alternate;
    D(Tl, Tl.current & 1), D(st, l), zt === null && (t === null || va.current !== null || t.memoizedState !== null) && (zt = l);
  }
  function ki(l) {
    D(Tl, Tl.current), D(st, l), zt === null && (zt = l);
  }
  function Zs(l) {
    l.tag === 22 ? (D(Tl, Tl.current), D(st, l), zt === null && (zt = l)) : re();
  }
  function re() {
    D(Tl, Tl.current), D(st, st.current);
  }
  function ot(l) {
    j(st), zt === l && (zt = null), j(Tl);
  }
  var Tl = d(0);
  function an(l) {
    for (var t = l; t !== null; ) {
      if (t.tag === 13) {
        var e = t.memoizedState;
        if (e !== null && (e = e.dehydrated, e === null || tf(e) || ef(e)))
          return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === l) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === l) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var Zt = 0, K = null, fl = null, Dl = null, un = !1, ha = !1, Xe = !1, nn = 0, lu = 0, ya = null, uv = 0;
  function xl() {
    throw Error(r(321));
  }
  function Wi(l, t) {
    if (t === null) return !1;
    for (var e = 0; e < t.length && e < l.length; e++)
      if (!ct(l[e], t[e])) return !1;
    return !0;
  }
  function Fi(l, t, e, a, u, n) {
    return Zt = n, K = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, x.H = l === null || l.memoizedState === null ? Oo : dc, Xe = !1, n = e(a, u), Xe = !1, ha && (n = Ks(
      t,
      e,
      a,
      u
    )), Vs(l), n;
  }
  function Vs(l) {
    x.H = au;
    var t = fl !== null && fl.next !== null;
    if (Zt = 0, Dl = fl = K = null, un = !1, lu = 0, ya = null, t) throw Error(r(300));
    l === null || Nl || (l = l.dependencies, l !== null && ku(l) && (Nl = !0));
  }
  function Ks(l, t, e, a) {
    K = l;
    var u = 0;
    do {
      if (ha && (ya = null), lu = 0, ha = !1, 25 <= u) throw Error(r(301));
      if (u += 1, Dl = fl = null, l.updateQueue != null) {
        var n = l.updateQueue;
        n.lastEffect = null, n.events = null, n.stores = null, n.memoCache != null && (n.memoCache.index = 0);
      }
      x.H = Mo, n = t(e, a);
    } while (ha);
    return n;
  }
  function nv() {
    var l = x.H, t = l.useState()[0];
    return t = typeof t.then == "function" ? tu(t) : t, l = l.useState()[0], (fl !== null ? fl.memoizedState : null) !== l && (K.flags |= 1024), t;
  }
  function Ii() {
    var l = nn !== 0;
    return nn = 0, l;
  }
  function Pi(l, t, e) {
    t.updateQueue = l.updateQueue, t.flags &= -2053, l.lanes &= ~e;
  }
  function lc(l) {
    if (un) {
      for (l = l.memoizedState; l !== null; ) {
        var t = l.queue;
        t !== null && (t.pending = null), l = l.next;
      }
      un = !1;
    }
    Zt = 0, Dl = fl = K = null, ha = !1, lu = nn = 0, ya = null;
  }
  function Wl() {
    var l = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Dl === null ? K.memoizedState = Dl = l : Dl = Dl.next = l, Dl;
  }
  function jl() {
    if (fl === null) {
      var l = K.alternate;
      l = l !== null ? l.memoizedState : null;
    } else l = fl.next;
    var t = Dl === null ? K.memoizedState : Dl.next;
    if (t !== null)
      Dl = t, fl = l;
    else {
      if (l === null)
        throw K.alternate === null ? Error(r(467)) : Error(r(310));
      fl = l, l = {
        memoizedState: fl.memoizedState,
        baseState: fl.baseState,
        baseQueue: fl.baseQueue,
        queue: fl.queue,
        next: null
      }, Dl === null ? K.memoizedState = Dl = l : Dl = Dl.next = l;
    }
    return Dl;
  }
  function cn() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function tu(l) {
    var t = lu;
    return lu += 1, ya === null && (ya = []), l = Cs(ya, l, t), t = K, (Dl === null ? t.memoizedState : Dl.next) === null && (t = t.alternate, x.H = t === null || t.memoizedState === null ? Oo : dc), l;
  }
  function fn(l) {
    if (l !== null && typeof l == "object") {
      if (typeof l.then == "function") return tu(l);
      if (l.$$typeof === El) return Ll(l);
    }
    throw Error(r(438, String(l)));
  }
  function tc(l) {
    var t = null, e = K.updateQueue;
    if (e !== null && (t = e.memoCache), t == null) {
      var a = K.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (t = {
        data: a.data.map(function(u) {
          return u.slice();
        }),
        index: 0
      })));
    }
    if (t == null && (t = { data: [], index: 0 }), e === null && (e = cn(), K.updateQueue = e), e.memoCache = t, e = t.data[t.index], e === void 0)
      for (e = t.data[t.index] = Array(l), a = 0; a < l; a++)
        e[a] = Rt;
    return t.index++, e;
  }
  function Vt(l, t) {
    return typeof t == "function" ? t(l) : t;
  }
  function sn(l) {
    var t = jl();
    return ec(t, fl, l);
  }
  function ec(l, t, e) {
    var a = l.queue;
    if (a === null) throw Error(r(311));
    a.lastRenderedReducer = e;
    var u = l.baseQueue, n = a.pending;
    if (n !== null) {
      if (u !== null) {
        var i = u.next;
        u.next = n.next, n.next = i;
      }
      t.baseQueue = u = n, a.pending = null;
    }
    if (n = l.baseState, u === null) l.memoizedState = n;
    else {
      t = u.next;
      var c = i = null, s = null, y = t, b = !1;
      do {
        var T = y.lane & -536870913;
        if (T !== y.lane ? (F & T) === T : (Zt & T) === T) {
          var g = y.revertLane;
          if (g === 0)
            s !== null && (s = s.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: y.action,
              hasEagerState: y.hasEagerState,
              eagerState: y.eagerState,
              next: null
            }), T === oa && (b = !0);
          else if ((Zt & g) === g) {
            y = y.next, g === oa && (b = !0);
            continue;
          } else
            T = {
              lane: 0,
              revertLane: y.revertLane,
              gesture: null,
              action: y.action,
              hasEagerState: y.hasEagerState,
              eagerState: y.eagerState,
              next: null
            }, s === null ? (c = s = T, i = n) : s = s.next = T, K.lanes |= g, ve |= g;
          T = y.action, Xe && e(n, T), n = y.hasEagerState ? y.eagerState : e(n, T);
        } else
          g = {
            lane: T,
            revertLane: y.revertLane,
            gesture: y.gesture,
            action: y.action,
            hasEagerState: y.hasEagerState,
            eagerState: y.eagerState,
            next: null
          }, s === null ? (c = s = g, i = n) : s = s.next = g, K.lanes |= T, ve |= T;
        y = y.next;
      } while (y !== null && y !== t);
      if (s === null ? i = n : s.next = c, !ct(n, l.memoizedState) && (Nl = !0, b && (e = ra, e !== null)))
        throw e;
      l.memoizedState = n, l.baseState = i, l.baseQueue = s, a.lastRenderedState = n;
    }
    return u === null && (a.lanes = 0), [l.memoizedState, a.dispatch];
  }
  function ac(l) {
    var t = jl(), e = t.queue;
    if (e === null) throw Error(r(311));
    e.lastRenderedReducer = l;
    var a = e.dispatch, u = e.pending, n = t.memoizedState;
    if (u !== null) {
      e.pending = null;
      var i = u = u.next;
      do
        n = l(n, i.action), i = i.next;
      while (i !== u);
      ct(n, t.memoizedState) || (Nl = !0), t.memoizedState = n, t.baseQueue === null && (t.baseState = n), e.lastRenderedState = n;
    }
    return [n, a];
  }
  function Js(l, t, e) {
    var a = K, u = jl(), n = P;
    if (n) {
      if (e === void 0) throw Error(r(407));
      e = e();
    } else e = t();
    var i = !ct(
      (fl || u).memoizedState,
      e
    );
    if (i && (u.memoizedState = e, Nl = !0), u = u.queue, ic(ks.bind(null, a, u, l), [
      l
    ]), u.getSnapshot !== t || i || Dl !== null && Dl.memoizedState.tag & 1) {
      if (a.flags |= 2048, ga(
        9,
        { destroy: void 0 },
        $s.bind(
          null,
          a,
          u,
          e,
          t
        ),
        null
      ), ml === null) throw Error(r(349));
      n || (Zt & 127) !== 0 || ws(a, t, e);
    }
    return e;
  }
  function ws(l, t, e) {
    l.flags |= 16384, l = { getSnapshot: t, value: e }, t = K.updateQueue, t === null ? (t = cn(), K.updateQueue = t, t.stores = [l]) : (e = t.stores, e === null ? t.stores = [l] : e.push(l));
  }
  function $s(l, t, e, a) {
    t.value = e, t.getSnapshot = a, Ws(t) && Fs(l);
  }
  function ks(l, t, e) {
    return e(function() {
      Ws(t) && Fs(l);
    });
  }
  function Ws(l) {
    var t = l.getSnapshot;
    l = l.value;
    try {
      var e = t();
      return !ct(l, e);
    } catch {
      return !0;
    }
  }
  function Fs(l) {
    var t = Ne(l, 2);
    t !== null && at(t, l, 2);
  }
  function uc(l) {
    var t = Wl();
    if (typeof l == "function") {
      var e = l;
      if (l = e(), Xe) {
        le(!0);
        try {
          e();
        } finally {
          le(!1);
        }
      }
    }
    return t.memoizedState = t.baseState = l, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Vt,
      lastRenderedState: l
    }, t;
  }
  function Is(l, t, e, a) {
    return l.baseState = e, ec(
      l,
      fl,
      typeof a == "function" ? a : Vt
    );
  }
  function iv(l, t, e, a, u) {
    if (dn(l)) throw Error(r(485));
    if (l = t.action, l !== null) {
      var n = {
        payload: u,
        action: l,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(i) {
          n.listeners.push(i);
        }
      };
      x.T !== null ? e(!0) : n.isTransition = !1, a(n), e = t.pending, e === null ? (n.next = t.pending = n, Ps(t, n)) : (n.next = e.next, t.pending = e.next = n);
    }
  }
  function Ps(l, t) {
    var e = t.action, a = t.payload, u = l.state;
    if (t.isTransition) {
      var n = x.T, i = {};
      x.T = i;
      try {
        var c = e(u, a), s = x.S;
        s !== null && s(i, c), lo(l, t, c);
      } catch (y) {
        nc(l, t, y);
      } finally {
        n !== null && i.types !== null && (n.types = i.types), x.T = n;
      }
    } else
      try {
        n = e(u, a), lo(l, t, n);
      } catch (y) {
        nc(l, t, y);
      }
  }
  function lo(l, t, e) {
    e !== null && typeof e == "object" && typeof e.then == "function" ? e.then(
      function(a) {
        to(l, t, a);
      },
      function(a) {
        return nc(l, t, a);
      }
    ) : to(l, t, e);
  }
  function to(l, t, e) {
    t.status = "fulfilled", t.value = e, eo(t), l.state = e, t = l.pending, t !== null && (e = t.next, e === t ? l.pending = null : (e = e.next, t.next = e, Ps(l, e)));
  }
  function nc(l, t, e) {
    var a = l.pending;
    if (l.pending = null, a !== null) {
      a = a.next;
      do
        t.status = "rejected", t.reason = e, eo(t), t = t.next;
      while (t !== a);
    }
    l.action = null;
  }
  function eo(l) {
    l = l.listeners;
    for (var t = 0; t < l.length; t++) (0, l[t])();
  }
  function ao(l, t) {
    return t;
  }
  function uo(l, t) {
    if (P) {
      var e = ml.formState;
      if (e !== null) {
        l: {
          var a = K;
          if (P) {
            if (vl) {
              t: {
                for (var u = vl, n = xt; u.nodeType !== 8; ) {
                  if (!n) {
                    u = null;
                    break t;
                  }
                  if (u = Et(
                    u.nextSibling
                  ), u === null) {
                    u = null;
                    break t;
                  }
                }
                n = u.data, u = n === "F!" || n === "F" ? u : null;
              }
              if (u) {
                vl = Et(
                  u.nextSibling
                ), a = u.data === "F!";
                break l;
              }
            }
            ne(a);
          }
          a = !1;
        }
        a && (t = e[0]);
      }
    }
    return e = Wl(), e.memoizedState = e.baseState = t, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: ao,
      lastRenderedState: t
    }, e.queue = a, e = Ao.bind(
      null,
      K,
      a
    ), a.dispatch = e, a = uc(!1), n = rc.bind(
      null,
      K,
      !1,
      a.queue
    ), a = Wl(), u = {
      state: t,
      dispatch: null,
      action: l,
      pending: null
    }, a.queue = u, e = iv.bind(
      null,
      K,
      u,
      n,
      e
    ), u.dispatch = e, a.memoizedState = l, [t, e, !1];
  }
  function no(l) {
    var t = jl();
    return io(t, fl, l);
  }
  function io(l, t, e) {
    if (t = ec(
      l,
      t,
      ao
    )[0], l = sn(Vt)[0], typeof t == "object" && t !== null && typeof t.then == "function")
      try {
        var a = tu(t);
      } catch (i) {
        throw i === da ? Iu : i;
      }
    else a = t;
    t = jl();
    var u = t.queue, n = u.dispatch;
    return e !== t.memoizedState && (K.flags |= 2048, ga(
      9,
      { destroy: void 0 },
      cv.bind(null, u, e),
      null
    )), [a, n, l];
  }
  function cv(l, t) {
    l.action = t;
  }
  function co(l) {
    var t = jl(), e = fl;
    if (e !== null)
      return io(t, e, l);
    jl(), t = t.memoizedState, e = jl();
    var a = e.queue.dispatch;
    return e.memoizedState = l, [t, a, !1];
  }
  function ga(l, t, e, a) {
    return l = { tag: l, create: e, deps: a, inst: t, next: null }, t = K.updateQueue, t === null && (t = cn(), K.updateQueue = t), e = t.lastEffect, e === null ? t.lastEffect = l.next = l : (a = e.next, e.next = l, l.next = a, t.lastEffect = l), l;
  }
  function fo() {
    return jl().memoizedState;
  }
  function on(l, t, e, a) {
    var u = Wl();
    K.flags |= l, u.memoizedState = ga(
      1 | t,
      { destroy: void 0 },
      e,
      a === void 0 ? null : a
    );
  }
  function rn(l, t, e, a) {
    var u = jl();
    a = a === void 0 ? null : a;
    var n = u.memoizedState.inst;
    fl !== null && a !== null && Wi(a, fl.memoizedState.deps) ? u.memoizedState = ga(t, n, e, a) : (K.flags |= l, u.memoizedState = ga(
      1 | t,
      n,
      e,
      a
    ));
  }
  function so(l, t) {
    on(8390656, 8, l, t);
  }
  function ic(l, t) {
    rn(2048, 8, l, t);
  }
  function fv(l) {
    K.flags |= 4;
    var t = K.updateQueue;
    if (t === null)
      t = cn(), K.updateQueue = t, t.events = [l];
    else {
      var e = t.events;
      e === null ? t.events = [l] : e.push(l);
    }
  }
  function oo(l) {
    var t = jl().memoizedState;
    return fv({ ref: t, nextImpl: l }), function() {
      if ((al & 2) !== 0) throw Error(r(440));
      return t.impl.apply(void 0, arguments);
    };
  }
  function ro(l, t) {
    return rn(4, 2, l, t);
  }
  function mo(l, t) {
    return rn(4, 4, l, t);
  }
  function vo(l, t) {
    if (typeof t == "function") {
      l = l();
      var e = t(l);
      return function() {
        typeof e == "function" ? e() : t(null);
      };
    }
    if (t != null)
      return l = l(), t.current = l, function() {
        t.current = null;
      };
  }
  function ho(l, t, e) {
    e = e != null ? e.concat([l]) : null, rn(4, 4, vo.bind(null, t, l), e);
  }
  function cc() {
  }
  function yo(l, t) {
    var e = jl();
    t = t === void 0 ? null : t;
    var a = e.memoizedState;
    return t !== null && Wi(t, a[1]) ? a[0] : (e.memoizedState = [l, t], l);
  }
  function go(l, t) {
    var e = jl();
    t = t === void 0 ? null : t;
    var a = e.memoizedState;
    if (t !== null && Wi(t, a[1]))
      return a[0];
    if (a = l(), Xe) {
      le(!0);
      try {
        l();
      } finally {
        le(!1);
      }
    }
    return e.memoizedState = [a, t], a;
  }
  function fc(l, t, e) {
    return e === void 0 || (Zt & 1073741824) !== 0 && (F & 261930) === 0 ? l.memoizedState = t : (l.memoizedState = e, l = pr(), K.lanes |= l, ve |= l, e);
  }
  function po(l, t, e, a) {
    return ct(e, t) ? e : va.current !== null ? (l = fc(l, e, a), ct(l, t) || (Nl = !0), l) : (Zt & 42) === 0 || (Zt & 1073741824) !== 0 && (F & 261930) === 0 ? (Nl = !0, l.memoizedState = e) : (l = pr(), K.lanes |= l, ve |= l, t);
  }
  function bo(l, t, e, a, u) {
    var n = R.p;
    R.p = n !== 0 && 8 > n ? n : 8;
    var i = x.T, c = {};
    x.T = c, rc(l, !1, t, e);
    try {
      var s = u(), y = x.S;
      if (y !== null && y(c, s), s !== null && typeof s == "object" && typeof s.then == "function") {
        var b = av(
          s,
          a
        );
        eu(
          l,
          t,
          b,
          mt(l)
        );
      } else
        eu(
          l,
          t,
          a,
          mt(l)
        );
    } catch (T) {
      eu(
        l,
        t,
        { then: function() {
        }, status: "rejected", reason: T },
        mt()
      );
    } finally {
      R.p = n, i !== null && c.types !== null && (i.types = c.types), x.T = i;
    }
  }
  function sv() {
  }
  function sc(l, t, e, a) {
    if (l.tag !== 5) throw Error(r(476));
    var u = So(l).queue;
    bo(
      l,
      u,
      t,
      X,
      e === null ? sv : function() {
        return xo(l), e(a);
      }
    );
  }
  function So(l) {
    var t = l.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: X,
      baseState: X,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vt,
        lastRenderedState: X
      },
      next: null
    };
    var e = {};
    return t.next = {
      memoizedState: e,
      baseState: e,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vt,
        lastRenderedState: e
      },
      next: null
    }, l.memoizedState = t, l = l.alternate, l !== null && (l.memoizedState = t), t;
  }
  function xo(l) {
    var t = So(l);
    t.next === null && (t = l.alternate.memoizedState), eu(
      l,
      t.next.queue,
      {},
      mt()
    );
  }
  function oc() {
    return Ll(bu);
  }
  function zo() {
    return jl().memoizedState;
  }
  function Eo() {
    return jl().memoizedState;
  }
  function ov(l) {
    for (var t = l.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var e = mt();
          l = fe(e);
          var a = se(t, l, e);
          a !== null && (at(a, t, e), Fa(a, t, e)), t = { cache: Gi() }, l.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function rv(l, t, e) {
    var a = mt();
    e = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, dn(l) ? To(t, e) : (e = Mi(l, t, e, a), e !== null && (at(e, l, a), jo(e, t, a)));
  }
  function Ao(l, t, e) {
    var a = mt();
    eu(l, t, e, a);
  }
  function eu(l, t, e, a) {
    var u = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (dn(l)) To(t, u);
    else {
      var n = l.alternate;
      if (l.lanes === 0 && (n === null || n.lanes === 0) && (n = t.lastRenderedReducer, n !== null))
        try {
          var i = t.lastRenderedState, c = n(i, e);
          if (u.hasEagerState = !0, u.eagerState = c, ct(c, i))
            return Ku(l, t, u, 0), ml === null && Vu(), !1;
        } catch {
        } finally {
        }
      if (e = Mi(l, t, u, a), e !== null)
        return at(e, l, a), jo(e, t, a), !0;
    }
    return !1;
  }
  function rc(l, t, e, a) {
    if (a = {
      lane: 2,
      revertLane: Zc(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, dn(l)) {
      if (t) throw Error(r(479));
    } else
      t = Mi(
        l,
        e,
        a,
        2
      ), t !== null && at(t, l, 2);
  }
  function dn(l) {
    var t = l.alternate;
    return l === K || t !== null && t === K;
  }
  function To(l, t) {
    ha = un = !0;
    var e = l.pending;
    e === null ? t.next = t : (t.next = e.next, e.next = t), l.pending = t;
  }
  function jo(l, t, e) {
    if ((e & 4194048) !== 0) {
      var a = t.lanes;
      a &= l.pendingLanes, e |= a, t.lanes = e, Rf(l, e);
    }
  }
  var au = {
    readContext: Ll,
    use: fn,
    useCallback: xl,
    useContext: xl,
    useEffect: xl,
    useImperativeHandle: xl,
    useLayoutEffect: xl,
    useInsertionEffect: xl,
    useMemo: xl,
    useReducer: xl,
    useRef: xl,
    useState: xl,
    useDebugValue: xl,
    useDeferredValue: xl,
    useTransition: xl,
    useSyncExternalStore: xl,
    useId: xl,
    useHostTransitionStatus: xl,
    useFormState: xl,
    useActionState: xl,
    useOptimistic: xl,
    useMemoCache: xl,
    useCacheRefresh: xl
  };
  au.useEffectEvent = xl;
  var Oo = {
    readContext: Ll,
    use: fn,
    useCallback: function(l, t) {
      return Wl().memoizedState = [
        l,
        t === void 0 ? null : t
      ], l;
    },
    useContext: Ll,
    useEffect: so,
    useImperativeHandle: function(l, t, e) {
      e = e != null ? e.concat([l]) : null, on(
        4194308,
        4,
        vo.bind(null, t, l),
        e
      );
    },
    useLayoutEffect: function(l, t) {
      return on(4194308, 4, l, t);
    },
    useInsertionEffect: function(l, t) {
      on(4, 2, l, t);
    },
    useMemo: function(l, t) {
      var e = Wl();
      t = t === void 0 ? null : t;
      var a = l();
      if (Xe) {
        le(!0);
        try {
          l();
        } finally {
          le(!1);
        }
      }
      return e.memoizedState = [a, t], a;
    },
    useReducer: function(l, t, e) {
      var a = Wl();
      if (e !== void 0) {
        var u = e(t);
        if (Xe) {
          le(!0);
          try {
            e(t);
          } finally {
            le(!1);
          }
        }
      } else u = t;
      return a.memoizedState = a.baseState = u, l = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: u
      }, a.queue = l, l = l.dispatch = rv.bind(
        null,
        K,
        l
      ), [a.memoizedState, l];
    },
    useRef: function(l) {
      var t = Wl();
      return l = { current: l }, t.memoizedState = l;
    },
    useState: function(l) {
      l = uc(l);
      var t = l.queue, e = Ao.bind(null, K, t);
      return t.dispatch = e, [l.memoizedState, e];
    },
    useDebugValue: cc,
    useDeferredValue: function(l, t) {
      var e = Wl();
      return fc(e, l, t);
    },
    useTransition: function() {
      var l = uc(!1);
      return l = bo.bind(
        null,
        K,
        l.queue,
        !0,
        !1
      ), Wl().memoizedState = l, [!1, l];
    },
    useSyncExternalStore: function(l, t, e) {
      var a = K, u = Wl();
      if (P) {
        if (e === void 0)
          throw Error(r(407));
        e = e();
      } else {
        if (e = t(), ml === null)
          throw Error(r(349));
        (F & 127) !== 0 || ws(a, t, e);
      }
      u.memoizedState = e;
      var n = { value: e, getSnapshot: t };
      return u.queue = n, so(ks.bind(null, a, n, l), [
        l
      ]), a.flags |= 2048, ga(
        9,
        { destroy: void 0 },
        $s.bind(
          null,
          a,
          n,
          e,
          t
        ),
        null
      ), e;
    },
    useId: function() {
      var l = Wl(), t = ml.identifierPrefix;
      if (P) {
        var e = Ut, a = Nt;
        e = (a & ~(1 << 32 - it(a) - 1)).toString(32) + e, t = "_" + t + "R_" + e, e = nn++, 0 < e && (t += "H" + e.toString(32)), t += "_";
      } else
        e = uv++, t = "_" + t + "r_" + e.toString(32) + "_";
      return l.memoizedState = t;
    },
    useHostTransitionStatus: oc,
    useFormState: uo,
    useActionState: uo,
    useOptimistic: function(l) {
      var t = Wl();
      t.memoizedState = t.baseState = l;
      var e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = e, t = rc.bind(
        null,
        K,
        !0,
        e
      ), e.dispatch = t, [l, t];
    },
    useMemoCache: tc,
    useCacheRefresh: function() {
      return Wl().memoizedState = ov.bind(
        null,
        K
      );
    },
    useEffectEvent: function(l) {
      var t = Wl(), e = { impl: l };
      return t.memoizedState = e, function() {
        if ((al & 2) !== 0)
          throw Error(r(440));
        return e.impl.apply(void 0, arguments);
      };
    }
  }, dc = {
    readContext: Ll,
    use: fn,
    useCallback: yo,
    useContext: Ll,
    useEffect: ic,
    useImperativeHandle: ho,
    useInsertionEffect: ro,
    useLayoutEffect: mo,
    useMemo: go,
    useReducer: sn,
    useRef: fo,
    useState: function() {
      return sn(Vt);
    },
    useDebugValue: cc,
    useDeferredValue: function(l, t) {
      var e = jl();
      return po(
        e,
        fl.memoizedState,
        l,
        t
      );
    },
    useTransition: function() {
      var l = sn(Vt)[0], t = jl().memoizedState;
      return [
        typeof l == "boolean" ? l : tu(l),
        t
      ];
    },
    useSyncExternalStore: Js,
    useId: zo,
    useHostTransitionStatus: oc,
    useFormState: no,
    useActionState: no,
    useOptimistic: function(l, t) {
      var e = jl();
      return Is(e, fl, l, t);
    },
    useMemoCache: tc,
    useCacheRefresh: Eo
  };
  dc.useEffectEvent = oo;
  var Mo = {
    readContext: Ll,
    use: fn,
    useCallback: yo,
    useContext: Ll,
    useEffect: ic,
    useImperativeHandle: ho,
    useInsertionEffect: ro,
    useLayoutEffect: mo,
    useMemo: go,
    useReducer: ac,
    useRef: fo,
    useState: function() {
      return ac(Vt);
    },
    useDebugValue: cc,
    useDeferredValue: function(l, t) {
      var e = jl();
      return fl === null ? fc(e, l, t) : po(
        e,
        fl.memoizedState,
        l,
        t
      );
    },
    useTransition: function() {
      var l = ac(Vt)[0], t = jl().memoizedState;
      return [
        typeof l == "boolean" ? l : tu(l),
        t
      ];
    },
    useSyncExternalStore: Js,
    useId: zo,
    useHostTransitionStatus: oc,
    useFormState: co,
    useActionState: co,
    useOptimistic: function(l, t) {
      var e = jl();
      return fl !== null ? Is(e, fl, l, t) : (e.baseState = l, [l, e.queue.dispatch]);
    },
    useMemoCache: tc,
    useCacheRefresh: Eo
  };
  Mo.useEffectEvent = oo;
  function mc(l, t, e, a) {
    t = l.memoizedState, e = e(a, t), e = e == null ? t : U({}, t, e), l.memoizedState = e, l.lanes === 0 && (l.updateQueue.baseState = e);
  }
  var vc = {
    enqueueSetState: function(l, t, e) {
      l = l._reactInternals;
      var a = mt(), u = fe(a);
      u.payload = t, e != null && (u.callback = e), t = se(l, u, a), t !== null && (at(t, l, a), Fa(t, l, a));
    },
    enqueueReplaceState: function(l, t, e) {
      l = l._reactInternals;
      var a = mt(), u = fe(a);
      u.tag = 1, u.payload = t, e != null && (u.callback = e), t = se(l, u, a), t !== null && (at(t, l, a), Fa(t, l, a));
    },
    enqueueForceUpdate: function(l, t) {
      l = l._reactInternals;
      var e = mt(), a = fe(e);
      a.tag = 2, t != null && (a.callback = t), t = se(l, a, e), t !== null && (at(t, l, e), Fa(t, l, e));
    }
  };
  function _o(l, t, e, a, u, n, i) {
    return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(a, n, i) : t.prototype && t.prototype.isPureReactComponent ? !Za(e, a) || !Za(u, n) : !0;
  }
  function Ro(l, t, e, a) {
    l = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(e, a), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(e, a), t.state !== l && vc.enqueueReplaceState(t, t.state, null);
  }
  function Le(l, t) {
    var e = t;
    if ("ref" in t) {
      e = {};
      for (var a in t)
        a !== "ref" && (e[a] = t[a]);
    }
    if (l = l.defaultProps) {
      e === t && (e = U({}, e));
      for (var u in l)
        e[u] === void 0 && (e[u] = l[u]);
    }
    return e;
  }
  function Do(l) {
    Zu(l);
  }
  function No(l) {
    console.error(l);
  }
  function Uo(l) {
    Zu(l);
  }
  function mn(l, t) {
    try {
      var e = l.onUncaughtError;
      e(t.value, { componentStack: t.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function Ho(l, t, e) {
    try {
      var a = l.onCaughtError;
      a(e.value, {
        componentStack: e.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (u) {
      setTimeout(function() {
        throw u;
      });
    }
  }
  function hc(l, t, e) {
    return e = fe(e), e.tag = 3, e.payload = { element: null }, e.callback = function() {
      mn(l, t);
    }, e;
  }
  function Co(l) {
    return l = fe(l), l.tag = 3, l;
  }
  function qo(l, t, e, a) {
    var u = e.type.getDerivedStateFromError;
    if (typeof u == "function") {
      var n = a.value;
      l.payload = function() {
        return u(n);
      }, l.callback = function() {
        Ho(t, e, a);
      };
    }
    var i = e.stateNode;
    i !== null && typeof i.componentDidCatch == "function" && (l.callback = function() {
      Ho(t, e, a), typeof u != "function" && (he === null ? he = /* @__PURE__ */ new Set([this]) : he.add(this));
      var c = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: c !== null ? c : ""
      });
    });
  }
  function dv(l, t, e, a, u) {
    if (e.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (t = e.alternate, t !== null && sa(
        t,
        e,
        u,
        !0
      ), e = st.current, e !== null) {
        switch (e.tag) {
          case 31:
          case 13:
            return zt === null ? Tn() : e.alternate === null && zl === 0 && (zl = 3), e.flags &= -257, e.flags |= 65536, e.lanes = u, a === Pu ? e.flags |= 16384 : (t = e.updateQueue, t === null ? e.updateQueue = /* @__PURE__ */ new Set([a]) : t.add(a), Qc(l, a, u)), !1;
          case 22:
            return e.flags |= 65536, a === Pu ? e.flags |= 16384 : (t = e.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, e.updateQueue = t) : (e = t.retryQueue, e === null ? t.retryQueue = /* @__PURE__ */ new Set([a]) : e.add(a)), Qc(l, a, u)), !1;
        }
        throw Error(r(435, e.tag));
      }
      return Qc(l, a, u), Tn(), !1;
    }
    if (P)
      return t = st.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = u, a !== Hi && (l = Error(r(422), { cause: a }), Ja(pt(l, e)))) : (a !== Hi && (t = Error(r(423), {
        cause: a
      }), Ja(
        pt(t, e)
      )), l = l.current.alternate, l.flags |= 65536, u &= -u, l.lanes |= u, a = pt(a, e), u = hc(
        l.stateNode,
        a,
        u
      ), Ki(l, u), zl !== 4 && (zl = 2)), !1;
    var n = Error(r(520), { cause: a });
    if (n = pt(n, e), ru === null ? ru = [n] : ru.push(n), zl !== 4 && (zl = 2), t === null) return !0;
    a = pt(a, e), e = t;
    do {
      switch (e.tag) {
        case 3:
          return e.flags |= 65536, l = u & -u, e.lanes |= l, l = hc(e.stateNode, a, l), Ki(e, l), !1;
        case 1:
          if (t = e.type, n = e.stateNode, (e.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || n !== null && typeof n.componentDidCatch == "function" && (he === null || !he.has(n))))
            return e.flags |= 65536, u &= -u, e.lanes |= u, u = Co(u), qo(
              u,
              l,
              e,
              a
            ), Ki(e, u), !1;
      }
      e = e.return;
    } while (e !== null);
    return !1;
  }
  var yc = Error(r(461)), Nl = !1;
  function Zl(l, t, e, a) {
    t.child = l === null ? Gs(t, null, e, a) : Qe(
      t,
      l.child,
      e,
      a
    );
  }
  function Bo(l, t, e, a, u) {
    e = e.render;
    var n = t.ref;
    if ("ref" in a) {
      var i = {};
      for (var c in a)
        c !== "ref" && (i[c] = a[c]);
    } else i = a;
    return qe(t), a = Fi(
      l,
      t,
      e,
      i,
      n,
      u
    ), c = Ii(), l !== null && !Nl ? (Pi(l, t, u), Kt(l, t, u)) : (P && c && Ni(t), t.flags |= 1, Zl(l, t, a, u), t.child);
  }
  function Yo(l, t, e, a, u) {
    if (l === null) {
      var n = e.type;
      return typeof n == "function" && !_i(n) && n.defaultProps === void 0 && e.compare === null ? (t.tag = 15, t.type = n, Go(
        l,
        t,
        n,
        a,
        u
      )) : (l = wu(
        e.type,
        null,
        a,
        t,
        t.mode,
        u
      ), l.ref = t.ref, l.return = t, t.child = l);
    }
    if (n = l.child, !Ac(l, u)) {
      var i = n.memoizedProps;
      if (e = e.compare, e = e !== null ? e : Za, e(i, a) && l.ref === t.ref)
        return Kt(l, t, u);
    }
    return t.flags |= 1, l = Gt(n, a), l.ref = t.ref, l.return = t, t.child = l;
  }
  function Go(l, t, e, a, u) {
    if (l !== null) {
      var n = l.memoizedProps;
      if (Za(n, a) && l.ref === t.ref)
        if (Nl = !1, t.pendingProps = a = n, Ac(l, u))
          (l.flags & 131072) !== 0 && (Nl = !0);
        else
          return t.lanes = l.lanes, Kt(l, t, u);
    }
    return gc(
      l,
      t,
      e,
      a,
      u
    );
  }
  function Qo(l, t, e, a) {
    var u = a.children, n = l !== null ? l.memoizedState : null;
    if (l === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((t.flags & 128) !== 0) {
        if (n = n !== null ? n.baseLanes | e : e, l !== null) {
          for (a = t.child = l.child, u = 0; a !== null; )
            u = u | a.lanes | a.childLanes, a = a.sibling;
          a = u & ~n;
        } else a = 0, t.child = null;
        return Xo(
          l,
          t,
          n,
          e,
          a
        );
      }
      if ((e & 536870912) !== 0)
        t.memoizedState = { baseLanes: 0, cachePool: null }, l !== null && Fu(
          t,
          n !== null ? n.cachePool : null
        ), n !== null ? Ls(t, n) : wi(), Zs(t);
      else
        return a = t.lanes = 536870912, Xo(
          l,
          t,
          n !== null ? n.baseLanes | e : e,
          e,
          a
        );
    } else
      n !== null ? (Fu(t, n.cachePool), Ls(t, n), re(), t.memoizedState = null) : (l !== null && Fu(t, null), wi(), re());
    return Zl(l, t, u, e), t.child;
  }
  function uu(l, t) {
    return l !== null && l.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling;
  }
  function Xo(l, t, e, a, u) {
    var n = Xi();
    return n = n === null ? null : { parent: Rl._currentValue, pool: n }, t.memoizedState = {
      baseLanes: e,
      cachePool: n
    }, l !== null && Fu(t, null), wi(), Zs(t), l !== null && sa(l, t, a, !0), t.childLanes = u, null;
  }
  function vn(l, t) {
    return t = yn(
      { mode: t.mode, children: t.children },
      l.mode
    ), t.ref = l.ref, l.child = t, t.return = l, t;
  }
  function Lo(l, t, e) {
    return Qe(t, l.child, null, e), l = vn(t, t.pendingProps), l.flags |= 2, ot(t), t.memoizedState = null, l;
  }
  function mv(l, t, e) {
    var a = t.pendingProps, u = (t.flags & 128) !== 0;
    if (t.flags &= -129, l === null) {
      if (P) {
        if (a.mode === "hidden")
          return l = vn(t, a), t.lanes = 536870912, uu(null, l);
        if (ki(t), (l = vl) ? (l = ld(
          l,
          xt
        ), l = l !== null && l.data === "&" ? l : null, l !== null && (t.memoizedState = {
          dehydrated: l,
          treeContext: ae !== null ? { id: Nt, overflow: Ut } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = As(l), e.return = t, t.child = e, Xl = t, vl = null)) : l = null, l === null) throw ne(t);
        return t.lanes = 536870912, null;
      }
      return vn(t, a);
    }
    var n = l.memoizedState;
    if (n !== null) {
      var i = n.dehydrated;
      if (ki(t), u)
        if (t.flags & 256)
          t.flags &= -257, t = Lo(
            l,
            t,
            e
          );
        else if (t.memoizedState !== null)
          t.child = l.child, t.flags |= 128, t = null;
        else throw Error(r(558));
      else if (Nl || sa(l, t, e, !1), u = (e & l.childLanes) !== 0, Nl || u) {
        if (a = ml, a !== null && (i = Df(a, e), i !== 0 && i !== n.retryLane))
          throw n.retryLane = i, Ne(l, i), at(a, l, i), yc;
        Tn(), t = Lo(
          l,
          t,
          e
        );
      } else
        l = n.treeContext, vl = Et(i.nextSibling), Xl = t, P = !0, ue = null, xt = !1, l !== null && Os(t, l), t = vn(t, a), t.flags |= 4096;
      return t;
    }
    return l = Gt(l.child, {
      mode: a.mode,
      children: a.children
    }), l.ref = t.ref, t.child = l, l.return = t, l;
  }
  function hn(l, t) {
    var e = t.ref;
    if (e === null)
      l !== null && l.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof e != "function" && typeof e != "object")
        throw Error(r(284));
      (l === null || l.ref !== e) && (t.flags |= 4194816);
    }
  }
  function gc(l, t, e, a, u) {
    return qe(t), e = Fi(
      l,
      t,
      e,
      a,
      void 0,
      u
    ), a = Ii(), l !== null && !Nl ? (Pi(l, t, u), Kt(l, t, u)) : (P && a && Ni(t), t.flags |= 1, Zl(l, t, e, u), t.child);
  }
  function Zo(l, t, e, a, u, n) {
    return qe(t), t.updateQueue = null, e = Ks(
      t,
      a,
      e,
      u
    ), Vs(l), a = Ii(), l !== null && !Nl ? (Pi(l, t, n), Kt(l, t, n)) : (P && a && Ni(t), t.flags |= 1, Zl(l, t, e, n), t.child);
  }
  function Vo(l, t, e, a, u) {
    if (qe(t), t.stateNode === null) {
      var n = na, i = e.contextType;
      typeof i == "object" && i !== null && (n = Ll(i)), n = new e(a, n), t.memoizedState = n.state !== null && n.state !== void 0 ? n.state : null, n.updater = vc, t.stateNode = n, n._reactInternals = t, n = t.stateNode, n.props = a, n.state = t.memoizedState, n.refs = {}, Zi(t), i = e.contextType, n.context = typeof i == "object" && i !== null ? Ll(i) : na, n.state = t.memoizedState, i = e.getDerivedStateFromProps, typeof i == "function" && (mc(
        t,
        e,
        i,
        a
      ), n.state = t.memoizedState), typeof e.getDerivedStateFromProps == "function" || typeof n.getSnapshotBeforeUpdate == "function" || typeof n.UNSAFE_componentWillMount != "function" && typeof n.componentWillMount != "function" || (i = n.state, typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount(), i !== n.state && vc.enqueueReplaceState(n, n.state, null), Pa(t, a, n, u), Ia(), n.state = t.memoizedState), typeof n.componentDidMount == "function" && (t.flags |= 4194308), a = !0;
    } else if (l === null) {
      n = t.stateNode;
      var c = t.memoizedProps, s = Le(e, c);
      n.props = s;
      var y = n.context, b = e.contextType;
      i = na, typeof b == "object" && b !== null && (i = Ll(b));
      var T = e.getDerivedStateFromProps;
      b = typeof T == "function" || typeof n.getSnapshotBeforeUpdate == "function", c = t.pendingProps !== c, b || typeof n.UNSAFE_componentWillReceiveProps != "function" && typeof n.componentWillReceiveProps != "function" || (c || y !== i) && Ro(
        t,
        n,
        a,
        i
      ), ce = !1;
      var g = t.memoizedState;
      n.state = g, Pa(t, a, n, u), Ia(), y = t.memoizedState, c || g !== y || ce ? (typeof T == "function" && (mc(
        t,
        e,
        T,
        a
      ), y = t.memoizedState), (s = ce || _o(
        t,
        e,
        s,
        a,
        g,
        y,
        i
      )) ? (b || typeof n.UNSAFE_componentWillMount != "function" && typeof n.componentWillMount != "function" || (typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount()), typeof n.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof n.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = a, t.memoizedState = y), n.props = a, n.state = y, n.context = i, a = s) : (typeof n.componentDidMount == "function" && (t.flags |= 4194308), a = !1);
    } else {
      n = t.stateNode, Vi(l, t), i = t.memoizedProps, b = Le(e, i), n.props = b, T = t.pendingProps, g = n.context, y = e.contextType, s = na, typeof y == "object" && y !== null && (s = Ll(y)), c = e.getDerivedStateFromProps, (y = typeof c == "function" || typeof n.getSnapshotBeforeUpdate == "function") || typeof n.UNSAFE_componentWillReceiveProps != "function" && typeof n.componentWillReceiveProps != "function" || (i !== T || g !== s) && Ro(
        t,
        n,
        a,
        s
      ), ce = !1, g = t.memoizedState, n.state = g, Pa(t, a, n, u), Ia();
      var p = t.memoizedState;
      i !== T || g !== p || ce || l !== null && l.dependencies !== null && ku(l.dependencies) ? (typeof c == "function" && (mc(
        t,
        e,
        c,
        a
      ), p = t.memoizedState), (b = ce || _o(
        t,
        e,
        b,
        a,
        g,
        p,
        s
      ) || l !== null && l.dependencies !== null && ku(l.dependencies)) ? (y || typeof n.UNSAFE_componentWillUpdate != "function" && typeof n.componentWillUpdate != "function" || (typeof n.componentWillUpdate == "function" && n.componentWillUpdate(a, p, s), typeof n.UNSAFE_componentWillUpdate == "function" && n.UNSAFE_componentWillUpdate(
        a,
        p,
        s
      )), typeof n.componentDidUpdate == "function" && (t.flags |= 4), typeof n.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof n.componentDidUpdate != "function" || i === l.memoizedProps && g === l.memoizedState || (t.flags |= 4), typeof n.getSnapshotBeforeUpdate != "function" || i === l.memoizedProps && g === l.memoizedState || (t.flags |= 1024), t.memoizedProps = a, t.memoizedState = p), n.props = a, n.state = p, n.context = s, a = b) : (typeof n.componentDidUpdate != "function" || i === l.memoizedProps && g === l.memoizedState || (t.flags |= 4), typeof n.getSnapshotBeforeUpdate != "function" || i === l.memoizedProps && g === l.memoizedState || (t.flags |= 1024), a = !1);
    }
    return n = a, hn(l, t), a = (t.flags & 128) !== 0, n || a ? (n = t.stateNode, e = a && typeof e.getDerivedStateFromError != "function" ? null : n.render(), t.flags |= 1, l !== null && a ? (t.child = Qe(
      t,
      l.child,
      null,
      u
    ), t.child = Qe(
      t,
      null,
      e,
      u
    )) : Zl(l, t, e, u), t.memoizedState = n.state, l = t.child) : l = Kt(
      l,
      t,
      u
    ), l;
  }
  function Ko(l, t, e, a) {
    return He(), t.flags |= 256, Zl(l, t, e, a), t.child;
  }
  var pc = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function bc(l) {
    return { baseLanes: l, cachePool: Us() };
  }
  function Sc(l, t, e) {
    return l = l !== null ? l.childLanes & ~e : 0, t && (l |= dt), l;
  }
  function Jo(l, t, e) {
    var a = t.pendingProps, u = !1, n = (t.flags & 128) !== 0, i;
    if ((i = n) || (i = l !== null && l.memoizedState === null ? !1 : (Tl.current & 2) !== 0), i && (u = !0, t.flags &= -129), i = (t.flags & 32) !== 0, t.flags &= -33, l === null) {
      if (P) {
        if (u ? oe(t) : re(), (l = vl) ? (l = ld(
          l,
          xt
        ), l = l !== null && l.data !== "&" ? l : null, l !== null && (t.memoizedState = {
          dehydrated: l,
          treeContext: ae !== null ? { id: Nt, overflow: Ut } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = As(l), e.return = t, t.child = e, Xl = t, vl = null)) : l = null, l === null) throw ne(t);
        return ef(l) ? t.lanes = 32 : t.lanes = 536870912, null;
      }
      var c = a.children;
      return a = a.fallback, u ? (re(), u = t.mode, c = yn(
        { mode: "hidden", children: c },
        u
      ), a = Ue(
        a,
        u,
        e,
        null
      ), c.return = t, a.return = t, c.sibling = a, t.child = c, a = t.child, a.memoizedState = bc(e), a.childLanes = Sc(
        l,
        i,
        e
      ), t.memoizedState = pc, uu(null, a)) : (oe(t), xc(t, c));
    }
    var s = l.memoizedState;
    if (s !== null && (c = s.dehydrated, c !== null)) {
      if (n)
        t.flags & 256 ? (oe(t), t.flags &= -257, t = zc(
          l,
          t,
          e
        )) : t.memoizedState !== null ? (re(), t.child = l.child, t.flags |= 128, t = null) : (re(), c = a.fallback, u = t.mode, a = yn(
          { mode: "visible", children: a.children },
          u
        ), c = Ue(
          c,
          u,
          e,
          null
        ), c.flags |= 2, a.return = t, c.return = t, a.sibling = c, t.child = a, Qe(
          t,
          l.child,
          null,
          e
        ), a = t.child, a.memoizedState = bc(e), a.childLanes = Sc(
          l,
          i,
          e
        ), t.memoizedState = pc, t = uu(null, a));
      else if (oe(t), ef(c)) {
        if (i = c.nextSibling && c.nextSibling.dataset, i) var y = i.dgst;
        i = y, a = Error(r(419)), a.stack = "", a.digest = i, Ja({ value: a, source: null, stack: null }), t = zc(
          l,
          t,
          e
        );
      } else if (Nl || sa(l, t, e, !1), i = (e & l.childLanes) !== 0, Nl || i) {
        if (i = ml, i !== null && (a = Df(i, e), a !== 0 && a !== s.retryLane))
          throw s.retryLane = a, Ne(l, a), at(i, l, a), yc;
        tf(c) || Tn(), t = zc(
          l,
          t,
          e
        );
      } else
        tf(c) ? (t.flags |= 192, t.child = l.child, t = null) : (l = s.treeContext, vl = Et(
          c.nextSibling
        ), Xl = t, P = !0, ue = null, xt = !1, l !== null && Os(t, l), t = xc(
          t,
          a.children
        ), t.flags |= 4096);
      return t;
    }
    return u ? (re(), c = a.fallback, u = t.mode, s = l.child, y = s.sibling, a = Gt(s, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = s.subtreeFlags & 65011712, y !== null ? c = Gt(
      y,
      c
    ) : (c = Ue(
      c,
      u,
      e,
      null
    ), c.flags |= 2), c.return = t, a.return = t, a.sibling = c, t.child = a, uu(null, a), a = t.child, c = l.child.memoizedState, c === null ? c = bc(e) : (u = c.cachePool, u !== null ? (s = Rl._currentValue, u = u.parent !== s ? { parent: s, pool: s } : u) : u = Us(), c = {
      baseLanes: c.baseLanes | e,
      cachePool: u
    }), a.memoizedState = c, a.childLanes = Sc(
      l,
      i,
      e
    ), t.memoizedState = pc, uu(l.child, a)) : (oe(t), e = l.child, l = e.sibling, e = Gt(e, {
      mode: "visible",
      children: a.children
    }), e.return = t, e.sibling = null, l !== null && (i = t.deletions, i === null ? (t.deletions = [l], t.flags |= 16) : i.push(l)), t.child = e, t.memoizedState = null, e);
  }
  function xc(l, t) {
    return t = yn(
      { mode: "visible", children: t },
      l.mode
    ), t.return = l, l.child = t;
  }
  function yn(l, t) {
    return l = ft(22, l, null, t), l.lanes = 0, l;
  }
  function zc(l, t, e) {
    return Qe(t, l.child, null, e), l = xc(
      t,
      t.pendingProps.children
    ), l.flags |= 2, t.memoizedState = null, l;
  }
  function wo(l, t, e) {
    l.lanes |= t;
    var a = l.alternate;
    a !== null && (a.lanes |= t), Bi(l.return, t, e);
  }
  function Ec(l, t, e, a, u, n) {
    var i = l.memoizedState;
    i === null ? l.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: e,
      tailMode: u,
      treeForkCount: n
    } : (i.isBackwards = t, i.rendering = null, i.renderingStartTime = 0, i.last = a, i.tail = e, i.tailMode = u, i.treeForkCount = n);
  }
  function $o(l, t, e) {
    var a = t.pendingProps, u = a.revealOrder, n = a.tail;
    a = a.children;
    var i = Tl.current, c = (i & 2) !== 0;
    if (c ? (i = i & 1 | 2, t.flags |= 128) : i &= 1, D(Tl, i), Zl(l, t, a, e), a = P ? Ka : 0, !c && l !== null && (l.flags & 128) !== 0)
      l: for (l = t.child; l !== null; ) {
        if (l.tag === 13)
          l.memoizedState !== null && wo(l, e, t);
        else if (l.tag === 19)
          wo(l, e, t);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === t) break l;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === t)
            break l;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    switch (u) {
      case "forwards":
        for (e = t.child, u = null; e !== null; )
          l = e.alternate, l !== null && an(l) === null && (u = e), e = e.sibling;
        e = u, e === null ? (u = t.child, t.child = null) : (u = e.sibling, e.sibling = null), Ec(
          t,
          !1,
          u,
          e,
          n,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (e = null, u = t.child, t.child = null; u !== null; ) {
          if (l = u.alternate, l !== null && an(l) === null) {
            t.child = u;
            break;
          }
          l = u.sibling, u.sibling = e, e = u, u = l;
        }
        Ec(
          t,
          !0,
          e,
          null,
          n,
          a
        );
        break;
      case "together":
        Ec(
          t,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function Kt(l, t, e) {
    if (l !== null && (t.dependencies = l.dependencies), ve |= t.lanes, (e & t.childLanes) === 0)
      if (l !== null) {
        if (sa(
          l,
          t,
          e,
          !1
        ), (e & t.childLanes) === 0)
          return null;
      } else return null;
    if (l !== null && t.child !== l.child)
      throw Error(r(153));
    if (t.child !== null) {
      for (l = t.child, e = Gt(l, l.pendingProps), t.child = e, e.return = t; l.sibling !== null; )
        l = l.sibling, e = e.sibling = Gt(l, l.pendingProps), e.return = t;
      e.sibling = null;
    }
    return t.child;
  }
  function Ac(l, t) {
    return (l.lanes & t) !== 0 ? !0 : (l = l.dependencies, !!(l !== null && ku(l)));
  }
  function vv(l, t, e) {
    switch (t.tag) {
      case 3:
        kl(t, t.stateNode.containerInfo), ie(t, Rl, l.memoizedState.cache), He();
        break;
      case 27:
      case 5:
        Ra(t);
        break;
      case 4:
        kl(t, t.stateNode.containerInfo);
        break;
      case 10:
        ie(
          t,
          t.type,
          t.memoizedProps.value
        );
        break;
      case 31:
        if (t.memoizedState !== null)
          return t.flags |= 128, ki(t), null;
        break;
      case 13:
        var a = t.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (oe(t), t.flags |= 128, null) : (e & t.child.childLanes) !== 0 ? Jo(l, t, e) : (oe(t), l = Kt(
            l,
            t,
            e
          ), l !== null ? l.sibling : null);
        oe(t);
        break;
      case 19:
        var u = (l.flags & 128) !== 0;
        if (a = (e & t.childLanes) !== 0, a || (sa(
          l,
          t,
          e,
          !1
        ), a = (e & t.childLanes) !== 0), u) {
          if (a)
            return $o(
              l,
              t,
              e
            );
          t.flags |= 128;
        }
        if (u = t.memoizedState, u !== null && (u.rendering = null, u.tail = null, u.lastEffect = null), D(Tl, Tl.current), a) break;
        return null;
      case 22:
        return t.lanes = 0, Qo(
          l,
          t,
          e,
          t.pendingProps
        );
      case 24:
        ie(t, Rl, l.memoizedState.cache);
    }
    return Kt(l, t, e);
  }
  function ko(l, t, e) {
    if (l !== null)
      if (l.memoizedProps !== t.pendingProps)
        Nl = !0;
      else {
        if (!Ac(l, e) && (t.flags & 128) === 0)
          return Nl = !1, vv(
            l,
            t,
            e
          );
        Nl = (l.flags & 131072) !== 0;
      }
    else
      Nl = !1, P && (t.flags & 1048576) !== 0 && js(t, Ka, t.index);
    switch (t.lanes = 0, t.tag) {
      case 16:
        l: {
          var a = t.pendingProps;
          if (l = Ye(t.elementType), t.type = l, typeof l == "function")
            _i(l) ? (a = Le(l, a), t.tag = 1, t = Vo(
              null,
              t,
              l,
              a,
              e
            )) : (t.tag = 0, t = gc(
              null,
              t,
              l,
              a,
              e
            ));
          else {
            if (l != null) {
              var u = l.$$typeof;
              if (u === Gl) {
                t.tag = 11, t = Bo(
                  null,
                  t,
                  l,
                  a,
                  e
                );
                break l;
              } else if (u === Q) {
                t.tag = 14, t = Yo(
                  null,
                  t,
                  l,
                  a,
                  e
                );
                break l;
              }
            }
            throw t = $l(l) || l, Error(r(306, t, ""));
          }
        }
        return t;
      case 0:
        return gc(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 1:
        return a = t.type, u = Le(
          a,
          t.pendingProps
        ), Vo(
          l,
          t,
          a,
          u,
          e
        );
      case 3:
        l: {
          if (kl(
            t,
            t.stateNode.containerInfo
          ), l === null) throw Error(r(387));
          a = t.pendingProps;
          var n = t.memoizedState;
          u = n.element, Vi(l, t), Pa(t, a, null, e);
          var i = t.memoizedState;
          if (a = i.cache, ie(t, Rl, a), a !== n.cache && Yi(
            t,
            [Rl],
            e,
            !0
          ), Ia(), a = i.element, n.isDehydrated)
            if (n = {
              element: a,
              isDehydrated: !1,
              cache: i.cache
            }, t.updateQueue.baseState = n, t.memoizedState = n, t.flags & 256) {
              t = Ko(
                l,
                t,
                a,
                e
              );
              break l;
            } else if (a !== u) {
              u = pt(
                Error(r(424)),
                t
              ), Ja(u), t = Ko(
                l,
                t,
                a,
                e
              );
              break l;
            } else {
              switch (l = t.stateNode.containerInfo, l.nodeType) {
                case 9:
                  l = l.body;
                  break;
                default:
                  l = l.nodeName === "HTML" ? l.ownerDocument.body : l;
              }
              for (vl = Et(l.firstChild), Xl = t, P = !0, ue = null, xt = !0, e = Gs(
                t,
                null,
                a,
                e
              ), t.child = e; e; )
                e.flags = e.flags & -3 | 4096, e = e.sibling;
            }
          else {
            if (He(), a === u) {
              t = Kt(
                l,
                t,
                e
              );
              break l;
            }
            Zl(l, t, a, e);
          }
          t = t.child;
        }
        return t;
      case 26:
        return hn(l, t), l === null ? (e = id(
          t.type,
          null,
          t.pendingProps,
          null
        )) ? t.memoizedState = e : P || (e = t.type, l = t.pendingProps, a = Nn(
          w.current
        ).createElement(e), a[Ql] = t, a[Fl] = l, Vl(a, e, l), Bl(a), t.stateNode = a) : t.memoizedState = id(
          t.type,
          l.memoizedProps,
          t.pendingProps,
          l.memoizedState
        ), null;
      case 27:
        return Ra(t), l === null && P && (a = t.stateNode = ad(
          t.type,
          t.pendingProps,
          w.current
        ), Xl = t, xt = !0, u = vl, be(t.type) ? (af = u, vl = Et(a.firstChild)) : vl = u), Zl(
          l,
          t,
          t.pendingProps.children,
          e
        ), hn(l, t), l === null && (t.flags |= 4194304), t.child;
      case 5:
        return l === null && P && ((u = a = vl) && (a = Vv(
          a,
          t.type,
          t.pendingProps,
          xt
        ), a !== null ? (t.stateNode = a, Xl = t, vl = Et(a.firstChild), xt = !1, u = !0) : u = !1), u || ne(t)), Ra(t), u = t.type, n = t.pendingProps, i = l !== null ? l.memoizedProps : null, a = n.children, Ic(u, n) ? a = null : i !== null && Ic(u, i) && (t.flags |= 32), t.memoizedState !== null && (u = Fi(
          l,
          t,
          nv,
          null,
          null,
          e
        ), bu._currentValue = u), hn(l, t), Zl(l, t, a, e), t.child;
      case 6:
        return l === null && P && ((l = e = vl) && (e = Kv(
          e,
          t.pendingProps,
          xt
        ), e !== null ? (t.stateNode = e, Xl = t, vl = null, l = !0) : l = !1), l || ne(t)), null;
      case 13:
        return Jo(l, t, e);
      case 4:
        return kl(
          t,
          t.stateNode.containerInfo
        ), a = t.pendingProps, l === null ? t.child = Qe(
          t,
          null,
          a,
          e
        ) : Zl(l, t, a, e), t.child;
      case 11:
        return Bo(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 7:
        return Zl(
          l,
          t,
          t.pendingProps,
          e
        ), t.child;
      case 8:
        return Zl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 12:
        return Zl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 10:
        return a = t.pendingProps, ie(t, t.type, a.value), Zl(l, t, a.children, e), t.child;
      case 9:
        return u = t.type._context, a = t.pendingProps.children, qe(t), u = Ll(u), a = a(u), t.flags |= 1, Zl(l, t, a, e), t.child;
      case 14:
        return Yo(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 15:
        return Go(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 19:
        return $o(l, t, e);
      case 31:
        return mv(l, t, e);
      case 22:
        return Qo(
          l,
          t,
          e,
          t.pendingProps
        );
      case 24:
        return qe(t), a = Ll(Rl), l === null ? (u = Xi(), u === null && (u = ml, n = Gi(), u.pooledCache = n, n.refCount++, n !== null && (u.pooledCacheLanes |= e), u = n), t.memoizedState = { parent: a, cache: u }, Zi(t), ie(t, Rl, u)) : ((l.lanes & e) !== 0 && (Vi(l, t), Pa(t, null, null, e), Ia()), u = l.memoizedState, n = t.memoizedState, u.parent !== a ? (u = { parent: a, cache: a }, t.memoizedState = u, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = u), ie(t, Rl, a)) : (a = n.cache, ie(t, Rl, a), a !== u.cache && Yi(
          t,
          [Rl],
          e,
          !0
        ))), Zl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(r(156, t.tag));
  }
  function Jt(l) {
    l.flags |= 4;
  }
  function Tc(l, t, e, a, u) {
    if ((t = (l.mode & 32) !== 0) && (t = !1), t) {
      if (l.flags |= 16777216, (u & 335544128) === u)
        if (l.stateNode.complete) l.flags |= 8192;
        else if (zr()) l.flags |= 8192;
        else
          throw Ge = Pu, Li;
    } else l.flags &= -16777217;
  }
  function Wo(l, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      l.flags &= -16777217;
    else if (l.flags |= 16777216, !rd(t))
      if (zr()) l.flags |= 8192;
      else
        throw Ge = Pu, Li;
  }
  function gn(l, t) {
    t !== null && (l.flags |= 4), l.flags & 16384 && (t = l.tag !== 22 ? Mf() : 536870912, l.lanes |= t, xa |= t);
  }
  function nu(l, t) {
    if (!P)
      switch (l.tailMode) {
        case "hidden":
          t = l.tail;
          for (var e = null; t !== null; )
            t.alternate !== null && (e = t), t = t.sibling;
          e === null ? l.tail = null : e.sibling = null;
          break;
        case "collapsed":
          e = l.tail;
          for (var a = null; e !== null; )
            e.alternate !== null && (a = e), e = e.sibling;
          a === null ? t || l.tail === null ? l.tail = null : l.tail.sibling = null : a.sibling = null;
      }
  }
  function hl(l) {
    var t = l.alternate !== null && l.alternate.child === l.child, e = 0, a = 0;
    if (t)
      for (var u = l.child; u !== null; )
        e |= u.lanes | u.childLanes, a |= u.subtreeFlags & 65011712, a |= u.flags & 65011712, u.return = l, u = u.sibling;
    else
      for (u = l.child; u !== null; )
        e |= u.lanes | u.childLanes, a |= u.subtreeFlags, a |= u.flags, u.return = l, u = u.sibling;
    return l.subtreeFlags |= a, l.childLanes = e, t;
  }
  function hv(l, t, e) {
    var a = t.pendingProps;
    switch (Ui(t), t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return hl(t), null;
      case 1:
        return hl(t), null;
      case 3:
        return e = t.stateNode, a = null, l !== null && (a = l.memoizedState.cache), t.memoizedState.cache !== a && (t.flags |= 2048), Lt(Rl), Al(), e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null), (l === null || l.child === null) && (fa(t) ? Jt(t) : l === null || l.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, Ci())), hl(t), null;
      case 26:
        var u = t.type, n = t.memoizedState;
        return l === null ? (Jt(t), n !== null ? (hl(t), Wo(t, n)) : (hl(t), Tc(
          t,
          u,
          null,
          a,
          e
        ))) : n ? n !== l.memoizedState ? (Jt(t), hl(t), Wo(t, n)) : (hl(t), t.flags &= -16777217) : (l = l.memoizedProps, l !== a && Jt(t), hl(t), Tc(
          t,
          u,
          l,
          a,
          e
        )), null;
      case 27:
        if (Ou(t), e = w.current, u = t.type, l !== null && t.stateNode != null)
          l.memoizedProps !== a && Jt(t);
        else {
          if (!a) {
            if (t.stateNode === null)
              throw Error(r(166));
            return hl(t), null;
          }
          l = C.current, fa(t) ? Ms(t) : (l = ad(u, a, e), t.stateNode = l, Jt(t));
        }
        return hl(t), null;
      case 5:
        if (Ou(t), u = t.type, l !== null && t.stateNode != null)
          l.memoizedProps !== a && Jt(t);
        else {
          if (!a) {
            if (t.stateNode === null)
              throw Error(r(166));
            return hl(t), null;
          }
          if (n = C.current, fa(t))
            Ms(t);
          else {
            var i = Nn(
              w.current
            );
            switch (n) {
              case 1:
                n = i.createElementNS(
                  "http://www.w3.org/2000/svg",
                  u
                );
                break;
              case 2:
                n = i.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  u
                );
                break;
              default:
                switch (u) {
                  case "svg":
                    n = i.createElementNS(
                      "http://www.w3.org/2000/svg",
                      u
                    );
                    break;
                  case "math":
                    n = i.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      u
                    );
                    break;
                  case "script":
                    n = i.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(
                      n.firstChild
                    );
                    break;
                  case "select":
                    n = typeof a.is == "string" ? i.createElement("select", {
                      is: a.is
                    }) : i.createElement("select"), a.multiple ? n.multiple = !0 : a.size && (n.size = a.size);
                    break;
                  default:
                    n = typeof a.is == "string" ? i.createElement(u, { is: a.is }) : i.createElement(u);
                }
            }
            n[Ql] = t, n[Fl] = a;
            l: for (i = t.child; i !== null; ) {
              if (i.tag === 5 || i.tag === 6)
                n.appendChild(i.stateNode);
              else if (i.tag !== 4 && i.tag !== 27 && i.child !== null) {
                i.child.return = i, i = i.child;
                continue;
              }
              if (i === t) break l;
              for (; i.sibling === null; ) {
                if (i.return === null || i.return === t)
                  break l;
                i = i.return;
              }
              i.sibling.return = i.return, i = i.sibling;
            }
            t.stateNode = n;
            l: switch (Vl(n, u, a), u) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break l;
              case "img":
                a = !0;
                break l;
              default:
                a = !1;
            }
            a && Jt(t);
          }
        }
        return hl(t), Tc(
          t,
          t.type,
          l === null ? null : l.memoizedProps,
          t.pendingProps,
          e
        ), null;
      case 6:
        if (l && t.stateNode != null)
          l.memoizedProps !== a && Jt(t);
        else {
          if (typeof a != "string" && t.stateNode === null)
            throw Error(r(166));
          if (l = w.current, fa(t)) {
            if (l = t.stateNode, e = t.memoizedProps, a = null, u = Xl, u !== null)
              switch (u.tag) {
                case 27:
                case 5:
                  a = u.memoizedProps;
              }
            l[Ql] = t, l = !!(l.nodeValue === e || a !== null && a.suppressHydrationWarning === !0 || Jr(l.nodeValue, e)), l || ne(t, !0);
          } else
            l = Nn(l).createTextNode(
              a
            ), l[Ql] = t, t.stateNode = l;
        }
        return hl(t), null;
      case 31:
        if (e = t.memoizedState, l === null || l.memoizedState !== null) {
          if (a = fa(t), e !== null) {
            if (l === null) {
              if (!a) throw Error(r(318));
              if (l = t.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(r(557));
              l[Ql] = t;
            } else
              He(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            hl(t), l = !1;
          } else
            e = Ci(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = e), l = !0;
          if (!l)
            return t.flags & 256 ? (ot(t), t) : (ot(t), null);
          if ((t.flags & 128) !== 0)
            throw Error(r(558));
        }
        return hl(t), null;
      case 13:
        if (a = t.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
          if (u = fa(t), a !== null && a.dehydrated !== null) {
            if (l === null) {
              if (!u) throw Error(r(318));
              if (u = t.memoizedState, u = u !== null ? u.dehydrated : null, !u) throw Error(r(317));
              u[Ql] = t;
            } else
              He(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            hl(t), u = !1;
          } else
            u = Ci(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = u), u = !0;
          if (!u)
            return t.flags & 256 ? (ot(t), t) : (ot(t), null);
        }
        return ot(t), (t.flags & 128) !== 0 ? (t.lanes = e, t) : (e = a !== null, l = l !== null && l.memoizedState !== null, e && (a = t.child, u = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (u = a.alternate.memoizedState.cachePool.pool), n = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (n = a.memoizedState.cachePool.pool), n !== u && (a.flags |= 2048)), e !== l && e && (t.child.flags |= 8192), gn(t, t.updateQueue), hl(t), null);
      case 4:
        return Al(), l === null && wc(t.stateNode.containerInfo), hl(t), null;
      case 10:
        return Lt(t.type), hl(t), null;
      case 19:
        if (j(Tl), a = t.memoizedState, a === null) return hl(t), null;
        if (u = (t.flags & 128) !== 0, n = a.rendering, n === null)
          if (u) nu(a, !1);
          else {
            if (zl !== 0 || l !== null && (l.flags & 128) !== 0)
              for (l = t.child; l !== null; ) {
                if (n = an(l), n !== null) {
                  for (t.flags |= 128, nu(a, !1), l = n.updateQueue, t.updateQueue = l, gn(t, l), t.subtreeFlags = 0, l = e, e = t.child; e !== null; )
                    Es(e, l), e = e.sibling;
                  return D(
                    Tl,
                    Tl.current & 1 | 2
                  ), P && Qt(t, a.treeForkCount), t.child;
                }
                l = l.sibling;
              }
            a.tail !== null && ut() > zn && (t.flags |= 128, u = !0, nu(a, !1), t.lanes = 4194304);
          }
        else {
          if (!u)
            if (l = an(n), l !== null) {
              if (t.flags |= 128, u = !0, l = l.updateQueue, t.updateQueue = l, gn(t, l), nu(a, !0), a.tail === null && a.tailMode === "hidden" && !n.alternate && !P)
                return hl(t), null;
            } else
              2 * ut() - a.renderingStartTime > zn && e !== 536870912 && (t.flags |= 128, u = !0, nu(a, !1), t.lanes = 4194304);
          a.isBackwards ? (n.sibling = t.child, t.child = n) : (l = a.last, l !== null ? l.sibling = n : t.child = n, a.last = n);
        }
        return a.tail !== null ? (l = a.tail, a.rendering = l, a.tail = l.sibling, a.renderingStartTime = ut(), l.sibling = null, e = Tl.current, D(
          Tl,
          u ? e & 1 | 2 : e & 1
        ), P && Qt(t, a.treeForkCount), l) : (hl(t), null);
      case 22:
      case 23:
        return ot(t), $i(), a = t.memoizedState !== null, l !== null ? l.memoizedState !== null !== a && (t.flags |= 8192) : a && (t.flags |= 8192), a ? (e & 536870912) !== 0 && (t.flags & 128) === 0 && (hl(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : hl(t), e = t.updateQueue, e !== null && gn(t, e.retryQueue), e = null, l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (e = l.memoizedState.cachePool.pool), a = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (a = t.memoizedState.cachePool.pool), a !== e && (t.flags |= 2048), l !== null && j(Be), null;
      case 24:
        return e = null, l !== null && (e = l.memoizedState.cache), t.memoizedState.cache !== e && (t.flags |= 2048), Lt(Rl), hl(t), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(r(156, t.tag));
  }
  function yv(l, t) {
    switch (Ui(t), t.tag) {
      case 1:
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 3:
        return Lt(Rl), Al(), l = t.flags, (l & 65536) !== 0 && (l & 128) === 0 ? (t.flags = l & -65537 | 128, t) : null;
      case 26:
      case 27:
      case 5:
        return Ou(t), null;
      case 31:
        if (t.memoizedState !== null) {
          if (ot(t), t.alternate === null)
            throw Error(r(340));
          He();
        }
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 13:
        if (ot(t), l = t.memoizedState, l !== null && l.dehydrated !== null) {
          if (t.alternate === null)
            throw Error(r(340));
          He();
        }
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 19:
        return j(Tl), null;
      case 4:
        return Al(), null;
      case 10:
        return Lt(t.type), null;
      case 22:
      case 23:
        return ot(t), $i(), l !== null && j(Be), l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 24:
        return Lt(Rl), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Fo(l, t) {
    switch (Ui(t), t.tag) {
      case 3:
        Lt(Rl), Al();
        break;
      case 26:
      case 27:
      case 5:
        Ou(t);
        break;
      case 4:
        Al();
        break;
      case 31:
        t.memoizedState !== null && ot(t);
        break;
      case 13:
        ot(t);
        break;
      case 19:
        j(Tl);
        break;
      case 10:
        Lt(t.type);
        break;
      case 22:
      case 23:
        ot(t), $i(), l !== null && j(Be);
        break;
      case 24:
        Lt(Rl);
    }
  }
  function iu(l, t) {
    try {
      var e = t.updateQueue, a = e !== null ? e.lastEffect : null;
      if (a !== null) {
        var u = a.next;
        e = u;
        do {
          if ((e.tag & l) === l) {
            a = void 0;
            var n = e.create, i = e.inst;
            a = n(), i.destroy = a;
          }
          e = e.next;
        } while (e !== u);
      }
    } catch (c) {
      il(t, t.return, c);
    }
  }
  function de(l, t, e) {
    try {
      var a = t.updateQueue, u = a !== null ? a.lastEffect : null;
      if (u !== null) {
        var n = u.next;
        a = n;
        do {
          if ((a.tag & l) === l) {
            var i = a.inst, c = i.destroy;
            if (c !== void 0) {
              i.destroy = void 0, u = t;
              var s = e, y = c;
              try {
                y();
              } catch (b) {
                il(
                  u,
                  s,
                  b
                );
              }
            }
          }
          a = a.next;
        } while (a !== n);
      }
    } catch (b) {
      il(t, t.return, b);
    }
  }
  function Io(l) {
    var t = l.updateQueue;
    if (t !== null) {
      var e = l.stateNode;
      try {
        Xs(t, e);
      } catch (a) {
        il(l, l.return, a);
      }
    }
  }
  function Po(l, t, e) {
    e.props = Le(
      l.type,
      l.memoizedProps
    ), e.state = l.memoizedState;
    try {
      e.componentWillUnmount();
    } catch (a) {
      il(l, t, a);
    }
  }
  function cu(l, t) {
    try {
      var e = l.ref;
      if (e !== null) {
        switch (l.tag) {
          case 26:
          case 27:
          case 5:
            var a = l.stateNode;
            break;
          case 30:
            a = l.stateNode;
            break;
          default:
            a = l.stateNode;
        }
        typeof e == "function" ? l.refCleanup = e(a) : e.current = a;
      }
    } catch (u) {
      il(l, t, u);
    }
  }
  function Ht(l, t) {
    var e = l.ref, a = l.refCleanup;
    if (e !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (u) {
          il(l, t, u);
        } finally {
          l.refCleanup = null, l = l.alternate, l != null && (l.refCleanup = null);
        }
      else if (typeof e == "function")
        try {
          e(null);
        } catch (u) {
          il(l, t, u);
        }
      else e.current = null;
  }
  function lr(l) {
    var t = l.type, e = l.memoizedProps, a = l.stateNode;
    try {
      l: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          e.autoFocus && a.focus();
          break l;
        case "img":
          e.src ? a.src = e.src : e.srcSet && (a.srcset = e.srcSet);
      }
    } catch (u) {
      il(l, l.return, u);
    }
  }
  function jc(l, t, e) {
    try {
      var a = l.stateNode;
      Yv(a, l.type, e, t), a[Fl] = t;
    } catch (u) {
      il(l, l.return, u);
    }
  }
  function tr(l) {
    return l.tag === 5 || l.tag === 3 || l.tag === 26 || l.tag === 27 && be(l.type) || l.tag === 4;
  }
  function Oc(l) {
    l: for (; ; ) {
      for (; l.sibling === null; ) {
        if (l.return === null || tr(l.return)) return null;
        l = l.return;
      }
      for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
        if (l.tag === 27 && be(l.type) || l.flags & 2 || l.child === null || l.tag === 4) continue l;
        l.child.return = l, l = l.child;
      }
      if (!(l.flags & 2)) return l.stateNode;
    }
  }
  function Mc(l, t, e) {
    var a = l.tag;
    if (a === 5 || a === 6)
      l = l.stateNode, t ? (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).insertBefore(l, t) : (t = e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, t.appendChild(l), e = e._reactRootContainer, e != null || t.onclick !== null || (t.onclick = Bt));
    else if (a !== 4 && (a === 27 && be(l.type) && (e = l.stateNode, t = null), l = l.child, l !== null))
      for (Mc(l, t, e), l = l.sibling; l !== null; )
        Mc(l, t, e), l = l.sibling;
  }
  function pn(l, t, e) {
    var a = l.tag;
    if (a === 5 || a === 6)
      l = l.stateNode, t ? e.insertBefore(l, t) : e.appendChild(l);
    else if (a !== 4 && (a === 27 && be(l.type) && (e = l.stateNode), l = l.child, l !== null))
      for (pn(l, t, e), l = l.sibling; l !== null; )
        pn(l, t, e), l = l.sibling;
  }
  function er(l) {
    var t = l.stateNode, e = l.memoizedProps;
    try {
      for (var a = l.type, u = t.attributes; u.length; )
        t.removeAttributeNode(u[0]);
      Vl(t, a, e), t[Ql] = l, t[Fl] = e;
    } catch (n) {
      il(l, l.return, n);
    }
  }
  var wt = !1, Ul = !1, _c = !1, ar = typeof WeakSet == "function" ? WeakSet : Set, Yl = null;
  function gv(l, t) {
    if (l = l.containerInfo, Wc = Gn, l = vs(l), zi(l)) {
      if ("selectionStart" in l)
        var e = {
          start: l.selectionStart,
          end: l.selectionEnd
        };
      else
        l: {
          e = (e = l.ownerDocument) && e.defaultView || window;
          var a = e.getSelection && e.getSelection();
          if (a && a.rangeCount !== 0) {
            e = a.anchorNode;
            var u = a.anchorOffset, n = a.focusNode;
            a = a.focusOffset;
            try {
              e.nodeType, n.nodeType;
            } catch {
              e = null;
              break l;
            }
            var i = 0, c = -1, s = -1, y = 0, b = 0, T = l, g = null;
            t: for (; ; ) {
              for (var p; T !== e || u !== 0 && T.nodeType !== 3 || (c = i + u), T !== n || a !== 0 && T.nodeType !== 3 || (s = i + a), T.nodeType === 3 && (i += T.nodeValue.length), (p = T.firstChild) !== null; )
                g = T, T = p;
              for (; ; ) {
                if (T === l) break t;
                if (g === e && ++y === u && (c = i), g === n && ++b === a && (s = i), (p = T.nextSibling) !== null) break;
                T = g, g = T.parentNode;
              }
              T = p;
            }
            e = c === -1 || s === -1 ? null : { start: c, end: s };
          } else e = null;
        }
      e = e || { start: 0, end: 0 };
    } else e = null;
    for (Fc = { focusedElem: l, selectionRange: e }, Gn = !1, Yl = t; Yl !== null; )
      if (t = Yl, l = t.child, (t.subtreeFlags & 1028) !== 0 && l !== null)
        l.return = t, Yl = l;
      else
        for (; Yl !== null; ) {
          switch (t = Yl, n = t.alternate, l = t.flags, t.tag) {
            case 0:
              if ((l & 4) !== 0 && (l = t.updateQueue, l = l !== null ? l.events : null, l !== null))
                for (e = 0; e < l.length; e++)
                  u = l[e], u.ref.impl = u.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((l & 1024) !== 0 && n !== null) {
                l = void 0, e = t, u = n.memoizedProps, n = n.memoizedState, a = e.stateNode;
                try {
                  var H = Le(
                    e.type,
                    u
                  );
                  l = a.getSnapshotBeforeUpdate(
                    H,
                    n
                  ), a.__reactInternalSnapshotBeforeUpdate = l;
                } catch (G) {
                  il(
                    e,
                    e.return,
                    G
                  );
                }
              }
              break;
            case 3:
              if ((l & 1024) !== 0) {
                if (l = t.stateNode.containerInfo, e = l.nodeType, e === 9)
                  lf(l);
                else if (e === 1)
                  switch (l.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      lf(l);
                      break;
                    default:
                      l.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((l & 1024) !== 0) throw Error(r(163));
          }
          if (l = t.sibling, l !== null) {
            l.return = t.return, Yl = l;
            break;
          }
          Yl = t.return;
        }
  }
  function ur(l, t, e) {
    var a = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        kt(l, e), a & 4 && iu(5, e);
        break;
      case 1:
        if (kt(l, e), a & 4)
          if (l = e.stateNode, t === null)
            try {
              l.componentDidMount();
            } catch (i) {
              il(e, e.return, i);
            }
          else {
            var u = Le(
              e.type,
              t.memoizedProps
            );
            t = t.memoizedState;
            try {
              l.componentDidUpdate(
                u,
                t,
                l.__reactInternalSnapshotBeforeUpdate
              );
            } catch (i) {
              il(
                e,
                e.return,
                i
              );
            }
          }
        a & 64 && Io(e), a & 512 && cu(e, e.return);
        break;
      case 3:
        if (kt(l, e), a & 64 && (l = e.updateQueue, l !== null)) {
          if (t = null, e.child !== null)
            switch (e.child.tag) {
              case 27:
              case 5:
                t = e.child.stateNode;
                break;
              case 1:
                t = e.child.stateNode;
            }
          try {
            Xs(l, t);
          } catch (i) {
            il(e, e.return, i);
          }
        }
        break;
      case 27:
        t === null && a & 4 && er(e);
      case 26:
      case 5:
        kt(l, e), t === null && a & 4 && lr(e), a & 512 && cu(e, e.return);
        break;
      case 12:
        kt(l, e);
        break;
      case 31:
        kt(l, e), a & 4 && cr(l, e);
        break;
      case 13:
        kt(l, e), a & 4 && fr(l, e), a & 64 && (l = e.memoizedState, l !== null && (l = l.dehydrated, l !== null && (e = jv.bind(
          null,
          e
        ), Jv(l, e))));
        break;
      case 22:
        if (a = e.memoizedState !== null || wt, !a) {
          t = t !== null && t.memoizedState !== null || Ul, u = wt;
          var n = Ul;
          wt = a, (Ul = t) && !n ? Wt(
            l,
            e,
            (e.subtreeFlags & 8772) !== 0
          ) : kt(l, e), wt = u, Ul = n;
        }
        break;
      case 30:
        break;
      default:
        kt(l, e);
    }
  }
  function nr(l) {
    var t = l.alternate;
    t !== null && (l.alternate = null, nr(t)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (t = l.stateNode, t !== null && ni(t)), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
  }
  var gl = null, Pl = !1;
  function $t(l, t, e) {
    for (e = e.child; e !== null; )
      ir(l, t, e), e = e.sibling;
  }
  function ir(l, t, e) {
    if (nt && typeof nt.onCommitFiberUnmount == "function")
      try {
        nt.onCommitFiberUnmount(Da, e);
      } catch {
      }
    switch (e.tag) {
      case 26:
        Ul || Ht(e, t), $t(
          l,
          t,
          e
        ), e.memoizedState ? e.memoizedState.count-- : e.stateNode && (e = e.stateNode, e.parentNode.removeChild(e));
        break;
      case 27:
        Ul || Ht(e, t);
        var a = gl, u = Pl;
        be(e.type) && (gl = e.stateNode, Pl = !1), $t(
          l,
          t,
          e
        ), yu(e.stateNode), gl = a, Pl = u;
        break;
      case 5:
        Ul || Ht(e, t);
      case 6:
        if (a = gl, u = Pl, gl = null, $t(
          l,
          t,
          e
        ), gl = a, Pl = u, gl !== null)
          if (Pl)
            try {
              (gl.nodeType === 9 ? gl.body : gl.nodeName === "HTML" ? gl.ownerDocument.body : gl).removeChild(e.stateNode);
            } catch (n) {
              il(
                e,
                t,
                n
              );
            }
          else
            try {
              gl.removeChild(e.stateNode);
            } catch (n) {
              il(
                e,
                t,
                n
              );
            }
        break;
      case 18:
        gl !== null && (Pl ? (l = gl, Ir(
          l.nodeType === 9 ? l.body : l.nodeName === "HTML" ? l.ownerDocument.body : l,
          e.stateNode
        ), _a(l)) : Ir(gl, e.stateNode));
        break;
      case 4:
        a = gl, u = Pl, gl = e.stateNode.containerInfo, Pl = !0, $t(
          l,
          t,
          e
        ), gl = a, Pl = u;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        de(2, e, t), Ul || de(4, e, t), $t(
          l,
          t,
          e
        );
        break;
      case 1:
        Ul || (Ht(e, t), a = e.stateNode, typeof a.componentWillUnmount == "function" && Po(
          e,
          t,
          a
        )), $t(
          l,
          t,
          e
        );
        break;
      case 21:
        $t(
          l,
          t,
          e
        );
        break;
      case 22:
        Ul = (a = Ul) || e.memoizedState !== null, $t(
          l,
          t,
          e
        ), Ul = a;
        break;
      default:
        $t(
          l,
          t,
          e
        );
    }
  }
  function cr(l, t) {
    if (t.memoizedState === null && (l = t.alternate, l !== null && (l = l.memoizedState, l !== null))) {
      l = l.dehydrated;
      try {
        _a(l);
      } catch (e) {
        il(t, t.return, e);
      }
    }
  }
  function fr(l, t) {
    if (t.memoizedState === null && (l = t.alternate, l !== null && (l = l.memoizedState, l !== null && (l = l.dehydrated, l !== null))))
      try {
        _a(l);
      } catch (e) {
        il(t, t.return, e);
      }
  }
  function pv(l) {
    switch (l.tag) {
      case 31:
      case 13:
      case 19:
        var t = l.stateNode;
        return t === null && (t = l.stateNode = new ar()), t;
      case 22:
        return l = l.stateNode, t = l._retryCache, t === null && (t = l._retryCache = new ar()), t;
      default:
        throw Error(r(435, l.tag));
    }
  }
  function bn(l, t) {
    var e = pv(l);
    t.forEach(function(a) {
      if (!e.has(a)) {
        e.add(a);
        var u = Ov.bind(null, l, a);
        a.then(u, u);
      }
    });
  }
  function lt(l, t) {
    var e = t.deletions;
    if (e !== null)
      for (var a = 0; a < e.length; a++) {
        var u = e[a], n = l, i = t, c = i;
        l: for (; c !== null; ) {
          switch (c.tag) {
            case 27:
              if (be(c.type)) {
                gl = c.stateNode, Pl = !1;
                break l;
              }
              break;
            case 5:
              gl = c.stateNode, Pl = !1;
              break l;
            case 3:
            case 4:
              gl = c.stateNode.containerInfo, Pl = !0;
              break l;
          }
          c = c.return;
        }
        if (gl === null) throw Error(r(160));
        ir(n, i, u), gl = null, Pl = !1, n = u.alternate, n !== null && (n.return = null), u.return = null;
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; )
        sr(t, l), t = t.sibling;
  }
  var Ot = null;
  function sr(l, t) {
    var e = l.alternate, a = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        lt(t, l), tt(l), a & 4 && (de(3, l, l.return), iu(3, l), de(5, l, l.return));
        break;
      case 1:
        lt(t, l), tt(l), a & 512 && (Ul || e === null || Ht(e, e.return)), a & 64 && wt && (l = l.updateQueue, l !== null && (a = l.callbacks, a !== null && (e = l.shared.hiddenCallbacks, l.shared.hiddenCallbacks = e === null ? a : e.concat(a))));
        break;
      case 26:
        var u = Ot;
        if (lt(t, l), tt(l), a & 512 && (Ul || e === null || Ht(e, e.return)), a & 4) {
          var n = e !== null ? e.memoizedState : null;
          if (a = l.memoizedState, e === null)
            if (a === null)
              if (l.stateNode === null) {
                l: {
                  a = l.type, e = l.memoizedProps, u = u.ownerDocument || u;
                  t: switch (a) {
                    case "title":
                      n = u.getElementsByTagName("title")[0], (!n || n[Ha] || n[Ql] || n.namespaceURI === "http://www.w3.org/2000/svg" || n.hasAttribute("itemprop")) && (n = u.createElement(a), u.head.insertBefore(
                        n,
                        u.querySelector("head > title")
                      )), Vl(n, a, e), n[Ql] = l, Bl(n), a = n;
                      break l;
                    case "link":
                      var i = sd(
                        "link",
                        "href",
                        u
                      ).get(a + (e.href || ""));
                      if (i) {
                        for (var c = 0; c < i.length; c++)
                          if (n = i[c], n.getAttribute("href") === (e.href == null || e.href === "" ? null : e.href) && n.getAttribute("rel") === (e.rel == null ? null : e.rel) && n.getAttribute("title") === (e.title == null ? null : e.title) && n.getAttribute("crossorigin") === (e.crossOrigin == null ? null : e.crossOrigin)) {
                            i.splice(c, 1);
                            break t;
                          }
                      }
                      n = u.createElement(a), Vl(n, a, e), u.head.appendChild(n);
                      break;
                    case "meta":
                      if (i = sd(
                        "meta",
                        "content",
                        u
                      ).get(a + (e.content || ""))) {
                        for (c = 0; c < i.length; c++)
                          if (n = i[c], n.getAttribute("content") === (e.content == null ? null : "" + e.content) && n.getAttribute("name") === (e.name == null ? null : e.name) && n.getAttribute("property") === (e.property == null ? null : e.property) && n.getAttribute("http-equiv") === (e.httpEquiv == null ? null : e.httpEquiv) && n.getAttribute("charset") === (e.charSet == null ? null : e.charSet)) {
                            i.splice(c, 1);
                            break t;
                          }
                      }
                      n = u.createElement(a), Vl(n, a, e), u.head.appendChild(n);
                      break;
                    default:
                      throw Error(r(468, a));
                  }
                  n[Ql] = l, Bl(n), a = n;
                }
                l.stateNode = a;
              } else
                od(
                  u,
                  l.type,
                  l.stateNode
                );
            else
              l.stateNode = fd(
                u,
                a,
                l.memoizedProps
              );
          else
            n !== a ? (n === null ? e.stateNode !== null && (e = e.stateNode, e.parentNode.removeChild(e)) : n.count--, a === null ? od(
              u,
              l.type,
              l.stateNode
            ) : fd(
              u,
              a,
              l.memoizedProps
            )) : a === null && l.stateNode !== null && jc(
              l,
              l.memoizedProps,
              e.memoizedProps
            );
        }
        break;
      case 27:
        lt(t, l), tt(l), a & 512 && (Ul || e === null || Ht(e, e.return)), e !== null && a & 4 && jc(
          l,
          l.memoizedProps,
          e.memoizedProps
        );
        break;
      case 5:
        if (lt(t, l), tt(l), a & 512 && (Ul || e === null || Ht(e, e.return)), l.flags & 32) {
          u = l.stateNode;
          try {
            Ie(u, "");
          } catch (H) {
            il(l, l.return, H);
          }
        }
        a & 4 && l.stateNode != null && (u = l.memoizedProps, jc(
          l,
          u,
          e !== null ? e.memoizedProps : u
        )), a & 1024 && (_c = !0);
        break;
      case 6:
        if (lt(t, l), tt(l), a & 4) {
          if (l.stateNode === null)
            throw Error(r(162));
          a = l.memoizedProps, e = l.stateNode;
          try {
            e.nodeValue = a;
          } catch (H) {
            il(l, l.return, H);
          }
        }
        break;
      case 3:
        if (Cn = null, u = Ot, Ot = Un(t.containerInfo), lt(t, l), Ot = u, tt(l), a & 4 && e !== null && e.memoizedState.isDehydrated)
          try {
            _a(t.containerInfo);
          } catch (H) {
            il(l, l.return, H);
          }
        _c && (_c = !1, or(l));
        break;
      case 4:
        a = Ot, Ot = Un(
          l.stateNode.containerInfo
        ), lt(t, l), tt(l), Ot = a;
        break;
      case 12:
        lt(t, l), tt(l);
        break;
      case 31:
        lt(t, l), tt(l), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bn(l, a)));
        break;
      case 13:
        lt(t, l), tt(l), l.child.flags & 8192 && l.memoizedState !== null != (e !== null && e.memoizedState !== null) && (xn = ut()), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bn(l, a)));
        break;
      case 22:
        u = l.memoizedState !== null;
        var s = e !== null && e.memoizedState !== null, y = wt, b = Ul;
        if (wt = y || u, Ul = b || s, lt(t, l), Ul = b, wt = y, tt(l), a & 8192)
          l: for (t = l.stateNode, t._visibility = u ? t._visibility & -2 : t._visibility | 1, u && (e === null || s || wt || Ul || Ze(l)), e = null, t = l; ; ) {
            if (t.tag === 5 || t.tag === 26) {
              if (e === null) {
                s = e = t;
                try {
                  if (n = s.stateNode, u)
                    i = n.style, typeof i.setProperty == "function" ? i.setProperty("display", "none", "important") : i.display = "none";
                  else {
                    c = s.stateNode;
                    var T = s.memoizedProps.style, g = T != null && T.hasOwnProperty("display") ? T.display : null;
                    c.style.display = g == null || typeof g == "boolean" ? "" : ("" + g).trim();
                  }
                } catch (H) {
                  il(s, s.return, H);
                }
              }
            } else if (t.tag === 6) {
              if (e === null) {
                s = t;
                try {
                  s.stateNode.nodeValue = u ? "" : s.memoizedProps;
                } catch (H) {
                  il(s, s.return, H);
                }
              }
            } else if (t.tag === 18) {
              if (e === null) {
                s = t;
                try {
                  var p = s.stateNode;
                  u ? Pr(p, !0) : Pr(s.stateNode, !1);
                } catch (H) {
                  il(s, s.return, H);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === l) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === l) break l;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === l) break l;
              e === t && (e = null), t = t.return;
            }
            e === t && (e = null), t.sibling.return = t.return, t = t.sibling;
          }
        a & 4 && (a = l.updateQueue, a !== null && (e = a.retryQueue, e !== null && (a.retryQueue = null, bn(l, e))));
        break;
      case 19:
        lt(t, l), tt(l), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, bn(l, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        lt(t, l), tt(l);
    }
  }
  function tt(l) {
    var t = l.flags;
    if (t & 2) {
      try {
        for (var e, a = l.return; a !== null; ) {
          if (tr(a)) {
            e = a;
            break;
          }
          a = a.return;
        }
        if (e == null) throw Error(r(160));
        switch (e.tag) {
          case 27:
            var u = e.stateNode, n = Oc(l);
            pn(l, n, u);
            break;
          case 5:
            var i = e.stateNode;
            e.flags & 32 && (Ie(i, ""), e.flags &= -33);
            var c = Oc(l);
            pn(l, c, i);
            break;
          case 3:
          case 4:
            var s = e.stateNode.containerInfo, y = Oc(l);
            Mc(
              l,
              y,
              s
            );
            break;
          default:
            throw Error(r(161));
        }
      } catch (b) {
        il(l, l.return, b);
      }
      l.flags &= -3;
    }
    t & 4096 && (l.flags &= -4097);
  }
  function or(l) {
    if (l.subtreeFlags & 1024)
      for (l = l.child; l !== null; ) {
        var t = l;
        or(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), l = l.sibling;
      }
  }
  function kt(l, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; )
        ur(l, t.alternate, t), t = t.sibling;
  }
  function Ze(l) {
    for (l = l.child; l !== null; ) {
      var t = l;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          de(4, t, t.return), Ze(t);
          break;
        case 1:
          Ht(t, t.return);
          var e = t.stateNode;
          typeof e.componentWillUnmount == "function" && Po(
            t,
            t.return,
            e
          ), Ze(t);
          break;
        case 27:
          yu(t.stateNode);
        case 26:
        case 5:
          Ht(t, t.return), Ze(t);
          break;
        case 22:
          t.memoizedState === null && Ze(t);
          break;
        case 30:
          Ze(t);
          break;
        default:
          Ze(t);
      }
      l = l.sibling;
    }
  }
  function Wt(l, t, e) {
    for (e = e && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var a = t.alternate, u = l, n = t, i = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Wt(
            u,
            n,
            e
          ), iu(4, n);
          break;
        case 1:
          if (Wt(
            u,
            n,
            e
          ), a = n, u = a.stateNode, typeof u.componentDidMount == "function")
            try {
              u.componentDidMount();
            } catch (y) {
              il(a, a.return, y);
            }
          if (a = n, u = a.updateQueue, u !== null) {
            var c = a.stateNode;
            try {
              var s = u.shared.hiddenCallbacks;
              if (s !== null)
                for (u.shared.hiddenCallbacks = null, u = 0; u < s.length; u++)
                  Qs(s[u], c);
            } catch (y) {
              il(a, a.return, y);
            }
          }
          e && i & 64 && Io(n), cu(n, n.return);
          break;
        case 27:
          er(n);
        case 26:
        case 5:
          Wt(
            u,
            n,
            e
          ), e && a === null && i & 4 && lr(n), cu(n, n.return);
          break;
        case 12:
          Wt(
            u,
            n,
            e
          );
          break;
        case 31:
          Wt(
            u,
            n,
            e
          ), e && i & 4 && cr(u, n);
          break;
        case 13:
          Wt(
            u,
            n,
            e
          ), e && i & 4 && fr(u, n);
          break;
        case 22:
          n.memoizedState === null && Wt(
            u,
            n,
            e
          ), cu(n, n.return);
          break;
        case 30:
          break;
        default:
          Wt(
            u,
            n,
            e
          );
      }
      t = t.sibling;
    }
  }
  function Rc(l, t) {
    var e = null;
    l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (e = l.memoizedState.cachePool.pool), l = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (l = t.memoizedState.cachePool.pool), l !== e && (l != null && l.refCount++, e != null && wa(e));
  }
  function Dc(l, t) {
    l = null, t.alternate !== null && (l = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== l && (t.refCount++, l != null && wa(l));
  }
  function Mt(l, t, e, a) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        rr(
          l,
          t,
          e,
          a
        ), t = t.sibling;
  }
  function rr(l, t, e, a) {
    var u = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Mt(
          l,
          t,
          e,
          a
        ), u & 2048 && iu(9, t);
        break;
      case 1:
        Mt(
          l,
          t,
          e,
          a
        );
        break;
      case 3:
        Mt(
          l,
          t,
          e,
          a
        ), u & 2048 && (l = null, t.alternate !== null && (l = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== l && (t.refCount++, l != null && wa(l)));
        break;
      case 12:
        if (u & 2048) {
          Mt(
            l,
            t,
            e,
            a
          ), l = t.stateNode;
          try {
            var n = t.memoizedProps, i = n.id, c = n.onPostCommit;
            typeof c == "function" && c(
              i,
              t.alternate === null ? "mount" : "update",
              l.passiveEffectDuration,
              -0
            );
          } catch (s) {
            il(t, t.return, s);
          }
        } else
          Mt(
            l,
            t,
            e,
            a
          );
        break;
      case 31:
        Mt(
          l,
          t,
          e,
          a
        );
        break;
      case 13:
        Mt(
          l,
          t,
          e,
          a
        );
        break;
      case 23:
        break;
      case 22:
        n = t.stateNode, i = t.alternate, t.memoizedState !== null ? n._visibility & 2 ? Mt(
          l,
          t,
          e,
          a
        ) : fu(l, t) : n._visibility & 2 ? Mt(
          l,
          t,
          e,
          a
        ) : (n._visibility |= 2, pa(
          l,
          t,
          e,
          a,
          (t.subtreeFlags & 10256) !== 0 || !1
        )), u & 2048 && Rc(i, t);
        break;
      case 24:
        Mt(
          l,
          t,
          e,
          a
        ), u & 2048 && Dc(t.alternate, t);
        break;
      default:
        Mt(
          l,
          t,
          e,
          a
        );
    }
  }
  function pa(l, t, e, a, u) {
    for (u = u && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child; t !== null; ) {
      var n = l, i = t, c = e, s = a, y = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          pa(
            n,
            i,
            c,
            s,
            u
          ), iu(8, i);
          break;
        case 23:
          break;
        case 22:
          var b = i.stateNode;
          i.memoizedState !== null ? b._visibility & 2 ? pa(
            n,
            i,
            c,
            s,
            u
          ) : fu(
            n,
            i
          ) : (b._visibility |= 2, pa(
            n,
            i,
            c,
            s,
            u
          )), u && y & 2048 && Rc(
            i.alternate,
            i
          );
          break;
        case 24:
          pa(
            n,
            i,
            c,
            s,
            u
          ), u && y & 2048 && Dc(i.alternate, i);
          break;
        default:
          pa(
            n,
            i,
            c,
            s,
            u
          );
      }
      t = t.sibling;
    }
  }
  function fu(l, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var e = l, a = t, u = a.flags;
        switch (a.tag) {
          case 22:
            fu(e, a), u & 2048 && Rc(
              a.alternate,
              a
            );
            break;
          case 24:
            fu(e, a), u & 2048 && Dc(a.alternate, a);
            break;
          default:
            fu(e, a);
        }
        t = t.sibling;
      }
  }
  var su = 8192;
  function ba(l, t, e) {
    if (l.subtreeFlags & su)
      for (l = l.child; l !== null; )
        dr(
          l,
          t,
          e
        ), l = l.sibling;
  }
  function dr(l, t, e) {
    switch (l.tag) {
      case 26:
        ba(
          l,
          t,
          e
        ), l.flags & su && l.memoizedState !== null && uh(
          e,
          Ot,
          l.memoizedState,
          l.memoizedProps
        );
        break;
      case 5:
        ba(
          l,
          t,
          e
        );
        break;
      case 3:
      case 4:
        var a = Ot;
        Ot = Un(l.stateNode.containerInfo), ba(
          l,
          t,
          e
        ), Ot = a;
        break;
      case 22:
        l.memoizedState === null && (a = l.alternate, a !== null && a.memoizedState !== null ? (a = su, su = 16777216, ba(
          l,
          t,
          e
        ), su = a) : ba(
          l,
          t,
          e
        ));
        break;
      default:
        ba(
          l,
          t,
          e
        );
    }
  }
  function mr(l) {
    var t = l.alternate;
    if (t !== null && (l = t.child, l !== null)) {
      t.child = null;
      do
        t = l.sibling, l.sibling = null, l = t;
      while (l !== null);
    }
  }
  function ou(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var e = 0; e < t.length; e++) {
          var a = t[e];
          Yl = a, hr(
            a,
            l
          );
        }
      mr(l);
    }
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        vr(l), l = l.sibling;
  }
  function vr(l) {
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        ou(l), l.flags & 2048 && de(9, l, l.return);
        break;
      case 3:
        ou(l);
        break;
      case 12:
        ou(l);
        break;
      case 22:
        var t = l.stateNode;
        l.memoizedState !== null && t._visibility & 2 && (l.return === null || l.return.tag !== 13) ? (t._visibility &= -3, Sn(l)) : ou(l);
        break;
      default:
        ou(l);
    }
  }
  function Sn(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var e = 0; e < t.length; e++) {
          var a = t[e];
          Yl = a, hr(
            a,
            l
          );
        }
      mr(l);
    }
    for (l = l.child; l !== null; ) {
      switch (t = l, t.tag) {
        case 0:
        case 11:
        case 15:
          de(8, t, t.return), Sn(t);
          break;
        case 22:
          e = t.stateNode, e._visibility & 2 && (e._visibility &= -3, Sn(t));
          break;
        default:
          Sn(t);
      }
      l = l.sibling;
    }
  }
  function hr(l, t) {
    for (; Yl !== null; ) {
      var e = Yl;
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          de(8, e, t);
          break;
        case 23:
        case 22:
          if (e.memoizedState !== null && e.memoizedState.cachePool !== null) {
            var a = e.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          wa(e.memoizedState.cache);
      }
      if (a = e.child, a !== null) a.return = e, Yl = a;
      else
        l: for (e = l; Yl !== null; ) {
          a = Yl;
          var u = a.sibling, n = a.return;
          if (nr(a), a === e) {
            Yl = null;
            break l;
          }
          if (u !== null) {
            u.return = n, Yl = u;
            break l;
          }
          Yl = n;
        }
    }
  }
  var bv = {
    getCacheForType: function(l) {
      var t = Ll(Rl), e = t.data.get(l);
      return e === void 0 && (e = l(), t.data.set(l, e)), e;
    },
    cacheSignal: function() {
      return Ll(Rl).controller.signal;
    }
  }, Sv = typeof WeakMap == "function" ? WeakMap : Map, al = 0, ml = null, $ = null, F = 0, nl = 0, rt = null, me = !1, Sa = !1, Nc = !1, Ft = 0, zl = 0, ve = 0, Ve = 0, Uc = 0, dt = 0, xa = 0, ru = null, et = null, Hc = !1, xn = 0, yr = 0, zn = 1 / 0, En = null, he = null, Cl = 0, ye = null, za = null, It = 0, Cc = 0, qc = null, gr = null, du = 0, Bc = null;
  function mt() {
    return (al & 2) !== 0 && F !== 0 ? F & -F : x.T !== null ? Zc() : Nf();
  }
  function pr() {
    if (dt === 0)
      if ((F & 536870912) === 0 || P) {
        var l = Ru;
        Ru <<= 1, (Ru & 3932160) === 0 && (Ru = 262144), dt = l;
      } else dt = 536870912;
    return l = st.current, l !== null && (l.flags |= 32), dt;
  }
  function at(l, t, e) {
    (l === ml && (nl === 2 || nl === 9) || l.cancelPendingCommit !== null) && (Ea(l, 0), ge(
      l,
      F,
      dt,
      !1
    )), Ua(l, e), ((al & 2) === 0 || l !== ml) && (l === ml && ((al & 2) === 0 && (Ve |= e), zl === 4 && ge(
      l,
      F,
      dt,
      !1
    )), Ct(l));
  }
  function br(l, t, e) {
    if ((al & 6) !== 0) throw Error(r(327));
    var a = !e && (t & 127) === 0 && (t & l.expiredLanes) === 0 || Na(l, t), u = a ? Ev(l, t) : Gc(l, t, !0), n = a;
    do {
      if (u === 0) {
        Sa && !a && ge(l, t, 0, !1);
        break;
      } else {
        if (e = l.current.alternate, n && !xv(e)) {
          u = Gc(l, t, !1), n = !1;
          continue;
        }
        if (u === 2) {
          if (n = t, l.errorRecoveryDisabledLanes & n)
            var i = 0;
          else
            i = l.pendingLanes & -536870913, i = i !== 0 ? i : i & 536870912 ? 536870912 : 0;
          if (i !== 0) {
            t = i;
            l: {
              var c = l;
              u = ru;
              var s = c.current.memoizedState.isDehydrated;
              if (s && (Ea(c, i).flags |= 256), i = Gc(
                c,
                i,
                !1
              ), i !== 2) {
                if (Nc && !s) {
                  c.errorRecoveryDisabledLanes |= n, Ve |= n, u = 4;
                  break l;
                }
                n = et, et = u, n !== null && (et === null ? et = n : et.push.apply(
                  et,
                  n
                ));
              }
              u = i;
            }
            if (n = !1, u !== 2) continue;
          }
        }
        if (u === 1) {
          Ea(l, 0), ge(l, t, 0, !0);
          break;
        }
        l: {
          switch (a = l, n = u, n) {
            case 0:
            case 1:
              throw Error(r(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              ge(
                a,
                t,
                dt,
                !me
              );
              break l;
            case 2:
              et = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(r(329));
          }
          if ((t & 62914560) === t && (u = xn + 300 - ut(), 10 < u)) {
            if (ge(
              a,
              t,
              dt,
              !me
            ), Nu(a, 0, !0) !== 0) break l;
            It = t, a.timeoutHandle = Wr(
              Sr.bind(
                null,
                a,
                e,
                et,
                En,
                Hc,
                t,
                dt,
                Ve,
                xa,
                me,
                n,
                "Throttled",
                -0,
                0
              ),
              u
            );
            break l;
          }
          Sr(
            a,
            e,
            et,
            En,
            Hc,
            t,
            dt,
            Ve,
            xa,
            me,
            n,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Ct(l);
  }
  function Sr(l, t, e, a, u, n, i, c, s, y, b, T, g, p) {
    if (l.timeoutHandle = -1, T = t.subtreeFlags, T & 8192 || (T & 16785408) === 16785408) {
      T = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Bt
      }, dr(
        t,
        n,
        T
      );
      var H = (n & 62914560) === n ? xn - ut() : (n & 4194048) === n ? yr - ut() : 0;
      if (H = nh(
        T,
        H
      ), H !== null) {
        It = n, l.cancelPendingCommit = H(
          Mr.bind(
            null,
            l,
            t,
            n,
            e,
            a,
            u,
            i,
            c,
            s,
            b,
            T,
            null,
            g,
            p
          )
        ), ge(l, n, i, !y);
        return;
      }
    }
    Mr(
      l,
      t,
      n,
      e,
      a,
      u,
      i,
      c,
      s
    );
  }
  function xv(l) {
    for (var t = l; ; ) {
      var e = t.tag;
      if ((e === 0 || e === 11 || e === 15) && t.flags & 16384 && (e = t.updateQueue, e !== null && (e = e.stores, e !== null)))
        for (var a = 0; a < e.length; a++) {
          var u = e[a], n = u.getSnapshot;
          u = u.value;
          try {
            if (!ct(n(), u)) return !1;
          } catch {
            return !1;
          }
        }
      if (e = t.child, t.subtreeFlags & 16384 && e !== null)
        e.return = t, t = e;
      else {
        if (t === l) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === l) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function ge(l, t, e, a) {
    t &= ~Uc, t &= ~Ve, l.suspendedLanes |= t, l.pingedLanes &= ~t, a && (l.warmLanes |= t), a = l.expirationTimes;
    for (var u = t; 0 < u; ) {
      var n = 31 - it(u), i = 1 << n;
      a[n] = -1, u &= ~i;
    }
    e !== 0 && _f(l, e, t);
  }
  function An() {
    return (al & 6) === 0 ? (mu(0), !1) : !0;
  }
  function Yc() {
    if ($ !== null) {
      if (nl === 0)
        var l = $.return;
      else
        l = $, Xt = Ce = null, lc(l), ma = null, ka = 0, l = $;
      for (; l !== null; )
        Fo(l.alternate, l), l = l.return;
      $ = null;
    }
  }
  function Ea(l, t) {
    var e = l.timeoutHandle;
    e !== -1 && (l.timeoutHandle = -1, Xv(e)), e = l.cancelPendingCommit, e !== null && (l.cancelPendingCommit = null, e()), It = 0, Yc(), ml = l, $ = e = Gt(l.current, null), F = t, nl = 0, rt = null, me = !1, Sa = Na(l, t), Nc = !1, xa = dt = Uc = Ve = ve = zl = 0, et = ru = null, Hc = !1, (t & 8) !== 0 && (t |= t & 32);
    var a = l.entangledLanes;
    if (a !== 0)
      for (l = l.entanglements, a &= t; 0 < a; ) {
        var u = 31 - it(a), n = 1 << u;
        t |= l[u], a &= ~n;
      }
    return Ft = t, Vu(), e;
  }
  function xr(l, t) {
    K = null, x.H = au, t === da || t === Iu ? (t = qs(), nl = 3) : t === Li ? (t = qs(), nl = 4) : nl = t === yc ? 8 : t !== null && typeof t == "object" && typeof t.then == "function" ? 6 : 1, rt = t, $ === null && (zl = 1, mn(
      l,
      pt(t, l.current)
    ));
  }
  function zr() {
    var l = st.current;
    return l === null ? !0 : (F & 4194048) === F ? zt === null : (F & 62914560) === F || (F & 536870912) !== 0 ? l === zt : !1;
  }
  function Er() {
    var l = x.H;
    return x.H = au, l === null ? au : l;
  }
  function Ar() {
    var l = x.A;
    return x.A = bv, l;
  }
  function Tn() {
    zl = 4, me || (F & 4194048) !== F && st.current !== null || (Sa = !0), (ve & 134217727) === 0 && (Ve & 134217727) === 0 || ml === null || ge(
      ml,
      F,
      dt,
      !1
    );
  }
  function Gc(l, t, e) {
    var a = al;
    al |= 2;
    var u = Er(), n = Ar();
    (ml !== l || F !== t) && (En = null, Ea(l, t)), t = !1;
    var i = zl;
    l: do
      try {
        if (nl !== 0 && $ !== null) {
          var c = $, s = rt;
          switch (nl) {
            case 8:
              Yc(), i = 6;
              break l;
            case 3:
            case 2:
            case 9:
            case 6:
              st.current === null && (t = !0);
              var y = nl;
              if (nl = 0, rt = null, Aa(l, c, s, y), e && Sa) {
                i = 0;
                break l;
              }
              break;
            default:
              y = nl, nl = 0, rt = null, Aa(l, c, s, y);
          }
        }
        zv(), i = zl;
        break;
      } catch (b) {
        xr(l, b);
      }
    while (!0);
    return t && l.shellSuspendCounter++, Xt = Ce = null, al = a, x.H = u, x.A = n, $ === null && (ml = null, F = 0, Vu()), i;
  }
  function zv() {
    for (; $ !== null; ) Tr($);
  }
  function Ev(l, t) {
    var e = al;
    al |= 2;
    var a = Er(), u = Ar();
    ml !== l || F !== t ? (En = null, zn = ut() + 500, Ea(l, t)) : Sa = Na(
      l,
      t
    );
    l: do
      try {
        if (nl !== 0 && $ !== null) {
          t = $;
          var n = rt;
          t: switch (nl) {
            case 1:
              nl = 0, rt = null, Aa(l, t, n, 1);
              break;
            case 2:
            case 9:
              if (Hs(n)) {
                nl = 0, rt = null, jr(t);
                break;
              }
              t = function() {
                nl !== 2 && nl !== 9 || ml !== l || (nl = 7), Ct(l);
              }, n.then(t, t);
              break l;
            case 3:
              nl = 7;
              break l;
            case 4:
              nl = 5;
              break l;
            case 7:
              Hs(n) ? (nl = 0, rt = null, jr(t)) : (nl = 0, rt = null, Aa(l, t, n, 7));
              break;
            case 5:
              var i = null;
              switch ($.tag) {
                case 26:
                  i = $.memoizedState;
                case 5:
                case 27:
                  var c = $;
                  if (i ? rd(i) : c.stateNode.complete) {
                    nl = 0, rt = null;
                    var s = c.sibling;
                    if (s !== null) $ = s;
                    else {
                      var y = c.return;
                      y !== null ? ($ = y, jn(y)) : $ = null;
                    }
                    break t;
                  }
              }
              nl = 0, rt = null, Aa(l, t, n, 5);
              break;
            case 6:
              nl = 0, rt = null, Aa(l, t, n, 6);
              break;
            case 8:
              Yc(), zl = 6;
              break l;
            default:
              throw Error(r(462));
          }
        }
        Av();
        break;
      } catch (b) {
        xr(l, b);
      }
    while (!0);
    return Xt = Ce = null, x.H = a, x.A = u, al = e, $ !== null ? 0 : (ml = null, F = 0, Vu(), zl);
  }
  function Av() {
    for (; $ !== null && !wd(); )
      Tr($);
  }
  function Tr(l) {
    var t = ko(l.alternate, l, Ft);
    l.memoizedProps = l.pendingProps, t === null ? jn(l) : $ = t;
  }
  function jr(l) {
    var t = l, e = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = Zo(
          e,
          t,
          t.pendingProps,
          t.type,
          void 0,
          F
        );
        break;
      case 11:
        t = Zo(
          e,
          t,
          t.pendingProps,
          t.type.render,
          t.ref,
          F
        );
        break;
      case 5:
        lc(t);
      default:
        Fo(e, t), t = $ = Es(t, Ft), t = ko(e, t, Ft);
    }
    l.memoizedProps = l.pendingProps, t === null ? jn(l) : $ = t;
  }
  function Aa(l, t, e, a) {
    Xt = Ce = null, lc(t), ma = null, ka = 0;
    var u = t.return;
    try {
      if (dv(
        l,
        u,
        t,
        e,
        F
      )) {
        zl = 1, mn(
          l,
          pt(e, l.current)
        ), $ = null;
        return;
      }
    } catch (n) {
      if (u !== null) throw $ = u, n;
      zl = 1, mn(
        l,
        pt(e, l.current)
      ), $ = null;
      return;
    }
    t.flags & 32768 ? (P || a === 1 ? l = !0 : Sa || (F & 536870912) !== 0 ? l = !1 : (me = l = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = st.current, a !== null && a.tag === 13 && (a.flags |= 16384))), Or(t, l)) : jn(t);
  }
  function jn(l) {
    var t = l;
    do {
      if ((t.flags & 32768) !== 0) {
        Or(
          t,
          me
        );
        return;
      }
      l = t.return;
      var e = hv(
        t.alternate,
        t,
        Ft
      );
      if (e !== null) {
        $ = e;
        return;
      }
      if (t = t.sibling, t !== null) {
        $ = t;
        return;
      }
      $ = t = l;
    } while (t !== null);
    zl === 0 && (zl = 5);
  }
  function Or(l, t) {
    do {
      var e = yv(l.alternate, l);
      if (e !== null) {
        e.flags &= 32767, $ = e;
        return;
      }
      if (e = l.return, e !== null && (e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null), !t && (l = l.sibling, l !== null)) {
        $ = l;
        return;
      }
      $ = l = e;
    } while (l !== null);
    zl = 6, $ = null;
  }
  function Mr(l, t, e, a, u, n, i, c, s) {
    l.cancelPendingCommit = null;
    do
      On();
    while (Cl !== 0);
    if ((al & 6) !== 0) throw Error(r(327));
    if (t !== null) {
      if (t === l.current) throw Error(r(177));
      if (n = t.lanes | t.childLanes, n |= Oi, am(
        l,
        e,
        n,
        i,
        c,
        s
      ), l === ml && ($ = ml = null, F = 0), za = t, ye = l, It = e, Cc = n, qc = u, gr = a, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (l.callbackNode = null, l.callbackPriority = 0, Mv(Mu, function() {
        return Ur(), null;
      })) : (l.callbackNode = null, l.callbackPriority = 0), a = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || a) {
        a = x.T, x.T = null, u = R.p, R.p = 2, i = al, al |= 4;
        try {
          gv(l, t, e);
        } finally {
          al = i, R.p = u, x.T = a;
        }
      }
      Cl = 1, _r(), Rr(), Dr();
    }
  }
  function _r() {
    if (Cl === 1) {
      Cl = 0;
      var l = ye, t = za, e = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || e) {
        e = x.T, x.T = null;
        var a = R.p;
        R.p = 2;
        var u = al;
        al |= 4;
        try {
          sr(t, l);
          var n = Fc, i = vs(l.containerInfo), c = n.focusedElem, s = n.selectionRange;
          if (i !== c && c && c.ownerDocument && ms(
            c.ownerDocument.documentElement,
            c
          )) {
            if (s !== null && zi(c)) {
              var y = s.start, b = s.end;
              if (b === void 0 && (b = y), "selectionStart" in c)
                c.selectionStart = y, c.selectionEnd = Math.min(
                  b,
                  c.value.length
                );
              else {
                var T = c.ownerDocument || document, g = T && T.defaultView || window;
                if (g.getSelection) {
                  var p = g.getSelection(), H = c.textContent.length, G = Math.min(s.start, H), ol = s.end === void 0 ? G : Math.min(s.end, H);
                  !p.extend && G > ol && (i = ol, ol = G, G = i);
                  var m = ds(
                    c,
                    G
                  ), o = ds(
                    c,
                    ol
                  );
                  if (m && o && (p.rangeCount !== 1 || p.anchorNode !== m.node || p.anchorOffset !== m.offset || p.focusNode !== o.node || p.focusOffset !== o.offset)) {
                    var h = T.createRange();
                    h.setStart(m.node, m.offset), p.removeAllRanges(), G > ol ? (p.addRange(h), p.extend(o.node, o.offset)) : (h.setEnd(o.node, o.offset), p.addRange(h));
                  }
                }
              }
            }
            for (T = [], p = c; p = p.parentNode; )
              p.nodeType === 1 && T.push({
                element: p,
                left: p.scrollLeft,
                top: p.scrollTop
              });
            for (typeof c.focus == "function" && c.focus(), c = 0; c < T.length; c++) {
              var z = T[c];
              z.element.scrollLeft = z.left, z.element.scrollTop = z.top;
            }
          }
          Gn = !!Wc, Fc = Wc = null;
        } finally {
          al = u, R.p = a, x.T = e;
        }
      }
      l.current = t, Cl = 2;
    }
  }
  function Rr() {
    if (Cl === 2) {
      Cl = 0;
      var l = ye, t = za, e = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || e) {
        e = x.T, x.T = null;
        var a = R.p;
        R.p = 2;
        var u = al;
        al |= 4;
        try {
          ur(l, t.alternate, t);
        } finally {
          al = u, R.p = a, x.T = e;
        }
      }
      Cl = 3;
    }
  }
  function Dr() {
    if (Cl === 4 || Cl === 3) {
      Cl = 0, $d();
      var l = ye, t = za, e = It, a = gr;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? Cl = 5 : (Cl = 0, za = ye = null, Nr(l, l.pendingLanes));
      var u = l.pendingLanes;
      if (u === 0 && (he = null), ai(e), t = t.stateNode, nt && typeof nt.onCommitFiberRoot == "function")
        try {
          nt.onCommitFiberRoot(
            Da,
            t,
            void 0,
            (t.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        t = x.T, u = R.p, R.p = 2, x.T = null;
        try {
          for (var n = l.onRecoverableError, i = 0; i < a.length; i++) {
            var c = a[i];
            n(c.value, {
              componentStack: c.stack
            });
          }
        } finally {
          x.T = t, R.p = u;
        }
      }
      (It & 3) !== 0 && On(), Ct(l), u = l.pendingLanes, (e & 261930) !== 0 && (u & 42) !== 0 ? l === Bc ? du++ : (du = 0, Bc = l) : du = 0, mu(0);
    }
  }
  function Nr(l, t) {
    (l.pooledCacheLanes &= t) === 0 && (t = l.pooledCache, t != null && (l.pooledCache = null, wa(t)));
  }
  function On() {
    return _r(), Rr(), Dr(), Ur();
  }
  function Ur() {
    if (Cl !== 5) return !1;
    var l = ye, t = Cc;
    Cc = 0;
    var e = ai(It), a = x.T, u = R.p;
    try {
      R.p = 32 > e ? 32 : e, x.T = null, e = qc, qc = null;
      var n = ye, i = It;
      if (Cl = 0, za = ye = null, It = 0, (al & 6) !== 0) throw Error(r(331));
      var c = al;
      if (al |= 4, vr(n.current), rr(
        n,
        n.current,
        i,
        e
      ), al = c, mu(0, !1), nt && typeof nt.onPostCommitFiberRoot == "function")
        try {
          nt.onPostCommitFiberRoot(Da, n);
        } catch {
        }
      return !0;
    } finally {
      R.p = u, x.T = a, Nr(l, t);
    }
  }
  function Hr(l, t, e) {
    t = pt(e, t), t = hc(l.stateNode, t, 2), l = se(l, t, 2), l !== null && (Ua(l, 2), Ct(l));
  }
  function il(l, t, e) {
    if (l.tag === 3)
      Hr(l, l, e);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          Hr(
            t,
            l,
            e
          );
          break;
        } else if (t.tag === 1) {
          var a = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (he === null || !he.has(a))) {
            l = pt(e, l), e = Co(2), a = se(t, e, 2), a !== null && (qo(
              e,
              a,
              t,
              l
            ), Ua(a, 2), Ct(a));
            break;
          }
        }
        t = t.return;
      }
  }
  function Qc(l, t, e) {
    var a = l.pingCache;
    if (a === null) {
      a = l.pingCache = new Sv();
      var u = /* @__PURE__ */ new Set();
      a.set(t, u);
    } else
      u = a.get(t), u === void 0 && (u = /* @__PURE__ */ new Set(), a.set(t, u));
    u.has(e) || (Nc = !0, u.add(e), l = Tv.bind(null, l, t, e), t.then(l, l));
  }
  function Tv(l, t, e) {
    var a = l.pingCache;
    a !== null && a.delete(t), l.pingedLanes |= l.suspendedLanes & e, l.warmLanes &= ~e, ml === l && (F & e) === e && (zl === 4 || zl === 3 && (F & 62914560) === F && 300 > ut() - xn ? (al & 2) === 0 && Ea(l, 0) : Uc |= e, xa === F && (xa = 0)), Ct(l);
  }
  function Cr(l, t) {
    t === 0 && (t = Mf()), l = Ne(l, t), l !== null && (Ua(l, t), Ct(l));
  }
  function jv(l) {
    var t = l.memoizedState, e = 0;
    t !== null && (e = t.retryLane), Cr(l, e);
  }
  function Ov(l, t) {
    var e = 0;
    switch (l.tag) {
      case 31:
      case 13:
        var a = l.stateNode, u = l.memoizedState;
        u !== null && (e = u.retryLane);
        break;
      case 19:
        a = l.stateNode;
        break;
      case 22:
        a = l.stateNode._retryCache;
        break;
      default:
        throw Error(r(314));
    }
    a !== null && a.delete(t), Cr(l, e);
  }
  function Mv(l, t) {
    return Pn(l, t);
  }
  var Mn = null, Ta = null, Xc = !1, _n = !1, Lc = !1, pe = 0;
  function Ct(l) {
    l !== Ta && l.next === null && (Ta === null ? Mn = Ta = l : Ta = Ta.next = l), _n = !0, Xc || (Xc = !0, Rv());
  }
  function mu(l, t) {
    if (!Lc && _n) {
      Lc = !0;
      do
        for (var e = !1, a = Mn; a !== null; ) {
          if (l !== 0) {
            var u = a.pendingLanes;
            if (u === 0) var n = 0;
            else {
              var i = a.suspendedLanes, c = a.pingedLanes;
              n = (1 << 31 - it(42 | l) + 1) - 1, n &= u & ~(i & ~c), n = n & 201326741 ? n & 201326741 | 1 : n ? n | 2 : 0;
            }
            n !== 0 && (e = !0, Gr(a, n));
          } else
            n = F, n = Nu(
              a,
              a === ml ? n : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (n & 3) === 0 || Na(a, n) || (e = !0, Gr(a, n));
          a = a.next;
        }
      while (e);
      Lc = !1;
    }
  }
  function _v() {
    qr();
  }
  function qr() {
    _n = Xc = !1;
    var l = 0;
    pe !== 0 && Qv() && (l = pe);
    for (var t = ut(), e = null, a = Mn; a !== null; ) {
      var u = a.next, n = Br(a, t);
      n === 0 ? (a.next = null, e === null ? Mn = u : e.next = u, u === null && (Ta = e)) : (e = a, (l !== 0 || (n & 3) !== 0) && (_n = !0)), a = u;
    }
    Cl !== 0 && Cl !== 5 || mu(l), pe !== 0 && (pe = 0);
  }
  function Br(l, t) {
    for (var e = l.suspendedLanes, a = l.pingedLanes, u = l.expirationTimes, n = l.pendingLanes & -62914561; 0 < n; ) {
      var i = 31 - it(n), c = 1 << i, s = u[i];
      s === -1 ? ((c & e) === 0 || (c & a) !== 0) && (u[i] = em(c, t)) : s <= t && (l.expiredLanes |= c), n &= ~c;
    }
    if (t = ml, e = F, e = Nu(
      l,
      l === t ? e : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), a = l.callbackNode, e === 0 || l === t && (nl === 2 || nl === 9) || l.cancelPendingCommit !== null)
      return a !== null && a !== null && li(a), l.callbackNode = null, l.callbackPriority = 0;
    if ((e & 3) === 0 || Na(l, e)) {
      if (t = e & -e, t === l.callbackPriority) return t;
      switch (a !== null && li(a), ai(e)) {
        case 2:
        case 8:
          e = jf;
          break;
        case 32:
          e = Mu;
          break;
        case 268435456:
          e = Of;
          break;
        default:
          e = Mu;
      }
      return a = Yr.bind(null, l), e = Pn(e, a), l.callbackPriority = t, l.callbackNode = e, t;
    }
    return a !== null && a !== null && li(a), l.callbackPriority = 2, l.callbackNode = null, 2;
  }
  function Yr(l, t) {
    if (Cl !== 0 && Cl !== 5)
      return l.callbackNode = null, l.callbackPriority = 0, null;
    var e = l.callbackNode;
    if (On() && l.callbackNode !== e)
      return null;
    var a = F;
    return a = Nu(
      l,
      l === ml ? a : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), a === 0 ? null : (br(l, a, t), Br(l, ut()), l.callbackNode != null && l.callbackNode === e ? Yr.bind(null, l) : null);
  }
  function Gr(l, t) {
    if (On()) return null;
    br(l, t, !0);
  }
  function Rv() {
    Lv(function() {
      (al & 6) !== 0 ? Pn(
        Tf,
        _v
      ) : qr();
    });
  }
  function Zc() {
    if (pe === 0) {
      var l = oa;
      l === 0 && (l = _u, _u <<= 1, (_u & 261888) === 0 && (_u = 256)), pe = l;
    }
    return pe;
  }
  function Qr(l) {
    return l == null || typeof l == "symbol" || typeof l == "boolean" ? null : typeof l == "function" ? l : qu("" + l);
  }
  function Xr(l, t) {
    var e = t.ownerDocument.createElement("input");
    return e.name = t.name, e.value = t.value, l.id && e.setAttribute("form", l.id), t.parentNode.insertBefore(e, t), l = new FormData(l), e.parentNode.removeChild(e), l;
  }
  function Dv(l, t, e, a, u) {
    if (t === "submit" && e && e.stateNode === u) {
      var n = Qr(
        (u[Fl] || null).action
      ), i = a.submitter;
      i && (t = (t = i[Fl] || null) ? Qr(t.formAction) : i.getAttribute("formAction"), t !== null && (n = t, i = null));
      var c = new Qu(
        "action",
        "action",
        null,
        a,
        u
      );
      l.push({
        event: c,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (pe !== 0) {
                  var s = i ? Xr(u, i) : new FormData(u);
                  sc(
                    e,
                    {
                      pending: !0,
                      data: s,
                      method: u.method,
                      action: n
                    },
                    null,
                    s
                  );
                }
              } else
                typeof n == "function" && (c.preventDefault(), s = i ? Xr(u, i) : new FormData(u), sc(
                  e,
                  {
                    pending: !0,
                    data: s,
                    method: u.method,
                    action: n
                  },
                  n,
                  s
                ));
            },
            currentTarget: u
          }
        ]
      });
    }
  }
  for (var Vc = 0; Vc < ji.length; Vc++) {
    var Kc = ji[Vc], Nv = Kc.toLowerCase(), Uv = Kc[0].toUpperCase() + Kc.slice(1);
    jt(
      Nv,
      "on" + Uv
    );
  }
  jt(gs, "onAnimationEnd"), jt(ps, "onAnimationIteration"), jt(bs, "onAnimationStart"), jt("dblclick", "onDoubleClick"), jt("focusin", "onFocus"), jt("focusout", "onBlur"), jt(km, "onTransitionRun"), jt(Wm, "onTransitionStart"), jt(Fm, "onTransitionCancel"), jt(Ss, "onTransitionEnd"), We("onMouseEnter", ["mouseout", "mouseover"]), We("onMouseLeave", ["mouseout", "mouseover"]), We("onPointerEnter", ["pointerout", "pointerover"]), We("onPointerLeave", ["pointerout", "pointerover"]), Me(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Me(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Me("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Me(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Me(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Me(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var vu = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), Hv = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(vu)
  );
  function Lr(l, t) {
    t = (t & 4) !== 0;
    for (var e = 0; e < l.length; e++) {
      var a = l[e], u = a.event;
      a = a.listeners;
      l: {
        var n = void 0;
        if (t)
          for (var i = a.length - 1; 0 <= i; i--) {
            var c = a[i], s = c.instance, y = c.currentTarget;
            if (c = c.listener, s !== n && u.isPropagationStopped())
              break l;
            n = c, u.currentTarget = y;
            try {
              n(u);
            } catch (b) {
              Zu(b);
            }
            u.currentTarget = null, n = s;
          }
        else
          for (i = 0; i < a.length; i++) {
            if (c = a[i], s = c.instance, y = c.currentTarget, c = c.listener, s !== n && u.isPropagationStopped())
              break l;
            n = c, u.currentTarget = y;
            try {
              n(u);
            } catch (b) {
              Zu(b);
            }
            u.currentTarget = null, n = s;
          }
      }
    }
  }
  function k(l, t) {
    var e = t[ui];
    e === void 0 && (e = t[ui] = /* @__PURE__ */ new Set());
    var a = l + "__bubble";
    e.has(a) || (Zr(t, l, 2, !1), e.add(a));
  }
  function Jc(l, t, e) {
    var a = 0;
    t && (a |= 4), Zr(
      e,
      l,
      a,
      t
    );
  }
  var Rn = "_reactListening" + Math.random().toString(36).slice(2);
  function wc(l) {
    if (!l[Rn]) {
      l[Rn] = !0, Cf.forEach(function(e) {
        e !== "selectionchange" && (Hv.has(e) || Jc(e, !1, l), Jc(e, !0, l));
      });
      var t = l.nodeType === 9 ? l : l.ownerDocument;
      t === null || t[Rn] || (t[Rn] = !0, Jc("selectionchange", !1, t));
    }
  }
  function Zr(l, t, e, a) {
    switch (pd(t)) {
      case 2:
        var u = fh;
        break;
      case 8:
        u = sh;
        break;
      default:
        u = sf;
    }
    e = u.bind(
      null,
      t,
      e,
      l
    ), u = void 0, !mi || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (u = !0), a ? u !== void 0 ? l.addEventListener(t, e, {
      capture: !0,
      passive: u
    }) : l.addEventListener(t, e, !0) : u !== void 0 ? l.addEventListener(t, e, {
      passive: u
    }) : l.addEventListener(t, e, !1);
  }
  function $c(l, t, e, a, u) {
    var n = a;
    if ((t & 1) === 0 && (t & 2) === 0 && a !== null)
      l: for (; ; ) {
        if (a === null) return;
        var i = a.tag;
        if (i === 3 || i === 4) {
          var c = a.stateNode.containerInfo;
          if (c === u) break;
          if (i === 4)
            for (i = a.return; i !== null; ) {
              var s = i.tag;
              if ((s === 3 || s === 4) && i.stateNode.containerInfo === u)
                return;
              i = i.return;
            }
          for (; c !== null; ) {
            if (i = we(c), i === null) return;
            if (s = i.tag, s === 5 || s === 6 || s === 26 || s === 27) {
              a = n = i;
              continue l;
            }
            c = c.parentNode;
          }
        }
        a = a.return;
      }
    wf(function() {
      var y = n, b = ri(e), T = [];
      l: {
        var g = xs.get(l);
        if (g !== void 0) {
          var p = Qu, H = l;
          switch (l) {
            case "keypress":
              if (Yu(e) === 0) break l;
            case "keydown":
            case "keyup":
              p = Om;
              break;
            case "focusin":
              H = "focus", p = gi;
              break;
            case "focusout":
              H = "blur", p = gi;
              break;
            case "beforeblur":
            case "afterblur":
              p = gi;
              break;
            case "click":
              if (e.button === 2) break l;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              p = Wf;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              p = hm;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              p = Rm;
              break;
            case gs:
            case ps:
            case bs:
              p = pm;
              break;
            case Ss:
              p = Nm;
              break;
            case "scroll":
            case "scrollend":
              p = mm;
              break;
            case "wheel":
              p = Hm;
              break;
            case "copy":
            case "cut":
            case "paste":
              p = Sm;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              p = If;
              break;
            case "toggle":
            case "beforetoggle":
              p = qm;
          }
          var G = (t & 4) !== 0, ol = !G && (l === "scroll" || l === "scrollend"), m = G ? g !== null ? g + "Capture" : null : g;
          G = [];
          for (var o = y, h; o !== null; ) {
            var z = o;
            if (h = z.stateNode, z = z.tag, z !== 5 && z !== 26 && z !== 27 || h === null || m === null || (z = qa(o, m), z != null && G.push(
              hu(o, z, h)
            )), ol) break;
            o = o.return;
          }
          0 < G.length && (g = new p(
            g,
            H,
            null,
            e,
            b
          ), T.push({ event: g, listeners: G }));
        }
      }
      if ((t & 7) === 0) {
        l: {
          if (g = l === "mouseover" || l === "pointerover", p = l === "mouseout" || l === "pointerout", g && e !== oi && (H = e.relatedTarget || e.fromElement) && (we(H) || H[Je]))
            break l;
          if ((p || g) && (g = b.window === b ? b : (g = b.ownerDocument) ? g.defaultView || g.parentWindow : window, p ? (H = e.relatedTarget || e.toElement, p = y, H = H ? we(H) : null, H !== null && (ol = _(H), G = H.tag, H !== ol || G !== 5 && G !== 27 && G !== 6) && (H = null)) : (p = null, H = y), p !== H)) {
            if (G = Wf, z = "onMouseLeave", m = "onMouseEnter", o = "mouse", (l === "pointerout" || l === "pointerover") && (G = If, z = "onPointerLeave", m = "onPointerEnter", o = "pointer"), ol = p == null ? g : Ca(p), h = H == null ? g : Ca(H), g = new G(
              z,
              o + "leave",
              p,
              e,
              b
            ), g.target = ol, g.relatedTarget = h, z = null, we(b) === y && (G = new G(
              m,
              o + "enter",
              H,
              e,
              b
            ), G.target = h, G.relatedTarget = ol, z = G), ol = z, p && H)
              t: {
                for (G = Cv, m = p, o = H, h = 0, z = m; z; z = G(z))
                  h++;
                z = 0;
                for (var B = o; B; B = G(B))
                  z++;
                for (; 0 < h - z; )
                  m = G(m), h--;
                for (; 0 < z - h; )
                  o = G(o), z--;
                for (; h--; ) {
                  if (m === o || o !== null && m === o.alternate) {
                    G = m;
                    break t;
                  }
                  m = G(m), o = G(o);
                }
                G = null;
              }
            else G = null;
            p !== null && Vr(
              T,
              g,
              p,
              G,
              !1
            ), H !== null && ol !== null && Vr(
              T,
              ol,
              H,
              G,
              !0
            );
          }
        }
        l: {
          if (g = y ? Ca(y) : window, p = g.nodeName && g.nodeName.toLowerCase(), p === "select" || p === "input" && g.type === "file")
            var ll = is;
          else if (us(g))
            if (cs)
              ll = Jm;
            else {
              ll = Vm;
              var q = Zm;
            }
          else
            p = g.nodeName, !p || p.toLowerCase() !== "input" || g.type !== "checkbox" && g.type !== "radio" ? y && si(y.elementType) && (ll = is) : ll = Km;
          if (ll && (ll = ll(l, y))) {
            ns(
              T,
              ll,
              e,
              b
            );
            break l;
          }
          q && q(l, g, y), l === "focusout" && y && g.type === "number" && y.memoizedProps.value != null && fi(g, "number", g.value);
        }
        switch (q = y ? Ca(y) : window, l) {
          case "focusin":
            (us(q) || q.contentEditable === "true") && (ea = q, Ei = y, Va = null);
            break;
          case "focusout":
            Va = Ei = ea = null;
            break;
          case "mousedown":
            Ai = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Ai = !1, hs(T, e, b);
            break;
          case "selectionchange":
            if ($m) break;
          case "keydown":
          case "keyup":
            hs(T, e, b);
        }
        var J;
        if (bi)
          l: {
            switch (l) {
              case "compositionstart":
                var I = "onCompositionStart";
                break l;
              case "compositionend":
                I = "onCompositionEnd";
                break l;
              case "compositionupdate":
                I = "onCompositionUpdate";
                break l;
            }
            I = void 0;
          }
        else
          ta ? es(l, e) && (I = "onCompositionEnd") : l === "keydown" && e.keyCode === 229 && (I = "onCompositionStart");
        I && (Pf && e.locale !== "ko" && (ta || I !== "onCompositionStart" ? I === "onCompositionEnd" && ta && (J = $f()) : (ee = b, vi = "value" in ee ? ee.value : ee.textContent, ta = !0)), q = Dn(y, I), 0 < q.length && (I = new Ff(
          I,
          l,
          null,
          e,
          b
        ), T.push({ event: I, listeners: q }), J ? I.data = J : (J = as(e), J !== null && (I.data = J)))), (J = Ym ? Gm(l, e) : Qm(l, e)) && (I = Dn(y, "onBeforeInput"), 0 < I.length && (q = new Ff(
          "onBeforeInput",
          "beforeinput",
          null,
          e,
          b
        ), T.push({
          event: q,
          listeners: I
        }), q.data = J)), Dv(
          T,
          l,
          y,
          e,
          b
        );
      }
      Lr(T, t);
    });
  }
  function hu(l, t, e) {
    return {
      instance: l,
      listener: t,
      currentTarget: e
    };
  }
  function Dn(l, t) {
    for (var e = t + "Capture", a = []; l !== null; ) {
      var u = l, n = u.stateNode;
      if (u = u.tag, u !== 5 && u !== 26 && u !== 27 || n === null || (u = qa(l, e), u != null && a.unshift(
        hu(l, u, n)
      ), u = qa(l, t), u != null && a.push(
        hu(l, u, n)
      )), l.tag === 3) return a;
      l = l.return;
    }
    return [];
  }
  function Cv(l) {
    if (l === null) return null;
    do
      l = l.return;
    while (l && l.tag !== 5 && l.tag !== 27);
    return l || null;
  }
  function Vr(l, t, e, a, u) {
    for (var n = t._reactName, i = []; e !== null && e !== a; ) {
      var c = e, s = c.alternate, y = c.stateNode;
      if (c = c.tag, s !== null && s === a) break;
      c !== 5 && c !== 26 && c !== 27 || y === null || (s = y, u ? (y = qa(e, n), y != null && i.unshift(
        hu(e, y, s)
      )) : u || (y = qa(e, n), y != null && i.push(
        hu(e, y, s)
      ))), e = e.return;
    }
    i.length !== 0 && l.push({ event: t, listeners: i });
  }
  var qv = /\r\n?/g, Bv = /\u0000|\uFFFD/g;
  function Kr(l) {
    return (typeof l == "string" ? l : "" + l).replace(qv, `
`).replace(Bv, "");
  }
  function Jr(l, t) {
    return t = Kr(t), Kr(l) === t;
  }
  function sl(l, t, e, a, u, n) {
    switch (e) {
      case "children":
        typeof a == "string" ? t === "body" || t === "textarea" && a === "" || Ie(l, a) : (typeof a == "number" || typeof a == "bigint") && t !== "body" && Ie(l, "" + a);
        break;
      case "className":
        Hu(l, "class", a);
        break;
      case "tabIndex":
        Hu(l, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Hu(l, e, a);
        break;
      case "style":
        Kf(l, a, n);
        break;
      case "data":
        if (t !== "object") {
          Hu(l, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (t !== "a" || e !== "href")) {
          l.removeAttribute(e);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          l.removeAttribute(e);
          break;
        }
        a = qu("" + a), l.setAttribute(e, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          l.setAttribute(
            e,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof n == "function" && (e === "formAction" ? (t !== "input" && sl(l, t, "name", u.name, u, null), sl(
            l,
            t,
            "formEncType",
            u.formEncType,
            u,
            null
          ), sl(
            l,
            t,
            "formMethod",
            u.formMethod,
            u,
            null
          ), sl(
            l,
            t,
            "formTarget",
            u.formTarget,
            u,
            null
          )) : (sl(l, t, "encType", u.encType, u, null), sl(l, t, "method", u.method, u, null), sl(l, t, "target", u.target, u, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          l.removeAttribute(e);
          break;
        }
        a = qu("" + a), l.setAttribute(e, a);
        break;
      case "onClick":
        a != null && (l.onclick = Bt);
        break;
      case "onScroll":
        a != null && k("scroll", l);
        break;
      case "onScrollEnd":
        a != null && k("scrollend", l);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(r(61));
          if (e = a.__html, e != null) {
            if (u.children != null) throw Error(r(60));
            l.innerHTML = e;
          }
        }
        break;
      case "multiple":
        l.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        l.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          l.removeAttribute("xlink:href");
          break;
        }
        e = qu("" + a), l.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          e
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, "" + a) : l.removeAttribute(e);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, "") : l.removeAttribute(e);
        break;
      case "capture":
      case "download":
        a === !0 ? l.setAttribute(e, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, a) : l.removeAttribute(e);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? l.setAttribute(e, a) : l.removeAttribute(e);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? l.removeAttribute(e) : l.setAttribute(e, a);
        break;
      case "popover":
        k("beforetoggle", l), k("toggle", l), Uu(l, "popover", a);
        break;
      case "xlinkActuate":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        qt(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        qt(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        qt(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        Uu(l, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < e.length) || e[0] !== "o" && e[0] !== "O" || e[1] !== "n" && e[1] !== "N") && (e = rm.get(e) || e, Uu(l, e, a));
    }
  }
  function kc(l, t, e, a, u, n) {
    switch (e) {
      case "style":
        Kf(l, a, n);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(r(61));
          if (e = a.__html, e != null) {
            if (u.children != null) throw Error(r(60));
            l.innerHTML = e;
          }
        }
        break;
      case "children":
        typeof a == "string" ? Ie(l, a) : (typeof a == "number" || typeof a == "bigint") && Ie(l, "" + a);
        break;
      case "onScroll":
        a != null && k("scroll", l);
        break;
      case "onScrollEnd":
        a != null && k("scrollend", l);
        break;
      case "onClick":
        a != null && (l.onclick = Bt);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!qf.hasOwnProperty(e))
          l: {
            if (e[0] === "o" && e[1] === "n" && (u = e.endsWith("Capture"), t = e.slice(2, u ? e.length - 7 : void 0), n = l[Fl] || null, n = n != null ? n[e] : null, typeof n == "function" && l.removeEventListener(t, n, u), typeof a == "function")) {
              typeof n != "function" && n !== null && (e in l ? l[e] = null : l.hasAttribute(e) && l.removeAttribute(e)), l.addEventListener(t, a, u);
              break l;
            }
            e in l ? l[e] = a : a === !0 ? l.setAttribute(e, "") : Uu(l, e, a);
          }
    }
  }
  function Vl(l, t, e) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        k("error", l), k("load", l);
        var a = !1, u = !1, n;
        for (n in e)
          if (e.hasOwnProperty(n)) {
            var i = e[n];
            if (i != null)
              switch (n) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  u = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(r(137, t));
                default:
                  sl(l, t, n, i, e, null);
              }
          }
        u && sl(l, t, "srcSet", e.srcSet, e, null), a && sl(l, t, "src", e.src, e, null);
        return;
      case "input":
        k("invalid", l);
        var c = n = i = u = null, s = null, y = null;
        for (a in e)
          if (e.hasOwnProperty(a)) {
            var b = e[a];
            if (b != null)
              switch (a) {
                case "name":
                  u = b;
                  break;
                case "type":
                  i = b;
                  break;
                case "checked":
                  s = b;
                  break;
                case "defaultChecked":
                  y = b;
                  break;
                case "value":
                  n = b;
                  break;
                case "defaultValue":
                  c = b;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (b != null)
                    throw Error(r(137, t));
                  break;
                default:
                  sl(l, t, a, b, e, null);
              }
          }
        Xf(
          l,
          n,
          c,
          s,
          y,
          i,
          u,
          !1
        );
        return;
      case "select":
        k("invalid", l), a = i = n = null;
        for (u in e)
          if (e.hasOwnProperty(u) && (c = e[u], c != null))
            switch (u) {
              case "value":
                n = c;
                break;
              case "defaultValue":
                i = c;
                break;
              case "multiple":
                a = c;
              default:
                sl(l, t, u, c, e, null);
            }
        t = n, e = i, l.multiple = !!a, t != null ? Fe(l, !!a, t, !1) : e != null && Fe(l, !!a, e, !0);
        return;
      case "textarea":
        k("invalid", l), n = u = a = null;
        for (i in e)
          if (e.hasOwnProperty(i) && (c = e[i], c != null))
            switch (i) {
              case "value":
                a = c;
                break;
              case "defaultValue":
                u = c;
                break;
              case "children":
                n = c;
                break;
              case "dangerouslySetInnerHTML":
                if (c != null) throw Error(r(91));
                break;
              default:
                sl(l, t, i, c, e, null);
            }
        Zf(l, a, u, n);
        return;
      case "option":
        for (s in e)
          if (e.hasOwnProperty(s) && (a = e[s], a != null))
            switch (s) {
              case "selected":
                l.selected = a && typeof a != "function" && typeof a != "symbol";
                break;
              default:
                sl(l, t, s, a, e, null);
            }
        return;
      case "dialog":
        k("beforetoggle", l), k("toggle", l), k("cancel", l), k("close", l);
        break;
      case "iframe":
      case "object":
        k("load", l);
        break;
      case "video":
      case "audio":
        for (a = 0; a < vu.length; a++)
          k(vu[a], l);
        break;
      case "image":
        k("error", l), k("load", l);
        break;
      case "details":
        k("toggle", l);
        break;
      case "embed":
      case "source":
      case "link":
        k("error", l), k("load", l);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (y in e)
          if (e.hasOwnProperty(y) && (a = e[y], a != null))
            switch (y) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(r(137, t));
              default:
                sl(l, t, y, a, e, null);
            }
        return;
      default:
        if (si(t)) {
          for (b in e)
            e.hasOwnProperty(b) && (a = e[b], a !== void 0 && kc(
              l,
              t,
              b,
              a,
              e,
              void 0
            ));
          return;
        }
    }
    for (c in e)
      e.hasOwnProperty(c) && (a = e[c], a != null && sl(l, t, c, a, e, null));
  }
  function Yv(l, t, e, a) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var u = null, n = null, i = null, c = null, s = null, y = null, b = null;
        for (p in e) {
          var T = e[p];
          if (e.hasOwnProperty(p) && T != null)
            switch (p) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                s = T;
              default:
                a.hasOwnProperty(p) || sl(l, t, p, null, a, T);
            }
        }
        for (var g in a) {
          var p = a[g];
          if (T = e[g], a.hasOwnProperty(g) && (p != null || T != null))
            switch (g) {
              case "type":
                n = p;
                break;
              case "name":
                u = p;
                break;
              case "checked":
                y = p;
                break;
              case "defaultChecked":
                b = p;
                break;
              case "value":
                i = p;
                break;
              case "defaultValue":
                c = p;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (p != null)
                  throw Error(r(137, t));
                break;
              default:
                p !== T && sl(
                  l,
                  t,
                  g,
                  p,
                  a,
                  T
                );
            }
        }
        ci(
          l,
          i,
          c,
          s,
          y,
          b,
          n,
          u
        );
        return;
      case "select":
        p = i = c = g = null;
        for (n in e)
          if (s = e[n], e.hasOwnProperty(n) && s != null)
            switch (n) {
              case "value":
                break;
              case "multiple":
                p = s;
              default:
                a.hasOwnProperty(n) || sl(
                  l,
                  t,
                  n,
                  null,
                  a,
                  s
                );
            }
        for (u in a)
          if (n = a[u], s = e[u], a.hasOwnProperty(u) && (n != null || s != null))
            switch (u) {
              case "value":
                g = n;
                break;
              case "defaultValue":
                c = n;
                break;
              case "multiple":
                i = n;
              default:
                n !== s && sl(
                  l,
                  t,
                  u,
                  n,
                  a,
                  s
                );
            }
        t = c, e = i, a = p, g != null ? Fe(l, !!e, g, !1) : !!a != !!e && (t != null ? Fe(l, !!e, t, !0) : Fe(l, !!e, e ? [] : "", !1));
        return;
      case "textarea":
        p = g = null;
        for (c in e)
          if (u = e[c], e.hasOwnProperty(c) && u != null && !a.hasOwnProperty(c))
            switch (c) {
              case "value":
                break;
              case "children":
                break;
              default:
                sl(l, t, c, null, a, u);
            }
        for (i in a)
          if (u = a[i], n = e[i], a.hasOwnProperty(i) && (u != null || n != null))
            switch (i) {
              case "value":
                g = u;
                break;
              case "defaultValue":
                p = u;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (u != null) throw Error(r(91));
                break;
              default:
                u !== n && sl(l, t, i, u, a, n);
            }
        Lf(l, g, p);
        return;
      case "option":
        for (var H in e)
          if (g = e[H], e.hasOwnProperty(H) && g != null && !a.hasOwnProperty(H))
            switch (H) {
              case "selected":
                l.selected = !1;
                break;
              default:
                sl(
                  l,
                  t,
                  H,
                  null,
                  a,
                  g
                );
            }
        for (s in a)
          if (g = a[s], p = e[s], a.hasOwnProperty(s) && g !== p && (g != null || p != null))
            switch (s) {
              case "selected":
                l.selected = g && typeof g != "function" && typeof g != "symbol";
                break;
              default:
                sl(
                  l,
                  t,
                  s,
                  g,
                  a,
                  p
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var G in e)
          g = e[G], e.hasOwnProperty(G) && g != null && !a.hasOwnProperty(G) && sl(l, t, G, null, a, g);
        for (y in a)
          if (g = a[y], p = e[y], a.hasOwnProperty(y) && g !== p && (g != null || p != null))
            switch (y) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (g != null)
                  throw Error(r(137, t));
                break;
              default:
                sl(
                  l,
                  t,
                  y,
                  g,
                  a,
                  p
                );
            }
        return;
      default:
        if (si(t)) {
          for (var ol in e)
            g = e[ol], e.hasOwnProperty(ol) && g !== void 0 && !a.hasOwnProperty(ol) && kc(
              l,
              t,
              ol,
              void 0,
              a,
              g
            );
          for (b in a)
            g = a[b], p = e[b], !a.hasOwnProperty(b) || g === p || g === void 0 && p === void 0 || kc(
              l,
              t,
              b,
              g,
              a,
              p
            );
          return;
        }
    }
    for (var m in e)
      g = e[m], e.hasOwnProperty(m) && g != null && !a.hasOwnProperty(m) && sl(l, t, m, null, a, g);
    for (T in a)
      g = a[T], p = e[T], !a.hasOwnProperty(T) || g === p || g == null && p == null || sl(l, t, T, g, a, p);
  }
  function wr(l) {
    switch (l) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function Gv() {
    if (typeof performance.getEntriesByType == "function") {
      for (var l = 0, t = 0, e = performance.getEntriesByType("resource"), a = 0; a < e.length; a++) {
        var u = e[a], n = u.transferSize, i = u.initiatorType, c = u.duration;
        if (n && c && wr(i)) {
          for (i = 0, c = u.responseEnd, a += 1; a < e.length; a++) {
            var s = e[a], y = s.startTime;
            if (y > c) break;
            var b = s.transferSize, T = s.initiatorType;
            b && wr(T) && (s = s.responseEnd, i += b * (s < c ? 1 : (c - y) / (s - y)));
          }
          if (--a, t += 8 * (n + i) / (u.duration / 1e3), l++, 10 < l) break;
        }
      }
      if (0 < l) return t / l / 1e6;
    }
    return navigator.connection && (l = navigator.connection.downlink, typeof l == "number") ? l : 5;
  }
  var Wc = null, Fc = null;
  function Nn(l) {
    return l.nodeType === 9 ? l : l.ownerDocument;
  }
  function $r(l) {
    switch (l) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function kr(l, t) {
    if (l === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return l === 1 && t === "foreignObject" ? 0 : l;
  }
  function Ic(l, t) {
    return l === "textarea" || l === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Pc = null;
  function Qv() {
    var l = window.event;
    return l && l.type === "popstate" ? l === Pc ? !1 : (Pc = l, !0) : (Pc = null, !1);
  }
  var Wr = typeof setTimeout == "function" ? setTimeout : void 0, Xv = typeof clearTimeout == "function" ? clearTimeout : void 0, Fr = typeof Promise == "function" ? Promise : void 0, Lv = typeof queueMicrotask == "function" ? queueMicrotask : typeof Fr < "u" ? function(l) {
    return Fr.resolve(null).then(l).catch(Zv);
  } : Wr;
  function Zv(l) {
    setTimeout(function() {
      throw l;
    });
  }
  function be(l) {
    return l === "head";
  }
  function Ir(l, t) {
    var e = t, a = 0;
    do {
      var u = e.nextSibling;
      if (l.removeChild(e), u && u.nodeType === 8)
        if (e = u.data, e === "/$" || e === "/&") {
          if (a === 0) {
            l.removeChild(u), _a(t);
            return;
          }
          a--;
        } else if (e === "$" || e === "$?" || e === "$~" || e === "$!" || e === "&")
          a++;
        else if (e === "html")
          yu(l.ownerDocument.documentElement);
        else if (e === "head") {
          e = l.ownerDocument.head, yu(e);
          for (var n = e.firstChild; n; ) {
            var i = n.nextSibling, c = n.nodeName;
            n[Ha] || c === "SCRIPT" || c === "STYLE" || c === "LINK" && n.rel.toLowerCase() === "stylesheet" || e.removeChild(n), n = i;
          }
        } else
          e === "body" && yu(l.ownerDocument.body);
      e = u;
    } while (e);
    _a(t);
  }
  function Pr(l, t) {
    var e = l;
    l = 0;
    do {
      var a = e.nextSibling;
      if (e.nodeType === 1 ? t ? (e._stashedDisplay = e.style.display, e.style.display = "none") : (e.style.display = e._stashedDisplay || "", e.getAttribute("style") === "" && e.removeAttribute("style")) : e.nodeType === 3 && (t ? (e._stashedText = e.nodeValue, e.nodeValue = "") : e.nodeValue = e._stashedText || ""), a && a.nodeType === 8)
        if (e = a.data, e === "/$") {
          if (l === 0) break;
          l--;
        } else
          e !== "$" && e !== "$?" && e !== "$~" && e !== "$!" || l++;
      e = a;
    } while (e);
  }
  function lf(l) {
    var t = l.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var e = t;
      switch (t = t.nextSibling, e.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          lf(e), ni(e);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (e.rel.toLowerCase() === "stylesheet") continue;
      }
      l.removeChild(e);
    }
  }
  function Vv(l, t, e, a) {
    for (; l.nodeType === 1; ) {
      var u = e;
      if (l.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!a && (l.nodeName !== "INPUT" || l.type !== "hidden"))
          break;
      } else if (a) {
        if (!l[Ha])
          switch (t) {
            case "meta":
              if (!l.hasAttribute("itemprop")) break;
              return l;
            case "link":
              if (n = l.getAttribute("rel"), n === "stylesheet" && l.hasAttribute("data-precedence"))
                break;
              if (n !== u.rel || l.getAttribute("href") !== (u.href == null || u.href === "" ? null : u.href) || l.getAttribute("crossorigin") !== (u.crossOrigin == null ? null : u.crossOrigin) || l.getAttribute("title") !== (u.title == null ? null : u.title))
                break;
              return l;
            case "style":
              if (l.hasAttribute("data-precedence")) break;
              return l;
            case "script":
              if (n = l.getAttribute("src"), (n !== (u.src == null ? null : u.src) || l.getAttribute("type") !== (u.type == null ? null : u.type) || l.getAttribute("crossorigin") !== (u.crossOrigin == null ? null : u.crossOrigin)) && n && l.hasAttribute("async") && !l.hasAttribute("itemprop"))
                break;
              return l;
            default:
              return l;
          }
      } else if (t === "input" && l.type === "hidden") {
        var n = u.name == null ? null : "" + u.name;
        if (u.type === "hidden" && l.getAttribute("name") === n)
          return l;
      } else return l;
      if (l = Et(l.nextSibling), l === null) break;
    }
    return null;
  }
  function Kv(l, t, e) {
    if (t === "") return null;
    for (; l.nodeType !== 3; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !e || (l = Et(l.nextSibling), l === null)) return null;
    return l;
  }
  function ld(l, t) {
    for (; l.nodeType !== 8; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !t || (l = Et(l.nextSibling), l === null)) return null;
    return l;
  }
  function tf(l) {
    return l.data === "$?" || l.data === "$~";
  }
  function ef(l) {
    return l.data === "$!" || l.data === "$?" && l.ownerDocument.readyState !== "loading";
  }
  function Jv(l, t) {
    var e = l.ownerDocument;
    if (l.data === "$~") l._reactRetry = t;
    else if (l.data !== "$?" || e.readyState !== "loading")
      t();
    else {
      var a = function() {
        t(), e.removeEventListener("DOMContentLoaded", a);
      };
      e.addEventListener("DOMContentLoaded", a), l._reactRetry = a;
    }
  }
  function Et(l) {
    for (; l != null; l = l.nextSibling) {
      var t = l.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = l.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F")
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return l;
  }
  var af = null;
  function td(l) {
    l = l.nextSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var e = l.data;
        if (e === "/$" || e === "/&") {
          if (t === 0)
            return Et(l.nextSibling);
          t--;
        } else
          e !== "$" && e !== "$!" && e !== "$?" && e !== "$~" && e !== "&" || t++;
      }
      l = l.nextSibling;
    }
    return null;
  }
  function ed(l) {
    l = l.previousSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var e = l.data;
        if (e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&") {
          if (t === 0) return l;
          t--;
        } else e !== "/$" && e !== "/&" || t++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  function ad(l, t, e) {
    switch (t = Nn(e), l) {
      case "html":
        if (l = t.documentElement, !l) throw Error(r(452));
        return l;
      case "head":
        if (l = t.head, !l) throw Error(r(453));
        return l;
      case "body":
        if (l = t.body, !l) throw Error(r(454));
        return l;
      default:
        throw Error(r(451));
    }
  }
  function yu(l) {
    for (var t = l.attributes; t.length; )
      l.removeAttributeNode(t[0]);
    ni(l);
  }
  var At = /* @__PURE__ */ new Map(), ud = /* @__PURE__ */ new Set();
  function Un(l) {
    return typeof l.getRootNode == "function" ? l.getRootNode() : l.nodeType === 9 ? l : l.ownerDocument;
  }
  var Pt = R.d;
  R.d = {
    f: wv,
    r: $v,
    D: kv,
    C: Wv,
    L: Fv,
    m: Iv,
    X: lh,
    S: Pv,
    M: th
  };
  function wv() {
    var l = Pt.f(), t = An();
    return l || t;
  }
  function $v(l) {
    var t = $e(l);
    t !== null && t.tag === 5 && t.type === "form" ? xo(t) : Pt.r(l);
  }
  var ja = typeof document > "u" ? null : document;
  function nd(l, t, e) {
    var a = ja;
    if (a && typeof t == "string" && t) {
      var u = yt(t);
      u = 'link[rel="' + l + '"][href="' + u + '"]', typeof e == "string" && (u += '[crossorigin="' + e + '"]'), ud.has(u) || (ud.add(u), l = { rel: l, crossOrigin: e, href: t }, a.querySelector(u) === null && (t = a.createElement("link"), Vl(t, "link", l), Bl(t), a.head.appendChild(t)));
    }
  }
  function kv(l) {
    Pt.D(l), nd("dns-prefetch", l, null);
  }
  function Wv(l, t) {
    Pt.C(l, t), nd("preconnect", l, t);
  }
  function Fv(l, t, e) {
    Pt.L(l, t, e);
    var a = ja;
    if (a && l && t) {
      var u = 'link[rel="preload"][as="' + yt(t) + '"]';
      t === "image" && e && e.imageSrcSet ? (u += '[imagesrcset="' + yt(
        e.imageSrcSet
      ) + '"]', typeof e.imageSizes == "string" && (u += '[imagesizes="' + yt(
        e.imageSizes
      ) + '"]')) : u += '[href="' + yt(l) + '"]';
      var n = u;
      switch (t) {
        case "style":
          n = Oa(l);
          break;
        case "script":
          n = Ma(l);
      }
      At.has(n) || (l = U(
        {
          rel: "preload",
          href: t === "image" && e && e.imageSrcSet ? void 0 : l,
          as: t
        },
        e
      ), At.set(n, l), a.querySelector(u) !== null || t === "style" && a.querySelector(gu(n)) || t === "script" && a.querySelector(pu(n)) || (t = a.createElement("link"), Vl(t, "link", l), Bl(t), a.head.appendChild(t)));
    }
  }
  function Iv(l, t) {
    Pt.m(l, t);
    var e = ja;
    if (e && l) {
      var a = t && typeof t.as == "string" ? t.as : "script", u = 'link[rel="modulepreload"][as="' + yt(a) + '"][href="' + yt(l) + '"]', n = u;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          n = Ma(l);
      }
      if (!At.has(n) && (l = U({ rel: "modulepreload", href: l }, t), At.set(n, l), e.querySelector(u) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (e.querySelector(pu(n)))
              return;
        }
        a = e.createElement("link"), Vl(a, "link", l), Bl(a), e.head.appendChild(a);
      }
    }
  }
  function Pv(l, t, e) {
    Pt.S(l, t, e);
    var a = ja;
    if (a && l) {
      var u = ke(a).hoistableStyles, n = Oa(l);
      t = t || "default";
      var i = u.get(n);
      if (!i) {
        var c = { loading: 0, preload: null };
        if (i = a.querySelector(
          gu(n)
        ))
          c.loading = 5;
        else {
          l = U(
            { rel: "stylesheet", href: l, "data-precedence": t },
            e
          ), (e = At.get(n)) && uf(l, e);
          var s = i = a.createElement("link");
          Bl(s), Vl(s, "link", l), s._p = new Promise(function(y, b) {
            s.onload = y, s.onerror = b;
          }), s.addEventListener("load", function() {
            c.loading |= 1;
          }), s.addEventListener("error", function() {
            c.loading |= 2;
          }), c.loading |= 4, Hn(i, t, a);
        }
        i = {
          type: "stylesheet",
          instance: i,
          count: 1,
          state: c
        }, u.set(n, i);
      }
    }
  }
  function lh(l, t) {
    Pt.X(l, t);
    var e = ja;
    if (e && l) {
      var a = ke(e).hoistableScripts, u = Ma(l), n = a.get(u);
      n || (n = e.querySelector(pu(u)), n || (l = U({ src: l, async: !0 }, t), (t = At.get(u)) && nf(l, t), n = e.createElement("script"), Bl(n), Vl(n, "link", l), e.head.appendChild(n)), n = {
        type: "script",
        instance: n,
        count: 1,
        state: null
      }, a.set(u, n));
    }
  }
  function th(l, t) {
    Pt.M(l, t);
    var e = ja;
    if (e && l) {
      var a = ke(e).hoistableScripts, u = Ma(l), n = a.get(u);
      n || (n = e.querySelector(pu(u)), n || (l = U({ src: l, async: !0, type: "module" }, t), (t = At.get(u)) && nf(l, t), n = e.createElement("script"), Bl(n), Vl(n, "link", l), e.head.appendChild(n)), n = {
        type: "script",
        instance: n,
        count: 1,
        state: null
      }, a.set(u, n));
    }
  }
  function id(l, t, e, a) {
    var u = (u = w.current) ? Un(u) : null;
    if (!u) throw Error(r(446));
    switch (l) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof e.precedence == "string" && typeof e.href == "string" ? (t = Oa(e.href), e = ke(
          u
        ).hoistableStyles, a = e.get(t), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, e.set(t, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (e.rel === "stylesheet" && typeof e.href == "string" && typeof e.precedence == "string") {
          l = Oa(e.href);
          var n = ke(
            u
          ).hoistableStyles, i = n.get(l);
          if (i || (u = u.ownerDocument || u, i = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, n.set(l, i), (n = u.querySelector(
            gu(l)
          )) && !n._p && (i.instance = n, i.state.loading = 5), At.has(l) || (e = {
            rel: "preload",
            as: "style",
            href: e.href,
            crossOrigin: e.crossOrigin,
            integrity: e.integrity,
            media: e.media,
            hrefLang: e.hrefLang,
            referrerPolicy: e.referrerPolicy
          }, At.set(l, e), n || eh(
            u,
            l,
            e,
            i.state
          ))), t && a === null)
            throw Error(r(528, ""));
          return i;
        }
        if (t && a !== null)
          throw Error(r(529, ""));
        return null;
      case "script":
        return t = e.async, e = e.src, typeof e == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Ma(e), e = ke(
          u
        ).hoistableScripts, a = e.get(t), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, e.set(t, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(r(444, l));
    }
  }
  function Oa(l) {
    return 'href="' + yt(l) + '"';
  }
  function gu(l) {
    return 'link[rel="stylesheet"][' + l + "]";
  }
  function cd(l) {
    return U({}, l, {
      "data-precedence": l.precedence,
      precedence: null
    });
  }
  function eh(l, t, e, a) {
    l.querySelector('link[rel="preload"][as="style"][' + t + "]") ? a.loading = 1 : (t = l.createElement("link"), a.preload = t, t.addEventListener("load", function() {
      return a.loading |= 1;
    }), t.addEventListener("error", function() {
      return a.loading |= 2;
    }), Vl(t, "link", e), Bl(t), l.head.appendChild(t));
  }
  function Ma(l) {
    return '[src="' + yt(l) + '"]';
  }
  function pu(l) {
    return "script[async]" + l;
  }
  function fd(l, t, e) {
    if (t.count++, t.instance === null)
      switch (t.type) {
        case "style":
          var a = l.querySelector(
            'style[data-href~="' + yt(e.href) + '"]'
          );
          if (a)
            return t.instance = a, Bl(a), a;
          var u = U({}, e, {
            "data-href": e.href,
            "data-precedence": e.precedence,
            href: null,
            precedence: null
          });
          return a = (l.ownerDocument || l).createElement(
            "style"
          ), Bl(a), Vl(a, "style", u), Hn(a, e.precedence, l), t.instance = a;
        case "stylesheet":
          u = Oa(e.href);
          var n = l.querySelector(
            gu(u)
          );
          if (n)
            return t.state.loading |= 4, t.instance = n, Bl(n), n;
          a = cd(e), (u = At.get(u)) && uf(a, u), n = (l.ownerDocument || l).createElement("link"), Bl(n);
          var i = n;
          return i._p = new Promise(function(c, s) {
            i.onload = c, i.onerror = s;
          }), Vl(n, "link", a), t.state.loading |= 4, Hn(n, e.precedence, l), t.instance = n;
        case "script":
          return n = Ma(e.src), (u = l.querySelector(
            pu(n)
          )) ? (t.instance = u, Bl(u), u) : (a = e, (u = At.get(n)) && (a = U({}, e), nf(a, u)), l = l.ownerDocument || l, u = l.createElement("script"), Bl(u), Vl(u, "link", a), l.head.appendChild(u), t.instance = u);
        case "void":
          return null;
        default:
          throw Error(r(443, t.type));
      }
    else
      t.type === "stylesheet" && (t.state.loading & 4) === 0 && (a = t.instance, t.state.loading |= 4, Hn(a, e.precedence, l));
    return t.instance;
  }
  function Hn(l, t, e) {
    for (var a = e.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), u = a.length ? a[a.length - 1] : null, n = u, i = 0; i < a.length; i++) {
      var c = a[i];
      if (c.dataset.precedence === t) n = c;
      else if (n !== u) break;
    }
    n ? n.parentNode.insertBefore(l, n.nextSibling) : (t = e.nodeType === 9 ? e.head : e, t.insertBefore(l, t.firstChild));
  }
  function uf(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy), l.title == null && (l.title = t.title);
  }
  function nf(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy), l.integrity == null && (l.integrity = t.integrity);
  }
  var Cn = null;
  function sd(l, t, e) {
    if (Cn === null) {
      var a = /* @__PURE__ */ new Map(), u = Cn = /* @__PURE__ */ new Map();
      u.set(e, a);
    } else
      u = Cn, a = u.get(e), a || (a = /* @__PURE__ */ new Map(), u.set(e, a));
    if (a.has(l)) return a;
    for (a.set(l, null), e = e.getElementsByTagName(l), u = 0; u < e.length; u++) {
      var n = e[u];
      if (!(n[Ha] || n[Ql] || l === "link" && n.getAttribute("rel") === "stylesheet") && n.namespaceURI !== "http://www.w3.org/2000/svg") {
        var i = n.getAttribute(t) || "";
        i = l + i;
        var c = a.get(i);
        c ? c.push(n) : a.set(i, [n]);
      }
    }
    return a;
  }
  function od(l, t, e) {
    l = l.ownerDocument || l, l.head.insertBefore(
      e,
      t === "title" ? l.querySelector("head > title") : null
    );
  }
  function ah(l, t, e) {
    if (e === 1 || t.itemProp != null) return !1;
    switch (l) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "")
          break;
        return !0;
      case "link":
        if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError)
          break;
        switch (t.rel) {
          case "stylesheet":
            return l = t.disabled, typeof t.precedence == "string" && l == null;
          default:
            return !0;
        }
      case "script":
        if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string")
          return !0;
    }
    return !1;
  }
  function rd(l) {
    return !(l.type === "stylesheet" && (l.state.loading & 3) === 0);
  }
  function uh(l, t, e, a) {
    if (e.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (e.state.loading & 4) === 0) {
      if (e.instance === null) {
        var u = Oa(a.href), n = t.querySelector(
          gu(u)
        );
        if (n) {
          t = n._p, t !== null && typeof t == "object" && typeof t.then == "function" && (l.count++, l = qn.bind(l), t.then(l, l)), e.state.loading |= 4, e.instance = n, Bl(n);
          return;
        }
        n = t.ownerDocument || t, a = cd(a), (u = At.get(u)) && uf(a, u), n = n.createElement("link"), Bl(n);
        var i = n;
        i._p = new Promise(function(c, s) {
          i.onload = c, i.onerror = s;
        }), Vl(n, "link", a), e.instance = n;
      }
      l.stylesheets === null && (l.stylesheets = /* @__PURE__ */ new Map()), l.stylesheets.set(e, t), (t = e.state.preload) && (e.state.loading & 3) === 0 && (l.count++, e = qn.bind(l), t.addEventListener("load", e), t.addEventListener("error", e));
    }
  }
  var cf = 0;
  function nh(l, t) {
    return l.stylesheets && l.count === 0 && Yn(l, l.stylesheets), 0 < l.count || 0 < l.imgCount ? function(e) {
      var a = setTimeout(function() {
        if (l.stylesheets && Yn(l, l.stylesheets), l.unsuspend) {
          var n = l.unsuspend;
          l.unsuspend = null, n();
        }
      }, 6e4 + t);
      0 < l.imgBytes && cf === 0 && (cf = 62500 * Gv());
      var u = setTimeout(
        function() {
          if (l.waitingForImages = !1, l.count === 0 && (l.stylesheets && Yn(l, l.stylesheets), l.unsuspend)) {
            var n = l.unsuspend;
            l.unsuspend = null, n();
          }
        },
        (l.imgBytes > cf ? 50 : 800) + t
      );
      return l.unsuspend = e, function() {
        l.unsuspend = null, clearTimeout(a), clearTimeout(u);
      };
    } : null;
  }
  function qn() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Yn(this, this.stylesheets);
      else if (this.unsuspend) {
        var l = this.unsuspend;
        this.unsuspend = null, l();
      }
    }
  }
  var Bn = null;
  function Yn(l, t) {
    l.stylesheets = null, l.unsuspend !== null && (l.count++, Bn = /* @__PURE__ */ new Map(), t.forEach(ih, l), Bn = null, qn.call(l));
  }
  function ih(l, t) {
    if (!(t.state.loading & 4)) {
      var e = Bn.get(l);
      if (e) var a = e.get(null);
      else {
        e = /* @__PURE__ */ new Map(), Bn.set(l, e);
        for (var u = l.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), n = 0; n < u.length; n++) {
          var i = u[n];
          (i.nodeName === "LINK" || i.getAttribute("media") !== "not all") && (e.set(i.dataset.precedence, i), a = i);
        }
        a && e.set(null, a);
      }
      u = t.instance, i = u.getAttribute("data-precedence"), n = e.get(i) || a, n === a && e.set(null, u), e.set(i, u), this.count++, a = qn.bind(this), u.addEventListener("load", a), u.addEventListener("error", a), n ? n.parentNode.insertBefore(u, n.nextSibling) : (l = l.nodeType === 9 ? l.head : l, l.insertBefore(u, l.firstChild)), t.state.loading |= 4;
    }
  }
  var bu = {
    $$typeof: El,
    Provider: null,
    Consumer: null,
    _currentValue: X,
    _currentValue2: X,
    _threadCount: 0
  };
  function ch(l, t, e, a, u, n, i, c, s) {
    this.tag = 1, this.containerInfo = l, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ti(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ti(0), this.hiddenUpdates = ti(null), this.identifierPrefix = a, this.onUncaughtError = u, this.onCaughtError = n, this.onRecoverableError = i, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = s, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function dd(l, t, e, a, u, n, i, c, s, y, b, T) {
    return l = new ch(
      l,
      t,
      e,
      i,
      s,
      y,
      b,
      T,
      c
    ), t = 1, n === !0 && (t |= 24), n = ft(3, null, null, t), l.current = n, n.stateNode = l, t = Gi(), t.refCount++, l.pooledCache = t, t.refCount++, n.memoizedState = {
      element: a,
      isDehydrated: e,
      cache: t
    }, Zi(n), l;
  }
  function md(l) {
    return l ? (l = na, l) : na;
  }
  function vd(l, t, e, a, u, n) {
    u = md(u), a.context === null ? a.context = u : a.pendingContext = u, a = fe(t), a.payload = { element: e }, n = n === void 0 ? null : n, n !== null && (a.callback = n), e = se(l, a, t), e !== null && (at(e, l, t), Fa(e, l, t));
  }
  function hd(l, t) {
    if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
      var e = l.retryLane;
      l.retryLane = e !== 0 && e < t ? e : t;
    }
  }
  function ff(l, t) {
    hd(l, t), (l = l.alternate) && hd(l, t);
  }
  function yd(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = Ne(l, 67108864);
      t !== null && at(t, l, 67108864), ff(l, 67108864);
    }
  }
  function gd(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = mt();
      t = ei(t);
      var e = Ne(l, t);
      e !== null && at(e, l, t), ff(l, t);
    }
  }
  var Gn = !0;
  function fh(l, t, e, a) {
    var u = x.T;
    x.T = null;
    var n = R.p;
    try {
      R.p = 2, sf(l, t, e, a);
    } finally {
      R.p = n, x.T = u;
    }
  }
  function sh(l, t, e, a) {
    var u = x.T;
    x.T = null;
    var n = R.p;
    try {
      R.p = 8, sf(l, t, e, a);
    } finally {
      R.p = n, x.T = u;
    }
  }
  function sf(l, t, e, a) {
    if (Gn) {
      var u = of(a);
      if (u === null)
        $c(
          l,
          t,
          a,
          Qn,
          e
        ), bd(l, a);
      else if (rh(
        u,
        l,
        t,
        e,
        a
      ))
        a.stopPropagation();
      else if (bd(l, a), t & 4 && -1 < oh.indexOf(l)) {
        for (; u !== null; ) {
          var n = $e(u);
          if (n !== null)
            switch (n.tag) {
              case 3:
                if (n = n.stateNode, n.current.memoizedState.isDehydrated) {
                  var i = Oe(n.pendingLanes);
                  if (i !== 0) {
                    var c = n;
                    for (c.pendingLanes |= 2, c.entangledLanes |= 2; i; ) {
                      var s = 1 << 31 - it(i);
                      c.entanglements[1] |= s, i &= ~s;
                    }
                    Ct(n), (al & 6) === 0 && (zn = ut() + 500, mu(0));
                  }
                }
                break;
              case 31:
              case 13:
                c = Ne(n, 2), c !== null && at(c, n, 2), An(), ff(n, 2);
            }
          if (n = of(a), n === null && $c(
            l,
            t,
            a,
            Qn,
            e
          ), n === u) break;
          u = n;
        }
        u !== null && a.stopPropagation();
      } else
        $c(
          l,
          t,
          a,
          null,
          e
        );
    }
  }
  function of(l) {
    return l = ri(l), rf(l);
  }
  var Qn = null;
  function rf(l) {
    if (Qn = null, l = we(l), l !== null) {
      var t = _(l);
      if (t === null) l = null;
      else {
        var e = t.tag;
        if (e === 13) {
          if (l = Y(t), l !== null) return l;
          l = null;
        } else if (e === 31) {
          if (l = N(t), l !== null) return l;
          l = null;
        } else if (e === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          l = null;
        } else t !== l && (l = null);
      }
    }
    return Qn = l, null;
  }
  function pd(l) {
    switch (l) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (kd()) {
          case Tf:
            return 2;
          case jf:
            return 8;
          case Mu:
          case Wd:
            return 32;
          case Of:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var df = !1, Se = null, xe = null, ze = null, Su = /* @__PURE__ */ new Map(), xu = /* @__PURE__ */ new Map(), Ee = [], oh = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function bd(l, t) {
    switch (l) {
      case "focusin":
      case "focusout":
        Se = null;
        break;
      case "dragenter":
      case "dragleave":
        xe = null;
        break;
      case "mouseover":
      case "mouseout":
        ze = null;
        break;
      case "pointerover":
      case "pointerout":
        Su.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        xu.delete(t.pointerId);
    }
  }
  function zu(l, t, e, a, u, n) {
    return l === null || l.nativeEvent !== n ? (l = {
      blockedOn: t,
      domEventName: e,
      eventSystemFlags: a,
      nativeEvent: n,
      targetContainers: [u]
    }, t !== null && (t = $e(t), t !== null && yd(t)), l) : (l.eventSystemFlags |= a, t = l.targetContainers, u !== null && t.indexOf(u) === -1 && t.push(u), l);
  }
  function rh(l, t, e, a, u) {
    switch (t) {
      case "focusin":
        return Se = zu(
          Se,
          l,
          t,
          e,
          a,
          u
        ), !0;
      case "dragenter":
        return xe = zu(
          xe,
          l,
          t,
          e,
          a,
          u
        ), !0;
      case "mouseover":
        return ze = zu(
          ze,
          l,
          t,
          e,
          a,
          u
        ), !0;
      case "pointerover":
        var n = u.pointerId;
        return Su.set(
          n,
          zu(
            Su.get(n) || null,
            l,
            t,
            e,
            a,
            u
          )
        ), !0;
      case "gotpointercapture":
        return n = u.pointerId, xu.set(
          n,
          zu(
            xu.get(n) || null,
            l,
            t,
            e,
            a,
            u
          )
        ), !0;
    }
    return !1;
  }
  function Sd(l) {
    var t = we(l.target);
    if (t !== null) {
      var e = _(t);
      if (e !== null) {
        if (t = e.tag, t === 13) {
          if (t = Y(e), t !== null) {
            l.blockedOn = t, Uf(l.priority, function() {
              gd(e);
            });
            return;
          }
        } else if (t === 31) {
          if (t = N(e), t !== null) {
            l.blockedOn = t, Uf(l.priority, function() {
              gd(e);
            });
            return;
          }
        } else if (t === 3 && e.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = e.tag === 3 ? e.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function Xn(l) {
    if (l.blockedOn !== null) return !1;
    for (var t = l.targetContainers; 0 < t.length; ) {
      var e = of(l.nativeEvent);
      if (e === null) {
        e = l.nativeEvent;
        var a = new e.constructor(
          e.type,
          e
        );
        oi = a, e.target.dispatchEvent(a), oi = null;
      } else
        return t = $e(e), t !== null && yd(t), l.blockedOn = e, !1;
      t.shift();
    }
    return !0;
  }
  function xd(l, t, e) {
    Xn(l) && e.delete(t);
  }
  function dh() {
    df = !1, Se !== null && Xn(Se) && (Se = null), xe !== null && Xn(xe) && (xe = null), ze !== null && Xn(ze) && (ze = null), Su.forEach(xd), xu.forEach(xd);
  }
  function Ln(l, t) {
    l.blockedOn === t && (l.blockedOn = null, df || (df = !0, v.unstable_scheduleCallback(
      v.unstable_NormalPriority,
      dh
    )));
  }
  var Zn = null;
  function zd(l) {
    Zn !== l && (Zn = l, v.unstable_scheduleCallback(
      v.unstable_NormalPriority,
      function() {
        Zn === l && (Zn = null);
        for (var t = 0; t < l.length; t += 3) {
          var e = l[t], a = l[t + 1], u = l[t + 2];
          if (typeof a != "function") {
            if (rf(a || e) === null)
              continue;
            break;
          }
          var n = $e(e);
          n !== null && (l.splice(t, 3), t -= 3, sc(
            n,
            {
              pending: !0,
              data: u,
              method: e.method,
              action: a
            },
            a,
            u
          ));
        }
      }
    ));
  }
  function _a(l) {
    function t(s) {
      return Ln(s, l);
    }
    Se !== null && Ln(Se, l), xe !== null && Ln(xe, l), ze !== null && Ln(ze, l), Su.forEach(t), xu.forEach(t);
    for (var e = 0; e < Ee.length; e++) {
      var a = Ee[e];
      a.blockedOn === l && (a.blockedOn = null);
    }
    for (; 0 < Ee.length && (e = Ee[0], e.blockedOn === null); )
      Sd(e), e.blockedOn === null && Ee.shift();
    if (e = (l.ownerDocument || l).$$reactFormReplay, e != null)
      for (a = 0; a < e.length; a += 3) {
        var u = e[a], n = e[a + 1], i = u[Fl] || null;
        if (typeof n == "function")
          i || zd(e);
        else if (i) {
          var c = null;
          if (n && n.hasAttribute("formAction")) {
            if (u = n, i = n[Fl] || null)
              c = i.formAction;
            else if (rf(u) !== null) continue;
          } else c = i.action;
          typeof c == "function" ? e[a + 1] = c : (e.splice(a, 3), a -= 3), zd(e);
        }
      }
  }
  function Ed() {
    function l(n) {
      n.canIntercept && n.info === "react-transition" && n.intercept({
        handler: function() {
          return new Promise(function(i) {
            return u = i;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function t() {
      u !== null && (u(), u = null), a || setTimeout(e, 20);
    }
    function e() {
      if (!a && !navigation.transition) {
        var n = navigation.currentEntry;
        n && n.url != null && navigation.navigate(n.url, {
          state: n.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, u = null;
      return navigation.addEventListener("navigate", l), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(e, 100), function() {
        a = !0, navigation.removeEventListener("navigate", l), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), u !== null && (u(), u = null);
      };
    }
  }
  function mf(l) {
    this._internalRoot = l;
  }
  Vn.prototype.render = mf.prototype.render = function(l) {
    var t = this._internalRoot;
    if (t === null) throw Error(r(409));
    var e = t.current, a = mt();
    vd(e, a, l, t, null, null);
  }, Vn.prototype.unmount = mf.prototype.unmount = function() {
    var l = this._internalRoot;
    if (l !== null) {
      this._internalRoot = null;
      var t = l.containerInfo;
      vd(l.current, 2, null, l, null, null), An(), t[Je] = null;
    }
  };
  function Vn(l) {
    this._internalRoot = l;
  }
  Vn.prototype.unstable_scheduleHydration = function(l) {
    if (l) {
      var t = Nf();
      l = { blockedOn: null, target: l, priority: t };
      for (var e = 0; e < Ee.length && t !== 0 && t < Ee[e].priority; e++) ;
      Ee.splice(e, 0, l), e === 0 && Sd(l);
    }
  };
  var Ad = A.version;
  if (Ad !== "19.2.3")
    throw Error(
      r(
        527,
        Ad,
        "19.2.3"
      )
    );
  R.findDOMNode = function(l) {
    var t = l._reactInternals;
    if (t === void 0)
      throw typeof l.render == "function" ? Error(r(188)) : (l = Object.keys(l).join(","), Error(r(268, l)));
    return l = S(t), l = l !== null ? Z(l) : null, l = l === null ? null : l.stateNode, l;
  };
  var mh = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: x,
    reconcilerVersion: "19.2.3"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Kn = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Kn.isDisabled && Kn.supportsFiber)
      try {
        Da = Kn.inject(
          mh
        ), nt = Kn;
      } catch {
      }
  }
  return Au.createRoot = function(l, t) {
    if (!O(l)) throw Error(r(299));
    var e = !1, a = "", u = Do, n = No, i = Uo;
    return t != null && (t.unstable_strictMode === !0 && (e = !0), t.identifierPrefix !== void 0 && (a = t.identifierPrefix), t.onUncaughtError !== void 0 && (u = t.onUncaughtError), t.onCaughtError !== void 0 && (n = t.onCaughtError), t.onRecoverableError !== void 0 && (i = t.onRecoverableError)), t = dd(
      l,
      1,
      !1,
      null,
      null,
      e,
      a,
      null,
      u,
      n,
      i,
      Ed
    ), l[Je] = t.current, wc(l), new mf(t);
  }, Au.hydrateRoot = function(l, t, e) {
    if (!O(l)) throw Error(r(299));
    var a = !1, u = "", n = Do, i = No, c = Uo, s = null;
    return e != null && (e.unstable_strictMode === !0 && (a = !0), e.identifierPrefix !== void 0 && (u = e.identifierPrefix), e.onUncaughtError !== void 0 && (n = e.onUncaughtError), e.onCaughtError !== void 0 && (i = e.onCaughtError), e.onRecoverableError !== void 0 && (c = e.onRecoverableError), e.formState !== void 0 && (s = e.formState)), t = dd(
      l,
      1,
      !0,
      t,
      e ?? null,
      a,
      u,
      s,
      n,
      i,
      c,
      Ed
    ), t.context = md(null), e = t.current, a = mt(), a = ei(a), u = fe(a), u.callback = null, se(e, u, a), e = a, t.current.lanes = e, Ua(t, e), Ct(t), l[Je] = t.current, wc(l), new Vn(t);
  }, Au.version = "19.2.3", Au;
}
var Hd;
function Eh() {
  if (Hd) return yf.exports;
  Hd = 1;
  function v() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(v);
      } catch (A) {
        console.error(A);
      }
  }
  return v(), yf.exports = zh(), yf.exports;
}
var Ah = Eh();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Th = (v) => v.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Ld = (...v) => v.filter((A, E, r) => !!A && A.trim() !== "" && r.indexOf(A) === E).join(" ").trim();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var jh = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oh = rl.forwardRef(
  ({
    color: v = "currentColor",
    size: A = 24,
    strokeWidth: E = 2,
    absoluteStrokeWidth: r,
    className: O = "",
    children: _,
    iconNode: Y,
    ...N
  }, M) => rl.createElement(
    "svg",
    {
      ref: M,
      ...jh,
      width: A,
      height: A,
      stroke: v,
      strokeWidth: r ? Number(E) * 24 / Number(A) : E,
      className: Ld("lucide", O),
      ...N
    },
    [
      ...Y.map(([S, Z]) => rl.createElement(S, Z)),
      ...Array.isArray(_) ? _ : [_]
    ]
  )
);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kl = (v, A) => {
  const E = rl.forwardRef(
    ({ className: r, ...O }, _) => rl.createElement(Oh, {
      ref: _,
      iconNode: A,
      className: Ld(`lucide-${Th(v)}`, r),
      ...O
    })
  );
  return E.displayName = `${v}`, E;
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mh = Kl("Activity", [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _h = Kl("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rh = Kl("ArrowRight", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ju = Kl("ArrowUpRight", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dh = Kl("BatteryMedium", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nh = Kl("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uh = Kl("CloudRain", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hh = Kl("CloudSun", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ch = Kl("Cloud", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qh = Kl("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bh = Kl("MessageCircle", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yh = Kl("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gh = Kl("Pause", [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qh = Kl("Play", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xh = Kl("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lh = Kl("Sunrise", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zh = Kl("Waves", [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
]), Tu = "/products/rheo-ring", Vh = [{
  slug: "tamanho-e-ajuste",
  category: "Tamanhos",
  title: "Como encontrar o tamanho do seu anel",
  summary: "Medir em centímetros, entender a numeração e conferir o encaixe.",
  keywords: "aro medida medir papel régua dedo tamanho ajuste kit",
  sections: [{
    title: "Comece pela circunferência",
    text: "Envolva a base do dedo com uma tira estreita de papel, sem apertar. Marque onde as pontas se encontram, estenda a tira e meça da ponta até a marca. No guia, informe o valor em centímetros."
  }, {
    title: "O papel é uma estimativa",
    text: "Repita a medida em momentos diferentes e confira também a passagem pela articulação. O anel precisa ficar confortável. Uma medição com papel não substitui a prova com um medidor físico compatível com o modelo."
  }, {
    title: "A numeração não é o aro brasileiro",
    text: "Os números da coleção não devem ser convertidos automaticamente de outro anel. A tabela desta prévia é demonstrativa e será substituída pelas medidas verificadas do fornecedor antes de qualquer venda."
  }],
  action: {
    href: "/pages/guia-de-tamanho",
    label: "Ver o guia de tamanho"
  }
}, {
  slug: "aplicativo-e-conexao",
  category: "Aplicativo",
  title: "Aplicativo, celular e conexão com o anel",
  summary: "O que está previsto para iOS, Android e sincronização Bluetooth.",
  keywords: "app ios iphone android bluetooth conectar sincronizar SDK instalação download compatibilidade",
  sections: [{
    title: "Uma experiência própria",
    text: "O aplicativo Rheo está sendo desenvolvido para iOS e Android. A proposta é reunir o resumo do dia, sono, movimento, histórico e check-ins pessoais em uma experiência só."
  }, {
    title: "A conexão ainda está em validação",
    text: "A leitura do anel por Bluetooth depende do protocolo ou SDK do fabricante e de testes com o hardware final. Versões mínimas do sistema, rotina de sincronização e funcionamento em segundo plano ainda não estão confirmados."
  }, {
    title: "Onde baixar",
    text: "Ainda não há uma versão comercial do aplicativo publicada. As telas deste site são uma prévia interativa, com dados demonstrativos. Os links oficiais de instalação serão informados no lançamento."
  }],
  action: {
    href: "/pages/aplicativo",
    label: "Conhecer o aplicativo"
  }
}, {
  slug: "entrega-e-trocas",
  category: "Compras",
  title: "Entrega, rastreamento e troca de tamanho",
  summary: "O que será informado antes da abertura das vendas.",
  keywords: "pedido compra frete prazo envio rastreio rastrear devolução reembolso garantia troca pagamento",
  sections: [{
    title: "Ainda não estamos recebendo pedidos",
    text: "O carrinho desta prévia permite montar uma seleção, mas não realiza pagamento, reserva ou envio. Por isso, ainda não existem pedidos para rastrear neste site."
  }, {
    title: "Frete e prazo",
    text: "Regiões atendidas, transportadoras, custos e prazos serão informados antes da compra quando a operação comercial estiver disponível. Nenhum prazo de entrega é prometido nesta prévia."
  }, {
    title: "Trocas e atendimento",
    text: "O processo de troca de tamanho, devoluções, garantia e os canais oficiais de atendimento serão publicados antes do lançamento. Esta página não substitui as condições comerciais finais."
  }],
  action: {
    href: "/suporte/colecao-e-disponibilidade",
    label: "Ver o estágio da coleção"
  }
}, {
  slug: "dados-e-privacidade",
  category: "Aplicativo",
  title: "Seus dados nesta prévia",
  summary: "O que fica neste navegador e o que ainda não está conectado.",
  keywords: "dados privacidade segurança saude armazenamento local conta apagar excluir histórico sensor",
  sections: [{
    title: "O carrinho fica no seu navegador",
    text: "Acabamento, tamanho e quantidade da sua seleção são guardados localmente neste navegador para manter o carrinho ao atualizar a página. Você pode remover os itens no próprio carrinho ou limpar os dados do site no navegador."
  }, {
    title: "Os indicadores são exemplos",
    text: "Os gráficos e telas exibidos aqui não são leituras do seu corpo. Esta prévia não conecta um anel por Bluetooth, não recebe medições de saúde e não oferece atendimento por IA."
  }, {
    title: "Antes do aplicativo comercial",
    text: "A política de privacidade, as permissões solicitadas, o tratamento dos dados e as opções de exclusão serão definidos e apresentados antes do uso comercial. Não há cadastro ou envio de dados de saúde disponível nesta versão do site."
  }],
  action: {
    href: "/pages/aplicativo",
    label: "Explorar a experiência"
  }
}, {
  slug: "colecao-e-disponibilidade",
  category: "Compras",
  title: "Coleção, acabamentos e disponibilidade",
  summary: "Prata, dourado e preto. Uma coleção em preparação.",
  keywords: "preço lançamento disponivel cores cor prata dourado preto caixa estojo case carregador compra assinatura mensalidade band pulseira",
  sections: [{
    title: "Rheo Ring, coleção 01",
    text: "A prévia apresenta três acabamentos: prata, dourado e preto. O anel e um estojo de carregamento estão previstos para a coleção. Fotos, medidas e conteúdo da caixa serão conferidos com o lote final."
  }, {
    title: "Preço e disponibilidade",
    text: "Preço, data de lançamento, estoque, formas de pagamento e eventuais planos do aplicativo ainda não foram definidos. Você pode explorar o produto e montar sua seleção sem cobrança ou reserva."
  }, {
    title: "Uma marca que começa pelo anel",
    text: "O Rheo Ring é o primeiro produto em desenvolvimento. Outros dispositivos fazem parte da visão da marca, mas não são apresentados como produtos disponíveis para compra."
  }],
  action: {
    href: Tu,
    label: "Explorar o Rheo Ring"
  }
}, {
  slug: "recursos-e-indices",
  category: "Produto",
  title: "O que o anel mede e o que o app interpreta",
  summary: "A diferença entre leituras do dispositivo e índices da Rheo.",
  keywords: "sono frequência cardiaca batimentos spo2 passos sensores flow recuperação estresse precisão recursos funcionalidades indices",
  sections: [{
    title: "O ponto de partida é o hardware",
    text: "O projeto parte das informações de movimento, sono, frequência cardíaca e SpO₂ descritas pelo fornecedor. O acesso, a frequência de leitura e a qualidade desses dados ainda precisam ser validados no modelo final."
  }, {
    title: "Flow é um conceito de software",
    text: "O Rheo Flow propõe reunir sono, recuperação e movimento em um resumo. Ele não é uma medida direta de um sensor. Sua fórmula, as fontes necessárias e outros índices apresentados ainda estão em desenvolvimento."
  }, {
    title: "Contexto, sem diagnóstico",
    text: "Check-ins e anotações acrescentam a percepção pessoal aos registros. As telas não devem ser usadas para diagnóstico, decisão clínica ou avaliação de desempenho esportivo. Os valores desta prévia são demonstrativos."
  }],
  action: {
    href: "/pages/aplicativo",
    label: "Ver as telas do aplicativo"
  }
}];
({
  ...Object.fromEntries(Vh.map((v) => [`/suporte/${v.slug}`, `${v.title} | Rheo`]))
});
const Kh = [0, 0, 0, 0, 0, 0, 265, 431, 1080, 385, 420, 710, 350, 605, 592, 365], Cd = [50, 52, 53, 55, 51, 53, 55], qd = [83, 79, 74, 71, 82, 76, 78], Bd = ["Leve", "Profundo", "Leve", "Profundo", "Leve", "REM", "Acordado", "Leve", "Profundo", "Leve", "REM", "Leve", "Acordado", "Leve", "Profundo", "Leve", "REM", "Leve", "Acordado", "REM", "Leve", "REM", "Acordado", "Leve"], Sf = {
  Acordado: 22,
  REM: 86,
  Leve: 274,
  Profundo: 96
}, Jh = ["#eeeedd", "#dec1b8", "#adbca1", "#6e8778"], Jn = Object.keys(Sf), Yd = [{
  icon: Uh,
  label: "Muito baixa"
}, {
  icon: Ch,
  label: "Baixa"
}, {
  icon: Hh,
  label: "Moderada"
}, {
  icon: Xh,
  label: "Boa"
}, {
  icon: Lh,
  label: "Muito boa"
}], wh = ["#dec1b8", "#e4b293", "#bbcbaf", "#e4b293", "#c3c1d6", "#bbcbaf"], $h = ["Tempo de sono", "Passos do dia", "FC em repouso", "Rheo Flow", "Sua disposição", "Flow na semana"];
function $n({
  label: v,
  children: A
}) {
  return /* @__PURE__ */ f.jsx("svg", { className: "rv-plot", viewBox: "0 0 310 130", role: "img", "aria-label": v, children: A });
}
function kh() {
  const v = Object.fromEntries(Jn.map((r) => [r, 0]));
  let A = 0;
  const E = Bd.map((r) => {
    const O = Bd.filter((N) => N === r).length, _ = Math.floor(Sf[r] / O) + (v[r]++ < Sf[r] % O ? 1 : 0), Y = {
      stage: r,
      from: A,
      minutes: _
    };
    return A += _, Y;
  });
  return /* @__PURE__ */ f.jsxs($n, { label: "Exemplo de fases do sono: 7 horas e 36 minutos de sono, 22 minutos acordado, das 22:48 às 06:46", children: [
    Jn.map((r, O) => /* @__PURE__ */ f.jsxs("g", { children: [
      /* @__PURE__ */ f.jsx("text", { x: "0", y: 18 + O * 26, children: r }),
      /* @__PURE__ */ f.jsx("line", { className: "rv-grid", x1: "52", x2: "310", y1: 15 + O * 26, y2: 15 + O * 26 })
    ] }, r)),
    E.map((r, O) => {
      const _ = 52 + r.from / 478 * 258, Y = r.minutes / 478 * 258, N = Jn.indexOf(r.stage), M = E[O + 1];
      return /* @__PURE__ */ f.jsxs("g", { className: "rv-segment", style: {
        "--delay": `${O * 35}ms`
      }, children: [
        M && /* @__PURE__ */ f.jsx("line", { x1: _ + Y, x2: _ + Y, y1: 15 + N * 26, y2: 15 + Jn.indexOf(M.stage) * 26, stroke: "#adbca1", opacity: ".4" }),
        /* @__PURE__ */ f.jsx("rect", { x: _, y: 9 + N * 26, width: Y, height: "12", rx: "2", fill: Jh[N] })
      ] }, O);
    }),
    /* @__PURE__ */ f.jsx("text", { x: "52", y: "126", children: "22:48" }),
    /* @__PURE__ */ f.jsx("text", { x: "180", y: "126", textAnchor: "middle", children: "02:47" }),
    /* @__PURE__ */ f.jsx("text", { x: "310", y: "126", textAnchor: "end", children: "06:46" })
  ] });
}
function Wh() {
  return /* @__PURE__ */ f.jsxs($n, { label: "Exemplo de movimento por hora, de 00h a 15h, total de 5.203 passos", children: [
    [25, 65, 105].map((v) => /* @__PURE__ */ f.jsx("line", { className: "rv-grid", x1: "0", x2: "310", y1: v, y2: v }, v)),
    Kh.map((v, A) => /* @__PURE__ */ f.jsx("rect", { className: "rv-bar", style: {
      "--delay": `${A * 35}ms`
    }, x: A * 19.5 + 3, y: 105 - Math.max(2, v / 1080 * 90), width: "11", height: Math.max(2, v / 1080 * 90), rx: "2", fill: "currentColor", opacity: A === 8 ? 1 : v ? 0.65 : 0.15 }, A)),
    /* @__PURE__ */ f.jsx("text", { x: "0", y: "126", children: "00h" }),
    /* @__PURE__ */ f.jsx("text", { x: "118", y: "126", children: "06h" }),
    /* @__PURE__ */ f.jsx("text", { x: "235", y: "126", children: "12h" }),
    /* @__PURE__ */ f.jsx("text", { x: "310", y: "126", textAnchor: "end", children: "15h" })
  ] });
}
function Gd({
  history: v = !1
}) {
  const A = v ? qd : Cd, E = (O) => v ? 101 - (O - 65) * 4 : 101 - (O - 48) * 11, r = A.map((O, _) => `${12 + _ * 47},${E(O)}`).join(" ");
  return /* @__PURE__ */ f.jsxs($n, { label: v ? `Flow demonstrativo dos dias 9 a 15 de setembro: ${qd.join(", ")}` : `FC em repouso demonstrativa dos dias 9 a 15 de setembro: ${Cd.join(", ")} bpm. Referência pessoal de 52 bpm.`, children: [
    [25, 65, 105].map((O) => /* @__PURE__ */ f.jsx("line", { className: "rv-grid", x1: "0", x2: "310", y1: O, y2: O }, O)),
    !v && /* @__PURE__ */ f.jsx("line", { x1: "0", x2: "310", y1: E(52), y2: E(52), stroke: "currentColor", opacity: ".4", strokeDasharray: "3 5" }),
    /* @__PURE__ */ f.jsx("polygon", { className: "rv-area", points: `12,106 ${r} 294,106`, fill: "currentColor", opacity: ".07" }),
    /* @__PURE__ */ f.jsx("polyline", { className: "rv-line", pathLength: "1", points: r, fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinejoin: "round", strokeLinecap: "round" }),
    A.map((O, _) => /* @__PURE__ */ f.jsxs("g", { className: "rv-segment", style: {
      "--delay": `${350 + _ * 90}ms`
    }, children: [
      /* @__PURE__ */ f.jsx("circle", { cx: 12 + _ * 47, cy: E(O), r: _ === 6 ? 4 : 2, fill: _ === 6 ? "#f0f3e9" : "currentColor" }),
      v && /* @__PURE__ */ f.jsx("text", { x: 12 + _ * 47, y: E(O) - 10, textAnchor: "middle", children: O })
    ] }, _)),
    /* @__PURE__ */ f.jsx("text", { x: "3", y: "126", children: "09 set" }),
    /* @__PURE__ */ f.jsx("text", { x: "154", y: "126", textAnchor: "middle", children: "12 set" }),
    /* @__PURE__ */ f.jsx("text", { x: "305", y: "126", textAnchor: "end", children: "15 set" })
  ] });
}
function Fh() {
  return /* @__PURE__ */ f.jsxs($n, { label: "Rheo Flow demonstrativo: 78 de 100. Sono 84, recuperação 71 e equilíbrio da atividade 80.", children: [
    Array.from({
      length: 41
    }, (v, A) => {
      const E = (150 + A * 6) * Math.PI / 180;
      return /* @__PURE__ */ f.jsx("line", { className: "rv-segment", style: {
        "--delay": `${A * 22}ms`
      }, x1: 155 + Math.cos(E) * 83, y1: 78 + Math.sin(E) * 83, x2: 155 + Math.cos(E) * (A % 5 === 0 ? 71 : 76), y2: 78 + Math.sin(E) * (A % 5 === 0 ? 71 : 76), stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", opacity: A / 40 <= 0.78 ? 1 : 0.18 }, A);
    }),
    /* @__PURE__ */ f.jsx("text", { className: "rv-flow-score", x: "155", y: "78", textAnchor: "middle", children: "78" }),
    /* @__PURE__ */ f.jsx("text", { x: "155", y: "98", textAnchor: "middle", children: "EM EQUILÍBRIO" })
  ] });
}
function Ih({
  index: v
}) {
  const A = rl.useRef(null), [E, r] = rl.useState(!1), [O, _] = rl.useState(3);
  rl.useEffect(() => {
    const N = new IntersectionObserver((M) => {
      M.some((S) => S.isIntersecting) && (r(!0), N.disconnect());
    }, {
      threshold: 0.3
    });
    return N.observe(A.current), () => N.disconnect();
  }, []);
  const Y = [/* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    "7",
    /* @__PURE__ */ f.jsx("span", { children: "h" }),
    " 36",
    /* @__PURE__ */ f.jsx("span", { children: "min" })
  ] }), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    "5.203",
    /* @__PURE__ */ f.jsx("span", { children: " passos" })
  ] }), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    "55",
    /* @__PURE__ */ f.jsx("span", { children: " bpm" })
  ] }), /* @__PURE__ */ f.jsx(f.Fragment, { children: "Seu dia, em contexto." }), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    O + 1,
    /* @__PURE__ */ f.jsx("span", { children: " / 5" })
  ] }), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    "7",
    /* @__PURE__ */ f.jsx("span", { children: " dias" })
  ] })];
  return /* @__PURE__ */ f.jsxs("div", { ref: A, className: `rv-visual rv-${v}${E ? " is-visible" : ""}`, style: {
    "--rv-tone": wh[v]
  }, children: [
    /* @__PURE__ */ f.jsxs("div", { className: "rv-readout", children: [
      /* @__PURE__ */ f.jsx("span", { children: $h[v] }),
      /* @__PURE__ */ f.jsx("strong", { children: Y[v] })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "rv-chart", children: [
      v === 0 && /* @__PURE__ */ f.jsx(kh, {}),
      v === 1 && /* @__PURE__ */ f.jsx(Wh, {}),
      v === 2 && /* @__PURE__ */ f.jsx(Gd, {}),
      v === 3 && /* @__PURE__ */ f.jsx(Fh, {}),
      v === 4 && /* @__PURE__ */ f.jsxs("div", { className: "rv-checkin", children: [
        /* @__PURE__ */ f.jsx("div", { className: "rv-moods", role: "group", "aria-label": "Disposição demonstrativa", children: Yd.map(({
          icon: N,
          label: M
        }, S) => /* @__PURE__ */ f.jsx("button", { type: "button", title: M, "aria-label": M, "aria-pressed": O === S, onClick: () => _(S), children: /* @__PURE__ */ f.jsx(N, { size: 23, strokeWidth: 1.3 }) }, M)) }),
        /* @__PURE__ */ f.jsxs("div", { className: "rv-checkin-result", "aria-live": "polite", children: [
          /* @__PURE__ */ f.jsx(Nh, { size: 14 }),
          /* @__PURE__ */ f.jsxs("span", { children: [
            Yd[O].label,
            " ",
            /* @__PURE__ */ f.jsx("span", { children: "· Seu check-in de exemplo" })
          ] })
        ] })
      ] }),
      v === 5 && /* @__PURE__ */ f.jsx(Gd, { history: !0 })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "rv-caption", children: [
      v === 0 && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsxs("span", { children: [
          /* @__PURE__ */ f.jsx("i", { style: {
            background: "#dec1b8"
          } }),
          "REM 1h26"
        ] }),
        /* @__PURE__ */ f.jsxs("span", { children: [
          /* @__PURE__ */ f.jsx("i", { style: {
            background: "#6e8778"
          } }),
          "Profundo 1h36"
        ] })
      ] }),
      v === 1 && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx("span", { children: "65% da meta" }),
        /* @__PURE__ */ f.jsx("span", { children: "Meta de 8.000" })
      ] }),
      v === 2 && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx("span", { children: "+3 bpm da referência" }),
        /* @__PURE__ */ f.jsx("span", { children: "Referência: 52" })
      ] }),
      v === 3 && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx("span", { children: "Sono 84" }),
        /* @__PURE__ */ f.jsx("span", { children: "Recuperação 71" }),
        /* @__PURE__ */ f.jsx("span", { children: "Atividade 80" })
      ] }),
      v === 4 && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx("span", { children: "Percepção pessoal" }),
        /* @__PURE__ */ f.jsx("span", { children: "Não medida pelo anel" })
      ] }),
      v === 5 && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx("span", { children: "Um dia de cada vez." }),
        /* @__PURE__ */ f.jsx("span", { children: "09–15 set" })
      ] })
    ] })
  ] });
}
const Ke = (v) => Math.max(0, Math.min(1, v)), Te = (v, A, E) => Ke((v - A) / (E - A)), zf = (v, A, E) => v + (A - v) * E, Zd = (v) => v * v * (3 - 2 * v), Vd = (v, A, E) => Math.abs(A - v) < 4e-5 ? A : zf(v, A, 1 - Math.exp(-Math.min(E, 64) / 65));
function Ph(v, A, E, r, O = 0) {
  const _ = (1 - Ke(A)) ** 4 * (1 - Te(O, 0, 0.16));
  return {
    ...v,
    x: v.x + E * (r === "silver" ? -0.15 : 0.16) * _,
    y: v.y - (v.y + v.size * 0.85) * _,
    rotate: v.rotate + (r === "silver" ? -14 : 18) * _
  };
}
function l0(v) {
  const A = Zd(Te(v, 0.06, 0.8));
  return {
    rotate: zf(180, 232, A)
  };
}
function Qd(v, A) {
  const E = A.findIndex((Y) => v <= Y.at);
  if (E <= 0) return {
    ...A[E === 0 ? 0 : A.length - 1]
  };
  const r = A[E - 1], O = A[E], _ = Zd(Te(v, r.at, O.at));
  return Object.fromEntries(["x", "y", "size", "rotate", "opacity"].map((Y) => [Y, zf(r[Y], O[Y], _)]));
}
function t0(v, A, E, r) {
  const O = Ke(v), _ = A <= 800, Y = _ ? A * 1.8 : Math.min(A * 0.94, 1550), N = (M, S, Z, U, W = 0, el = 1) => ({
    at: M,
    x: S,
    y: Z,
    size: U,
    rotate: W,
    opacity: el
  });
  return {
    silver: Qd(O, [N(0, A * -0.08, E * -0.14, Y, -22), N(0.16, A * 0.07, E * 0.37, Y * 0.92, -9), N(0.3, A * (_ ? 0.56 : 0.75), E * (_ ? 0.72 : 0.53), Math.min(A * (_ ? 1 : 0.59), E * (_ ? 0.56 : 0.94)), 10), N(0.48, A * (_ ? 0.56 : 0.75), E * (_ ? 0.72 : 0.53), Math.min(A * (_ ? 1 : 0.59), E * (_ ? 0.56 : 0.94)), 10), N(0.58, A * 0.5, E * 0.53, Math.min(A * 0.98, E * 0.88)), N(0.9, r.x, r.y, r.size), N(1, r.x, r.y, r.size)]),
    gold: Qd(O, [N(0, A * 1.02, E * 1.12, _ ? A * 1.65 : A * 0.82, 28), N(0.2, A * 1.2, E * 0.6, A * 0.75, 40, 0.75), N(0.4, A * 1.6, E * 0.15, A * 0.6, 65, 0), N(1, A * 1.6, E * 0.15, A * 0.6, 65, 0)]),
    intro: 1 - Te(O, 0.055, 0.2),
    detail: Te(O, 0.3, 0.34) * (1 - Te(O, 0.44, 0.48)),
    word: Te(O, 0.65, 0.82),
    paper: Te(O, 0.14, 0.3)
  };
}
const _t = (v) => globalThis.rheoRingAsset(`${v}`);
function e0() {
  const v = rl.useRef(null), A = rl.useRef(null), E = rl.useRef(null), r = rl.useRef(null), O = rl.useRef(null), _ = rl.useRef(null), Y = rl.useRef(null);
  return rl.useEffect(() => {
    const N = matchMedia("(prefers-reduced-motion: reduce)");
    let M = null, S = !0, Z = !1, U, W = !0, el = null, Ol = null, bl = null, Sl = 0;
    const pl = A.current, vt = () => {
      const Q = pl.getBoundingClientRect(), yl = v.current.getBoundingClientRect(), ql = O.current.getBoundingClientRect();
      U = {
        top: yl.top + window.scrollY,
        distance: Math.max(1, yl.height - Q.height),
        width: Q.width,
        height: Q.height,
        target: {
          x: ql.left - Q.left + ql.width / 2,
          y: ql.top - Q.top + ql.height / 2,
          size: ql.width / 0.834
        }
      }, W = !1;
    }, El = (Q) => {
      if (M = null, !S || !Z) return;
      W && vt();
      const yl = N.matches ? 0 : Ke((window.scrollY + 56 - U.top) / U.distance), ql = bl === null ? 16 : Q - bl;
      bl = Q, el === null && (el = yl, Ol = Q, (yl > 0.015 || N.matches) && (Sl = 1)), el = N.matches || Math.abs(yl - el) > 0.35 ? yl : Vd(el, yl, ql), N.matches ? Sl = 1 : Sl = Math.max(Sl, Ke((Q - Ol) / 1900));
      const Rt = el, wl = t0(Rt, U.width, U.height, U.target);
      pl.style.setProperty("--progress", Rt.toFixed(5));
      for (const _l of ["intro", "detail", "word", "paper"]) pl.style.setProperty(`--${_l}`, wl[_l].toFixed(5));
      _.current.inert = !N.matches && wl.intro < 0.1, Y.current.inert = N.matches || wl.intro < 0.1;
      for (const [_l, Dt] of [[E.current, "silver"], [r.current, "gold"]]) {
        const $l = Ph(wl[Dt], Sl, U.width, Dt, Rt);
        _l.style.transform = `translate3d(${$l.x - 512}px,${$l.y - 512}px,0) rotate(${$l.rotate}deg) scale(${$l.size / 1024})`, _l.style.opacity = $l.opacity;
      }
      pl.dataset.motionReady = "true", pl.dataset.entered = String(Sl === 1), (Sl < 1 || el !== yl) && Gl();
    }, Gl = () => {
      S && M === null && (M = requestAnimationFrame(El));
    }, Ml = () => {
      W = !0, Gl();
    }, Hl = new ResizeObserver(Ml);
    return Hl.observe(v.current), Hl.observe(A.current), Hl.observe(O.current), window.addEventListener("scroll", Gl, {
      passive: !0
    }), window.addEventListener("resize", Ml), window.addEventListener("pageshow", Ml), N.addEventListener("change", Ml), Promise.all([E.current, r.current].map((Q) => Q.querySelector("img").decode().catch(() => {
    }))).then(() => {
      S && (Z = !0, Ml());
    }), document.fonts.ready.then(() => {
      S && Ml();
    }), () => {
      S = !1, cancelAnimationFrame(M), Hl.disconnect(), window.removeEventListener("scroll", Gl), window.removeEventListener("resize", Ml), window.removeEventListener("pageshow", Ml), N.removeEventListener("change", Ml);
    };
  }, []), /* @__PURE__ */ f.jsx("section", { className: "rx-opening", id: "ring-intro", ref: v, "aria-label": "Conheça o design do Rheo Ring", children: /* @__PURE__ */ f.jsxs("div", { className: "rx-opening-stage", ref: A, children: [
    /* @__PURE__ */ f.jsx("div", { className: "rx-paper" }),
    /* @__PURE__ */ f.jsx("div", { className: "rx-floating-ring rx-ring-silver", ref: E, children: /* @__PURE__ */ f.jsx("img", { src: _t("ring-front-cutout.webp"), alt: "Rheo Ring prata, com acabamento polido e sensores no interior", fetchPriority: "high" }) }),
    /* @__PURE__ */ f.jsx("div", { className: "rx-floating-ring rx-ring-gold", ref: r, children: /* @__PURE__ */ f.jsx("img", { src: _t("ring-gold-cutout.webp"), alt: "Rheo Ring dourado em uma vista de três quartos", fetchPriority: "high" }) }),
    /* @__PURE__ */ f.jsxs("div", { className: "rx-opening-title", ref: _, children: [
      /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: "INTELIGÊNCIA QUE VESTE VOCÊ." }),
      /* @__PURE__ */ f.jsx("h1", { children: "Rheo Ring" }),
      /* @__PURE__ */ f.jsxs("p", { children: [
        "Pequeno no dedo.",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("em", { children: "Presente na vida." })
      ] }),
      /* @__PURE__ */ f.jsxs("a", { className: "rx-light-buy", href: Tu, children: [
        "Comprar agora ",
        /* @__PURE__ */ f.jsx(ju, { size: 16 })
      ] })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "rx-opening-detail", id: "de-dentro", children: [
      /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: "UM OUTRO JEITO DE SE PERCEBER." }),
      /* @__PURE__ */ f.jsxs("h2", { children: [
        "Discreto por fora.",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("em", { children: "Atento a você." })
      ] }),
      /* @__PURE__ */ f.jsxs("p", { children: [
        "Um anel que cabe no seu estilo.",
        /* @__PURE__ */ f.jsx("br", {}),
        "Uma nova perspectiva sobre o seu corpo.",
        /* @__PURE__ */ f.jsx("br", {}),
        "Para levar a vida, não uma tela."
      ] })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "rx-word-scene", children: [
      /* @__PURE__ */ f.jsx("span", { children: "Para viver no seu" }),
      /* @__PURE__ */ f.jsxs("h2", { className: "rx-word", "aria-label": "ritmo", children: [
        /* @__PURE__ */ f.jsx("span", { "aria-hidden": "true", children: "ritm" }),
        /* @__PURE__ */ f.jsx("span", { className: "rx-letter", ref: O, "aria-hidden": "true" })
      ] }),
      /* @__PURE__ */ f.jsxs("p", { children: [
        "Sono. Movimento. Recuperação.",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("span", { children: "Uma nova perspectiva sobre você." })
      ] })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "rx-opening-bottom", ref: Y, children: [
      /* @__PURE__ */ f.jsxs("span", { children: [
        "TECNOLOGIA POR DENTRO.",
        /* @__PURE__ */ f.jsx("br", {}),
        "O SEU ESTILO POR FORA."
      ] }),
      /* @__PURE__ */ f.jsx("a", { href: "#vida", "aria-label": "Continuar para Rheo na sua vida", children: /* @__PURE__ */ f.jsx(_h, { size: 20 }) }),
      /* @__PURE__ */ f.jsxs("span", { children: [
        "PRATA & DOURADO",
        /* @__PURE__ */ f.jsx("br", {}),
        "RHEO RING"
      ] })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "rx-progress", "aria-hidden": "true", children: /* @__PURE__ */ f.jsx("i", {}) })
  ] }) });
}
function a0() {
  const v = rl.useRef(null);
  return rl.useEffect(() => {
    const A = matchMedia("(prefers-reduced-motion: reduce)");
    let E = null;
    const r = () => {
      E = null;
      const _ = v.current.getBoundingClientRect();
      v.current.style.setProperty("--life", A.matches ? 0 : Ke((innerHeight - _.top) / (innerHeight + _.height)));
    }, O = () => {
      E === null && (E = requestAnimationFrame(r));
    };
    return r(), window.addEventListener("scroll", O, {
      passive: !0
    }), window.addEventListener("resize", O), A.addEventListener("change", O), () => {
      cancelAnimationFrame(E), window.removeEventListener("scroll", O), window.removeEventListener("resize", O), A.removeEventListener("change", O);
    };
  }, []), /* @__PURE__ */ f.jsxs("section", { className: "rx-life", id: "vida", ref: v, children: [
    /* @__PURE__ */ f.jsxs("div", { className: "rx-section-heading", children: [
      /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: "FEITO PARA FAZER PARTE." }),
      /* @__PURE__ */ f.jsxs("h2", { children: [
        "O seu próximo movimento.",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("em", { children: "E todos os outros." })
      ] })
    ] }),
    /* @__PURE__ */ f.jsxs("figure", { className: "rx-life-photo", children: [
      /* @__PURE__ */ f.jsx("img", { src: _t("pdp-running-detail.webp"), alt: "Anel dourado na mão de uma mulher com roupa esportiva verde", loading: "lazy" }),
      /* @__PURE__ */ f.jsx("figcaption", { children: "NA SUA PELE. NO SEU DIA." })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "rx-life-caption", children: [
      /* @__PURE__ */ f.jsxs("h3", { children: [
        "Um treino. Uma conversa.",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("em", { children: "Um instante só seu." })
      ] }),
      /* @__PURE__ */ f.jsxs("p", { children: [
        "Saúde não acontece fora da vida. Acontece nela.",
        /* @__PURE__ */ f.jsx("br", {}),
        " Rheo é o convite para prestar atenção ao que o seu corpo tem a dizer, sem deixar de estar presente."
      ] })
    ] })
  ] });
}
function u0() {
  const v = rl.useRef(null), A = rl.useRef(!1), [E, r] = rl.useState(!1), [O, _] = rl.useState(!1);
  rl.useEffect(() => {
    const N = v.current, M = matchMedia("(prefers-reduced-motion: reduce)");
    let S = !1, Z = !0;
    const U = () => {
      S && !M.matches && !document.hidden && !A.current ? N.play().catch(() => {
      }) : N.pause();
    }, W = new IntersectionObserver(([el]) => {
      Z && (S = el.isIntersecting, U());
    }, {
      threshold: 0.3
    });
    return W.observe(N), M.addEventListener("change", U), document.addEventListener("visibilitychange", U), () => {
      Z = !1, W.disconnect(), M.removeEventListener("change", U), document.removeEventListener("visibilitychange", U), N.pause();
    };
  }, []);
  const Y = () => {
    const N = v.current;
    N.paused ? (A.current = !1, N.play().catch(() => _(!0))) : (A.current = !0, N.pause());
  };
  return /* @__PURE__ */ f.jsxs("section", { className: "rx-film", "aria-label": "Rheo Ring em detalhe", children: [
    /* @__PURE__ */ f.jsx("video", { ref: v, src: _t("ring-film.mp4"), poster: _t("silver-hero.webp"), muted: !0, loop: !0, playsInline: !0, preload: "metadata", onPlaying: () => {
      r(!0), _(!1);
    }, onPause: () => r(!1), onError: () => _(!0), "aria-label": "Filme silencioso do Rheo Ring prata em movimento" }),
    /* @__PURE__ */ f.jsxs("div", { className: "rx-film-copy", children: [
      /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: "OLHE MAIS DE PERTO." }),
      /* @__PURE__ */ f.jsxs("h2", { children: [
        "Presença",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("em", { children: "nos detalhes." })
      ] })
    ] }),
    /* @__PURE__ */ f.jsx("span", { className: "rx-film-label", children: "RHEO RING / PRATA" }),
    /* @__PURE__ */ f.jsx("button", { type: "button", className: "rx-film-toggle", onClick: Y, "aria-label": E ? "Pausar filme" : "Reproduzir filme", title: E ? "Pausar filme" : "Reproduzir filme", children: E ? /* @__PURE__ */ f.jsx(Gh, { size: 19 }) : /* @__PURE__ */ f.jsx(Qh, { size: 19 }) }),
    O && /* @__PURE__ */ f.jsx("p", { className: "rx-film-error", role: "status", children: "Não foi possível reproduzir o filme." })
  ] });
}
function n0() {
  const v = rl.useRef(null), A = rl.useRef(null);
  return rl.useEffect(() => {
    const E = matchMedia("(prefers-reduced-motion: reduce)");
    let r = null, O = !0, _ = !1, Y = !0, N, M = null, S = null;
    const Z = (Sl) => {
      if (r = null, !O) return;
      if (Y) {
        const El = v.current.getBoundingClientRect();
        N = {
          top: El.top + window.scrollY,
          distance: innerHeight + El.height,
          viewport: innerHeight
        }, Y = !1;
      }
      const pl = E.matches ? 0 : Ke((window.scrollY + N.viewport - N.top) / N.distance);
      M = M === null || E.matches ? pl : Vd(M, pl, S === null ? 16 : Sl - S), S = Sl;
      const vt = l0(M);
      A.current.style.transform = `rotate(${vt.rotate}deg)`, _ && M !== pl && U();
    }, U = () => {
      O && r === null && (r = requestAnimationFrame(Z));
    }, W = () => {
      _ && U();
    }, el = () => {
      Y = !0, U();
    }, Ol = new IntersectionObserver(([Sl]) => {
      _ = Sl.isIntersecting, _ && (Y = !0, U());
    }), bl = new ResizeObserver(el);
    return Ol.observe(v.current), bl.observe(v.current), window.addEventListener("scroll", W, {
      passive: !0
    }), window.addEventListener("resize", el), E.addEventListener("change", el), U(), () => {
      O = !1, cancelAnimationFrame(r), Ol.disconnect(), bl.disconnect(), window.removeEventListener("scroll", W), window.removeEventListener("resize", el), E.removeEventListener("change", el);
    };
  }, []), /* @__PURE__ */ f.jsxs("section", { className: "rx-battery", id: "autonomia", ref: v, children: [
    /* @__PURE__ */ f.jsxs("div", { className: "rx-battery-copy", children: [
      /* @__PURE__ */ f.jsx(Dh, { size: 30, strokeWidth: 1.3 }),
      /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: "NO RITMO DOS SEUS DIAS." }),
      /* @__PURE__ */ f.jsxs("h2", { children: [
        /* @__PURE__ */ f.jsx("strong", { children: "4–5" }),
        " ",
        /* @__PURE__ */ f.jsx("em", { children: "dias." })
      ] }),
      /* @__PURE__ */ f.jsx("h3", { children: "Menos tomadas. Mais momentos." }),
      /* @__PURE__ */ f.jsxs("p", { children: [
        "Do começo da semana à próxima pausa.",
        /* @__PURE__ */ f.jsx("br", {}),
        "Tempo para viver entre uma carga e outra."
      ] }),
      /* @__PURE__ */ f.jsx("small", { children: "Autonomia estimada por carga. Varia com o uso, o tamanho e as configurações. Sujeita à validação do modelo final." })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "rx-battery-product", children: /* @__PURE__ */ f.jsx("img", { ref: A, className: "rx-battery-ring", src: _t("ring-front-cutout.webp"), width: "1024", height: "1024", alt: "Interior do Rheo Ring prata, ampliado", loading: "lazy", decoding: "async" }) }),
    /* @__PURE__ */ f.jsx("div", { className: "rx-battery-days", "aria-hidden": "true", children: ["SEG", "TER", "QUA", "QUI", "SEX"].map((E, r) => /* @__PURE__ */ f.jsxs("span", { children: [
      /* @__PURE__ */ f.jsx("i", { style: {
        opacity: 1 - r * 0.15
      } }),
      E
    ] }, E)) })
  ] });
}
const Xd = [{
  name: "Sono",
  icon: Yh,
  visual: 0,
  photo: "experience-sleep.webp",
  alt: "Mulher com o anel prata lendo à luz de uma luminária antes de dormir",
  screen: "pdp-app-sleep.webp",
  title: "O amanhã começa à noite.",
  metric: "Enxergue o seu descanso.",
  copy: "Horários, duração e regularidade. Observe como suas noites se conectam ao que você sente durante o dia.",
  app: "Uma noite em perspectiva.",
  detail: "Um resumo claro, com espaço para explorar cada detalhe do seu sono.",
  note: "Fases do sono e métricas são demonstrações. Disponibilidade e qualidade dependem da integração com o modelo final."
}, {
  name: "Atividade",
  icon: Mh,
  visual: 1,
  photo: "sport-life.webp",
  alt: "Pessoa com anel segurando uma raquete em uma quadra de tênis",
  screen: "pdp-app-activity.webp",
  title: "Todo movimento conta.",
  metric: "O dia, passo a passo.",
  copy: "Do caminho até o trabalho ao treino. Acompanhe o movimento e encontre espaço para o que faz você se sentir bem.",
  app: "O seu treino também tem lugar.",
  detail: "Metas, histórico e registro de atividades, organizados no mesmo lugar.",
  note: "Dados ilustrativos. O conceito inclui registro manual de treinos; detecção automática ainda não está confirmada."
}, {
  name: "Recuperação",
  icon: Zh,
  visual: 3,
  photo: "pdp-running-detail.webp",
  alt: "Anel dourado em uma mão junto a roupa esportiva verde",
  screen: "pdp-app-body.webp",
  title: "Pausar também é avançar.",
  metric: "O seu ritmo, com contexto.",
  copy: "A proposta do Rheo Flow é reunir sono, movimento e recuperação em uma leitura mais simples do seu dia.",
  app: "Você é a sua referência.",
  detail: "Observe tendências ao longo do tempo e compare a sua rotina com o seu próprio histórico.",
  note: "Rheo Flow é um conceito em desenvolvimento. VFC e demais sinais dependem dos dados disponibilizados pelo dispositivo."
}, {
  name: "Estresse",
  icon: qh,
  visual: 4,
  photo: "experience-stress.webp",
  alt: "Homem usando o anel prata em uma pausa para respirar no jardim",
  screen: "pdp-app-care.webp",
  title: "Encontre espaço para respirar.",
  metric: "Como você está, de verdade?",
  copy: "Um check-in rápido para registrar sua percepção. Às vezes, começar por essa pergunta já muda a forma de olhar para o dia.",
  app: "Perceba os seus padrões.",
  detail: "Aproxime o que você sente dos seus hábitos e dos momentos de descanso.",
  note: "Aqui, o check-in é informado por você. Não representa uma medição de estresse pelo anel."
}, {
  name: "Rheo Care",
  icon: Bh,
  visual: 5,
  photo: "experience-care.webp",
  alt: "Mulher com o anel prata consultando o celular junto à janela",
  screen: "pdp-app-care.webp",
  title: "Uma conversa com a sua rotina.",
  metric: "Além de um dia isolado.",
  copy: "Uma noite não conta a história inteira. Encontre contexto nas tendências da sua semana e nas pequenas mudanças de hábito.",
  app: "Insights que fazem sentido.",
  detail: "Uma experiência pensada para transformar informações em reflexões úteis para a sua rotina.",
  note: "Prévia conceitual com dados demonstrativos. Os insights não são aconselhamento médico; IA e integração ainda em desenvolvimento."
}];
function i0() {
  const [v, A] = rl.useState(0), E = Xd[v], r = (O, _ = !1) => {
    var Y;
    A(O), _ && ((Y = document.getElementById(`rx-tab-${O}`)) == null || Y.focus());
  };
  return /* @__PURE__ */ f.jsxs("section", { className: "rx-situations", id: "experiencia", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "rx-section-heading", children: [
      /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: "UM NOVO OLHAR SOBRE VOCÊ." }),
      /* @__PURE__ */ f.jsxs("h2", { children: [
        "Para cada parte",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("em", { children: "do seu dia." })
      ] })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "rx-tabs", role: "tablist", "aria-label": "Explore a experiência Rheo", children: Xd.map(({
      name: O,
      icon: _
    }, Y) => /* @__PURE__ */ f.jsxs("button", { id: `rx-tab-${Y}`, type: "button", role: "tab", "aria-selected": v === Y, "aria-controls": "rx-benefit-panel", tabIndex: v === Y ? 0 : -1, onClick: () => r(Y), onKeyDown: (N) => {
      ["ArrowLeft", "ArrowRight", "Home", "End"].includes(N.key) && (N.preventDefault(), r(N.key === "Home" ? 0 : N.key === "End" ? 4 : (v + (N.key === "ArrowRight" ? 1 : 4)) % 5, !0));
    }, children: [
      /* @__PURE__ */ f.jsx(_, { size: 20, strokeWidth: 1.5 }),
      O
    ] }, O)) }),
    /* @__PURE__ */ f.jsxs("div", { id: "rx-benefit-panel", className: "rx-benefit-panel", role: "tabpanel", "aria-labelledby": `rx-tab-${v}`, children: [
      /* @__PURE__ */ f.jsxs("div", { className: "rx-benefit-grid", children: [
        /* @__PURE__ */ f.jsxs("figure", { className: "rx-benefit-photo", children: [
          /* @__PURE__ */ f.jsx("img", { src: _t(E.photo), alt: E.alt, loading: "lazy" }),
          /* @__PURE__ */ f.jsxs("figcaption", { children: [
            /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: E.name.toUpperCase() }),
            /* @__PURE__ */ f.jsx("h3", { children: E.title })
          ] })
        ] }),
        /* @__PURE__ */ f.jsxs("article", { className: "rx-benefit-metric", children: [
          /* @__PURE__ */ f.jsxs("div", { className: "rx-benefit-visual", children: [
            /* @__PURE__ */ f.jsx(Ih, { index: E.visual }),
            /* @__PURE__ */ f.jsx("span", { className: "rx-demo-label", children: "DADOS DE EXEMPLO" })
          ] }),
          /* @__PURE__ */ f.jsx("h3", { children: E.metric }),
          /* @__PURE__ */ f.jsx("p", { children: E.copy })
        ] }),
        /* @__PURE__ */ f.jsxs("article", { className: "rx-benefit-app", children: [
          /* @__PURE__ */ f.jsx("div", { className: "rx-app-preview", children: /* @__PURE__ */ f.jsx("img", { src: _t(E.screen), alt: `Prévia da tela ${E.name} do aplicativo Rheo`, loading: "lazy" }) }),
          /* @__PURE__ */ f.jsx("h3", { children: E.app }),
          /* @__PURE__ */ f.jsx("p", { children: E.detail }),
          /* @__PURE__ */ f.jsxs("a", { href: "/pages/aplicativo", children: [
            "Conheça o aplicativo ",
            /* @__PURE__ */ f.jsx(ju, { size: 15 })
          ] })
        ] })
      ] }, E.name),
      /* @__PURE__ */ f.jsx("p", { className: "rx-note", "aria-live": "polite", children: E.note })
    ] })
  ] });
}
function c0() {
  return /* @__PURE__ */ f.jsxs("section", { className: "rx-care", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "rx-care-copy", children: [
      /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: "RHEO CARE" }),
      /* @__PURE__ */ f.jsxs("h2", { children: [
        "Os números",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("em", { children: "ganham sentido." })
      ] }),
      /* @__PURE__ */ f.jsx("p", { children: "Mais do que acompanhar, começar a perceber. A relação entre uma noite melhor, um treino, uma pausa. E o que tudo isso diz sobre o seu ritmo." }),
      /* @__PURE__ */ f.jsxs("a", { href: "/pages/aplicativo", children: [
        "Entre na experiência Rheo ",
        /* @__PURE__ */ f.jsx(ju, { size: 18 })
      ] }),
      /* @__PURE__ */ f.jsx("small", { children: "Prévia do aplicativo. Dados demonstrativos e recursos em desenvolvimento." })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: "rx-care-phones", children: [
      /* @__PURE__ */ f.jsx("img", { src: _t("pdp-app-today.webp"), alt: "Visão conceitual do dia no aplicativo Rheo", loading: "lazy" }),
      /* @__PURE__ */ f.jsx("img", { src: _t("pdp-app-care.webp"), alt: "Prévia do Rheo Care, com check-ins e tendências", loading: "lazy" })
    ] })
  ] });
}
function f0() {
  return /* @__PURE__ */ f.jsxs("section", { className: "rx-finishes", id: "acabamentos", children: [
    /* @__PURE__ */ f.jsxs("div", { className: "rx-section-heading", children: [
      /* @__PURE__ */ f.jsx("span", { className: "rx-eyebrow", children: "QUAL É O SEU RHEO?" }),
      /* @__PURE__ */ f.jsxs("h2", { children: [
        "Três acabamentos.",
        /* @__PURE__ */ f.jsx("br", {}),
        /* @__PURE__ */ f.jsx("em", { children: "O seu jeito de ser." })
      ] })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: "rx-models", children: [{
      id: "silver",
      name: "Prata",
      copy: "Luz em cada movimento."
    }, {
      id: "gold",
      name: "Dourado",
      copy: "Um toque de calor."
    }, {
      id: "black",
      name: "Preto",
      copy: "Presença, sem excesso."
    }].map((v) => /* @__PURE__ */ f.jsxs("article", { className: "rx-model", children: [
      /* @__PURE__ */ f.jsx("a", { className: "rx-model-image", href: `${Tu}?cor=${v.id}`, "aria-label": `Escolher Rheo Ring ${v.name}`, children: /* @__PURE__ */ f.jsx("img", { src: _t(`${v.id}-hero.webp`), alt: `Rheo Ring ${v.name}`, loading: "lazy" }) }),
      /* @__PURE__ */ f.jsx("h3", { children: v.name }),
      /* @__PURE__ */ f.jsx("p", { children: v.copy }),
      /* @__PURE__ */ f.jsx("span", { className: "rx-model-price", children: "R$ 497,00" }),
      /* @__PURE__ */ f.jsxs("a", { className: "rx-final-buy", href: `${Tu}?cor=${v.id}`, children: [
        "Escolher tamanho ",
        /* @__PURE__ */ f.jsx(Rh, { size: 17 })
      ] })
    ] }, v.id)) }),
    /* @__PURE__ */ f.jsxs("a", { className: "rx-sizing-link", href: "/pages/guia-de-tamanho", children: [
      "Encontre o seu tamanho ",
      /* @__PURE__ */ f.jsx(ju, { size: 16 })
    ] }),
    /* @__PURE__ */ f.jsxs("p", { className: "rx-note", children: [
      "Imagens conceituais. Aparência e especificações sujeitas à conferência com o produto final.",
      /* @__PURE__ */ f.jsx("br", {}),
      "O Rheo Ring não se destina a diagnóstico médico."
    ] })
  ] });
}
function s0() {
  return /* @__PURE__ */ f.jsxs("div", { className: "rx-page", children: [
    /* @__PURE__ */ f.jsxs("nav", { className: "rx-subnav", "aria-label": "Rheo Ring", children: [
      /* @__PURE__ */ f.jsx("a", { href: "#ring-intro", className: "rx-product-name", children: "Rheo Ring" }),
      /* @__PURE__ */ f.jsxs("div", { className: "rx-chapter-links", children: [
        /* @__PURE__ */ f.jsx("a", { href: "#ring-intro", children: "Design" }),
        /* @__PURE__ */ f.jsx("a", { href: "#vida", children: "Na sua vida" }),
        /* @__PURE__ */ f.jsx("a", { href: "#experiencia", children: "Experiência" }),
        /* @__PURE__ */ f.jsx("a", { href: "#acabamentos", children: "Acabamentos" })
      ] }),
      /* @__PURE__ */ f.jsxs("a", { className: "rx-buy", href: Tu, children: [
        "Comprar agora ",
        /* @__PURE__ */ f.jsx(ju, { size: 15 })
      ] })
    ] }),
    /* @__PURE__ */ f.jsx(e0, {}),
    /* @__PURE__ */ f.jsx(a0, {}),
    /* @__PURE__ */ f.jsx(u0, {}),
    /* @__PURE__ */ f.jsx(n0, {}),
    /* @__PURE__ */ f.jsx(i0, {}),
    /* @__PURE__ */ f.jsx(c0, {}),
    /* @__PURE__ */ f.jsx(f0, {})
  ] });
}
const wn = /* @__PURE__ */ new Map();
function Kd(v = document) {
  v.querySelectorAll("[data-rheo-ring-section]").forEach((A) => {
    if (wn.has(A)) return;
    const E = JSON.parse(A.querySelector("[data-rheo-ring-assets]").textContent);
    globalThis.rheoRingAsset = (r) => E[r], wn.set(A, Ah.hydrateRoot(A.querySelector("[data-rheo-ring-content]"), /* @__PURE__ */ f.jsx(s0, {})));
  });
}
Kd();
document.addEventListener("shopify:section:load", (v) => Kd(v.target.parentElement));
document.addEventListener("shopify:section:unload", (v) => {
  v.target.querySelectorAll("[data-rheo-ring-section]").forEach((A) => {
    var E;
    (E = wn.get(A)) == null || E.unmount(), wn.delete(A);
  });
});
